import { ALTARSimpleDomainServiceException as __BaseException } from "../models/ALTARSimpleDomainServiceException";
import { AdvancedListEventData, BadRequestException, BatchOperationInstanceResourceException, ConflictException, DependencyException, ForbiddenException, InternalServerException, NotFoundException, UnauthorizedException, ValidationException, } from "../models/models_0";
import { OCUserOrGroupId, } from "../models/models_1";
import { EntityRepositoryWorkflowEvaluator, EntityWorkflowEvaluator, } from "../models/models_2";
import { HttpRequest as __HttpRequest, } from "@aws-sdk/protocol-http";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectLong as __expectLong, expectNonNull as __expectNonNull, expectNumber as __expectNumber, expectObject as __expectObject, expectString as __expectString, expectUnion as __expectUnion, map as __map, parseEpochTimestamp as __parseEpochTimestamp, throwDefaultError, } from "@aws-sdk/smithy-client";
export const serializeAws_restJson1ActAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/act";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contextType != null && { "contextType": input.contextType }),
        ...(input.workflowContext != null && { "workflowContext": serializeAws_restJson1AdvancedListWorkflowContext(input.workflowContext, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BatchDeleteAdvancedListItemAttachmentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/batchDeleteAttachments";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.keys != null && { "keys": serializeAws_restJson1StringList(input.keys, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BatchUploadAdvancedListItemAttachmentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/batchUploadAttachment";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.sandboxFiles != null && { "sandboxFiles": serializeAws_restJson1SandboxFileKeyFileNameList(input.sandboxFiles, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BuildAdvancedListWorkflowContextCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/buildContext";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowExecution != null && { "workflowExecution": serializeAws_restJson1AdvancedListWorkflowExecution(input.workflowExecution, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateAdvancedListCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/create";
    let body;
    body = JSON.stringify({
        ...(input.addEditorsList != null && { "addEditorsList": serializeAws_restJson1EditorList(input.addEditorsList, context) }),
        ...(input.addFieldDefinitionsList != null && { "addFieldDefinitionsList": serializeAws_restJson1AddFieldDefinitionsList(input.addFieldDefinitionsList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.id != null && { "id": input.id }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateAdvancedListItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item";
    let body;
    body = JSON.stringify({
        ...(input.attachments != null && { "attachments": serializeAws_restJson1SandboxFileKeyFileNameList(input.attachments, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.values != null && { "values": serializeAws_restJson1AdvancedListItemValues(input.values, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateAdvancedListViewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.fieldKeys != null && { "fieldKeys": serializeAws_restJson1StringList(input.fieldKeys, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.sort != null && { "sort": serializeAws_restJson1SortList(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow";
    let body;
    body = JSON.stringify({
        ...(input.actor != null && { "actor": serializeAws_restJson1EntityWorkflowActor(input.actor, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contextType != null && { "contextType": input.contextType }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.disabled != null && { "disabled": input.disabled }),
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1EntityVersionRef(input.entityRef, context) }),
        ...(input.evaluator != null && { "evaluator": serializeAws_restJson1EntityWorkflowEvaluator(input.evaluator, context) }),
        ...(input.executionHistoryDuration != null && { "executionHistoryDuration": serializeAws_restJson1Duration(input.executionHistoryDuration, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.variables != null && { "variables": serializeAws_restJson1VariableList(input.variables, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateAdvancedListWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contextConfig != null && { "contextConfig": serializeAws_restJson1AdvancedListWorkflowContextConfig(input.contextConfig, context) }),
        ...(input.nowTimestamp != null && { "nowTimestamp": Math.round(input.nowTimestamp.getTime() / 1000) }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1EntityExtraVersionRef(input.workflowRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateAdvancedListWorkflowExecutionByItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/createByItem";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.listItemRef != null && { "listItemRef": serializeAws_restJson1EntityExtraVersionRef(input.listItemRef, context) }),
        ...(input.nowTimestamp != null && { "nowTimestamp": Math.round(input.nowTimestamp.getTime() / 1000) }),
        ...(input.workflowContextConfig != null && { "workflowContextConfig": serializeAws_restJson1AdvancedListWorkflowContextConfig(input.workflowContextConfig, context) }),
        ...(input.workflowContextType != null && { "workflowContextType": input.workflowContextType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteAdvancedListCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteAdvancedListItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteAdvancedListViewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1EntityExtraVersionRef(input.workflowRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DownloadAdvancedListItemAttachmentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/downloadAttachment";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1EvaluateAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/evaluate";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contextType != null && { "contextType": input.contextType }),
        ...(input.workflowContext != null && { "workflowContext": serializeAws_restJson1AdvancedListWorkflowContext(input.workflowContext, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexAdvancedListItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexAdvancedListViewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadAdvancedListCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadAdvancedListItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.version != null && { "version": input.version }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadAdvancedListViewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowRefs != null && { "workflowRefs": serializeAws_restJson1EntityExtraVersionRefList(input.workflowRefs, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadAdvancedListWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowExecutionRefs != null && { "workflowExecutionRefs": serializeAws_restJson1EntityExtraVersionRefList(input.workflowExecutionRefs, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PublishAdvancedListEventCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/publishEvent";
    let body;
    body = JSON.stringify({
        ...(input.advancedListRef != null && { "advancedListRef": serializeAws_restJson1EntityRef(input.advancedListRef, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.eventData != null && { "eventData": serializeAws_restJson1AdvancedListEventData(input.eventData, context) }),
        ...(input.eventTimestamp != null && { "eventTimestamp": Math.round(input.eventTimestamp.getTime() / 1000) }),
        ...(input.eventType != null && { "eventType": input.eventType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RunAdvancedListWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/run";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowExecutionRef != null && { "workflowExecutionRef": serializeAws_restJson1EntityExtraVersionRef(input.workflowExecutionRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchAdvancedListItemsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.listEntityId != null && { "listEntityId": input.listEntityId }),
        ...(input.listRepositoryId != null && { "listRepositoryId": input.listRepositoryId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchAdvancedListViewsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.listEntityId != null && { "listEntityId": input.listEntityId }),
        ...(input.listRepositoryId != null && { "listRepositoryId": input.listRepositoryId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchAdvancedListWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow-execution/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnindexAdvancedListItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item/unindex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnindexAdvancedListViewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view/unindex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateAdvancedListCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/update";
    let body;
    body = JSON.stringify({
        ...(input.addEditorsList != null && { "addEditorsList": serializeAws_restJson1EditorList(input.addEditorsList, context) }),
        ...(input.addFieldDefinitionsList != null && { "addFieldDefinitionsList": serializeAws_restJson1AddFieldDefinitionsList(input.addFieldDefinitionsList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.defaultSort != null && { "defaultSort": serializeAws_restJson1Sort(input.defaultSort, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.editorFieldKey != null && { "editorFieldKey": input.editorFieldKey }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.removeEditorsList != null && { "removeEditorsList": serializeAws_restJson1EditorList(input.removeEditorsList, context) }),
        ...(input.reorderFieldDefinitionSequence != null && { "reorderFieldDefinitionSequence": serializeAws_restJson1StringList(input.reorderFieldDefinitionSequence, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.version != null && { "version": input.version }),
        ...(input.viewerFieldKey != null && { "viewerFieldKey": input.viewerFieldKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateAdvancedListItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/item";
    let body;
    body = JSON.stringify({
        ...(input.addOrUpdateValues != null && { "addOrUpdateValues": serializeAws_restJson1AdvancedListItemValues(input.addOrUpdateValues, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.removeValues != null && { "removeValues": serializeAws_restJson1TypicalIdList(input.removeValues, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateAdvancedListViewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/view";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.description != null && { "description": input.description }),
        ...(input.entityExtraId != null && { "entityExtraId": input.entityExtraId }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.fieldKeys != null && { "fieldKeys": serializeAws_restJson1StringList(input.fieldKeys, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.sort != null && { "sort": serializeAws_restJson1SortList(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateAdvancedListWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/advanced-list/workflow";
    let body;
    body = JSON.stringify({
        ...(input.actor != null && { "actor": serializeAws_restJson1EntityWorkflowActor(input.actor, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contextType != null && { "contextType": input.contextType }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.disabled != null && { "disabled": input.disabled }),
        ...(input.evaluator != null && { "evaluator": serializeAws_restJson1EntityWorkflowEvaluator(input.evaluator, context) }),
        ...(input.executionHistoryDuration != null && { "executionHistoryDuration": serializeAws_restJson1Duration(input.executionHistoryDuration, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.newMajorVersion != null && { "newMajorVersion": input.newMajorVersion }),
        ...(input.removeEvaluator != null && { "removeEvaluator": input.removeEvaluator }),
        ...(input.variables != null && { "variables": serializeAws_restJson1VariableList(input.variables, context) }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1EntityExtraVersionRef(input.workflowRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateEntityRelationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/entity-relation";
    let body;
    body = JSON.stringify({
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1EntityRef(input.entityRef, context) }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.relatedEntityRef != null && { "relatedEntityRef": serializeAws_restJson1EntityRef(input.relatedEntityRef, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteEntityRelationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/entity-relation/delete";
    let body;
    body = JSON.stringify({
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetEntityRelationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/entity-relation/load";
    let body;
    body = JSON.stringify({
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexEntityRelationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/entity-relation/index";
    let body;
    body = JSON.stringify({
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchEntityRelationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/entity-relation/search";
    let body;
    body = JSON.stringify({
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateInstanceCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.guidianceLink != null && { "guidianceLink": input.guidianceLink }),
        ...(input.modules != null && { "modules": serializeAws_restJson1ModuleList(input.modules, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ownerRef != null && { "ownerRef": serializeAws_restJson1IdentityRef(input.ownerRef, context) }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateInstanceAllowedTeamCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/allowedTeam";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.roleRef != null && { "roleRef": serializeAws_restJson1InstanceRoleRef(input.roleRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateInstanceAuthzCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/authz";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1EntityVersionRef(input.entityRef, context) }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.resourceIdentifier != null && { "resourceIdentifier": input.resourceIdentifier }),
        ...(input.roleRef != null && { "roleRef": serializeAws_restJson1InstanceRoleRef(input.roleRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateInstanceRoleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/role";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.permissions != null && { "permissions": serializeAws_restJson1EntityRepositoryRolePermissions(input.permissions, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteInstanceAllowedTeamCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/allowedTeam/delete";
    let body;
    body = JSON.stringify({
        ...(input.allowedTeamId != null && { "allowedTeamId": input.allowedTeamId }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteInstanceAuthzCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/authz/delete";
    let body;
    body = JSON.stringify({
        ...(input.authzId != null && { "authzId": input.authzId }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteInstanceRoleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/role/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.roleId != null && { "roleId": input.roleId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteUserItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/userItem/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.itemType != null && { "itemType": input.itemType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GenInstanceSandboxFileGetUrlCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance-sandbox-file/genGetUrl";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.fileKey != null && { "fileKey": input.fileKey }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GenInstanceSandboxFilePutUrlCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance-sandbox-file/genPutUrl";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contentType != null && { "contentType": input.contentType }),
        ...(input.fileName != null && { "fileName": input.fileName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetInstanceCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetInstanceAllowedTeamCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/allowedTeam/get";
    let body;
    body = JSON.stringify({
        ...(input.allowedTeamId != null && { "allowedTeamId": input.allowedTeamId }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetInstanceAuthzCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/authz/get";
    let body;
    body = JSON.stringify({
        ...(input.authzId != null && { "authzId": input.authzId }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetInstanceRoleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/role/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.roleId != null && { "roleId": input.roleId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetUserAllowedTeamsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/getUserAllowedTeams";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetUserItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/userItem/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.itemType != null && { "itemType": input.itemType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetUserRolesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/getUserRoles";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexUserItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/userItem/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.itemType != null && { "itemType": input.itemType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IsAuthorizedCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/isAuthorized";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1EntityRef(input.entityRef, context) }),
        ...(input.identityRef != null && { "identityRef": serializeAws_restJson1IdentityRef(input.identityRef, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.permission != null && { "permission": serializeAws_restJson1EntityRepositoryRolePermissions(input.permission, context) }),
        ...(input.resourceIdentifier != null && { "resourceIdentifier": input.resourceIdentifier }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PutUserItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/userItem";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.itemType != null && { "itemType": input.itemType }),
        ...(input.itemValue != null && { "itemValue": input.itemValue }),
        ...(input.name != null && { "name": input.name }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchInstanceCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchInstanceAllowedTeamCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/allowedTeam/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchInstanceAuthzCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/authz/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchInstanceRoleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/role/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchUserItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/userItem/search";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemType != null && { "itemType": input.itemType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SmartSearchResultFeedbackCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/smartSearchResultFeedback";
    let body;
    body = JSON.stringify({
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.queryId != null && { "queryId": input.queryId }),
        ...(input.resultFeedbackItems != null && { "resultFeedbackItems": serializeAws_restJson1SmartSearchResultRelevanceItems(input.resultFeedbackItems, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnindexUserItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/userItem/unindex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.itemType != null && { "itemType": input.itemType }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateInstanceCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/update";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.guidianceLink != null && { "guidianceLink": input.guidianceLink }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.moduleConfigurations != null && { "moduleConfigurations": serializeAws_restJson1ModuleConfigurationList(input.moduleConfigurations, context) }),
        ...(input.modules != null && { "modules": serializeAws_restJson1ModuleList(input.modules, context) }),
        ...(input.name != null && { "name": input.name }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateInstanceAllowedTeamCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/allowedTeam";
    let body;
    body = JSON.stringify({
        ...(input.allowedTeamId != null && { "allowedTeamId": input.allowedTeamId }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.roleRef != null && { "roleRef": serializeAws_restJson1InstanceRoleRef(input.roleRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateInstanceRoleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/instance/role/update";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.permissions != null && { "permissions": serializeAws_restJson1EntityRepositoryRolePermissions(input.permissions, context) }),
        ...(input.roleId != null && { "roleId": input.roleId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateLabelCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/label";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.id != null && { "id": input.id }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetLabelCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/label/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexLabelCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/label/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchLabelCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/label/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateLabelCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/label";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.description != null && { "description": input.description }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateLocationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/location";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.countryData != null && { "countryData": serializeAws_restJson1CountryData2(input.countryData, context) }),
        ...(input.locationType != null && { "locationType": input.locationType }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.unionData != null && { "unionData": serializeAws_restJson1UnionData2(input.unionData, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetLocationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/location/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexLocationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/Location/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchLocationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/Location/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateLocationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/location";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.countryData != null && { "countryData": serializeAws_restJson1CountryData2(input.countryData, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.unionData != null && { "unionData": serializeAws_restJson1UnionData2(input.unionData, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1ActMatterInstanceWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/act";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowContext != null && { "workflowContext": serializeAws_restJson1MatterInstanceWorkflowContext(input.workflowContext, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AddMatterDraftContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/addDraftContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.answerSandboxFileKey != null && { "answerSandboxFileKey": input.answerSandboxFileKey }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.titleSandboxFileKey != null && { "titleSandboxFileKey": input.titleSandboxFileKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AddMatterQuestionsFromQuestionListCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/addQuestionsFromQuestionList";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKeys != null && { "questionKeys": serializeAws_restJson1StringList(input.questionKeys, context) }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
        ...(input.questionListVersion != null && { "questionListVersion": input.questionListVersion }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AssignMatterDraftContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/assignDraftContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.assignee != null && { "assignee": serializeAws_restJson1IdentityRef(input.assignee, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BatchUpdatePermissionForMatterQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/batchUpdatePermissionForMatterQuestion";
    let body;
    body = JSON.stringify({
        ...(input.accessibleBy != null && { "accessibleBy": serializeAws_restJson1IdentityRef(input.accessibleBy, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.items != null && { "items": serializeAws_restJson1BatchUpdatePermissionForMatterQuestionRequestItemList(input.items, context) }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BuildMatterInstanceWorkflowContextCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/buildContext";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowExecution != null && { "workflowExecution": serializeAws_restJson1MatterInstanceWorkflowExecution(input.workflowExecution, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BulkGetMatterDraftContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/bulkGetDraftContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterEntityVersion != null && { "matterEntityVersion": input.matterEntityVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKeys != null && { "questionKeys": serializeAws_restJson1StringList(input.questionKeys, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BulkGetMatterPublishedContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/bulkGetPublishedContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterEntityVersion != null && { "matterEntityVersion": input.matterEntityVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKeys != null && { "questionKeys": serializeAws_restJson1StringList(input.questionKeys, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CloseMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement/close";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter";
    let body;
    body = JSON.stringify({
        ...(input.backgroundSandboxFileKey != null && { "backgroundSandboxFileKey": input.backgroundSandboxFileKey }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.customDateFields != null && { "customDateFields": serializeAws_restJson1MatterCustomDateFieldList(input.customDateFields, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.locations != null && { "locations": serializeAws_restJson1MatterLocationList(input.locations, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.owner != null && { "owner": serializeAws_restJson1IdentityRef(input.owner, context) }),
        ...(input.refreshDate != null && { "refreshDate": Math.round(input.refreshDate.getTime() / 1000) }),
        ...(input.topics != null && { "topics": serializeAws_restJson1MatterTopicList(input.topics, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterDraftContentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/createDraftContent";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterEntityVersion != null && { "matterEntityVersion": input.matterEntityVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterDraftContentClientFacingFolderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/createClientFacingFolder";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.folderName != null && { "folderName": input.folderName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterDraftContentLegalOnlyFolderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/createLegalOnlyFolder";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.folderName != null && { "folderName": input.folderName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterInstanceWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow";
    let body;
    body = JSON.stringify({
        ...(input.actor != null && { "actor": serializeAws_restJson1EntityRepositoryWorkflowActor(input.actor, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.disabled != null && { "disabled": input.disabled }),
        ...(input.evaluator != null && { "evaluator": serializeAws_restJson1EntityRepositoryWorkflowEvaluator(input.evaluator, context) }),
        ...(input.executionHistoryDuration != null && { "executionHistoryDuration": serializeAws_restJson1Duration(input.executionHistoryDuration, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.triggerType != null && { "triggerType": input.triggerType }),
        ...(input.variables != null && { "variables": serializeAws_restJson1EntityRepositoryWorkflowVariableList(input.variables, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterInstanceWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.nowTimestamp != null && { "nowTimestamp": Math.round(input.nowTimestamp.getTime() / 1000) }),
        ...(input.workflowExecutionCreationContext != null && { "workflowExecutionCreationContext": serializeAws_restJson1MatterWorkflowExecutionCreationContext(input.workflowExecutionCreationContext, context) }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1MatterInstanceWorkflowRef(input.workflowRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterInstanceWorkflowExecutionForMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/createForMatter";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.nowTimestamp != null && { "nowTimestamp": Math.round(input.nowTimestamp.getTime() / 1000) }),
        ...(input.triggeredBy != null && { "triggeredBy": input.triggeredBy }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterOwnerInactiveWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/owner-inactive-workflow";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterRefreshWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/refresh-workflow";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateTemplateFromMatterQuestionsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/createTemplateFromMatterQuestions";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionListName != null && { "questionListName": input.questionListName }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteMatterDraftContentClientFacingFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/deleteClientFacingFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteMatterDraftContentClientFacingFolderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/deleteClientFacingFolder";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteMatterDraftContentLegalOnlyFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/deleteLegalOnlyFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteMatterDraftContentLegalOnlyFolderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/deleteLegalOnlyFolder";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DownloadMatterDraftContentClientFacingFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/downloadClientFacingFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DownloadMatterDraftContentLegalOnlyFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/downloadLegalOnlyFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DownloadMatterPublishedClientFacingFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/downloadPublishedClientFacingFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DownloadMatterPublishedLegalOnlyFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/downloadPublishedLegalOnlyFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1EvaluateMatterInstanceWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/evaluate";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.triggerType != null && { "triggerType": input.triggerType }),
        ...(input.workflowContext != null && { "workflowContext": serializeAws_restJson1MatterInstanceWorkflowContext(input.workflowContext, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterChatLastReadMessageVersionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat/getLastReadMessageVersion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterDraftContentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getDraftContent";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.majorVersion != null && { "majorVersion": input.majorVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.minorVersion != null && { "minorVersion": input.minorVersion }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterDraftContentClientFacingFilesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getClientFacingFiles";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterDraftContentLegalOnlyFilesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getLegalOnlyFiles";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterDraftContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getDraftContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterEntityVersion != null && { "matterEntityVersion": input.matterEntityVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterDraftContentQuestionLegalNoteCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getDraftContentQuestionLegalNote";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.majorVersion != null && { "majorVersion": input.majorVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.minorVersion != null && { "minorVersion": input.minorVersion }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.version != null && { "version": input.version }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedClientFacingFilesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedClientFacingFiles";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedContentHistoryByVersionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedContentHistoryByVersion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.publishedContentVersion != null && { "publishedContentVersion": input.publishedContentVersion }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterEntityVersion != null && { "matterEntityVersion": input.matterEntityVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedContentQuestionByVersionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedContentQuestionByVersion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.publishedContentVersion != null && { "publishedContentVersion": input.publishedContentVersion }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedContentQuestionLegalNote";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterEntityVersion != null && { "matterEntityVersion": input.matterEntityVersion }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteByVersionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getMatterPublishedContentQuestionLegalNoteByVersion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.publishedContentVersion != null && { "publishedContentVersion": input.publishedContentVersion }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterPublishedLegalOnlyFilesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedLegalOnlyFiles";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetPublishedMatterContentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/getPublishedContent";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.version != null && { "version": input.version }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GrantPermissionForHighlyConfidentialMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/grantPermissionForHighlyConfidentialMatter";
    let body;
    body = JSON.stringify({
        ...(input.accessibleByList != null && { "accessibleByList": serializeAws_restJson1IdentityRefList(input.accessibleByList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GrantPermissionToTeamForMatterQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/grantPermissionToTeamForMatterQuestion";
    let body;
    body = JSON.stringify({
        ...(input.accessibleBy != null && { "accessibleBy": serializeAws_restJson1IdentityRef(input.accessibleBy, context) }),
        ...(input.accessibleByList != null && { "accessibleByList": serializeAws_restJson1IdentityRefList(input.accessibleByList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterChatLastReadMessageCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat/indexChatLastReadMessage";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterChatMessageCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.chatRef != null && { "chatRef": serializeAws_restJson1EntityExtraVersionRef(input.chatRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterDraftContentHistoryCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/indexDraftContentHistory";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.draftContentHistory != null && { "draftContentHistory": serializeAws_restJson1MatterDraftContentHistory(input.draftContentHistory, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.version != null && { "version": input.version }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterForSearchNewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/indexNew";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterForSmartSearchCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/indexForSmartSearch";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterPublishedContentHistoryCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/indexPublishedContentHistory";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.publishedContentHistory != null && { "publishedContentHistory": serializeAws_restJson1MatterPublishedContentHistory(input.publishedContentHistory, context) }),
        ...(input.version != null && { "version": input.version }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadMatterInstanceWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowRefs != null && { "workflowRefs": serializeAws_restJson1MatterInstanceWorkflowRefList(input.workflowRefs, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1LoadMatterInstanceWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowExecutionRefs != null && { "workflowExecutionRefs": serializeAws_restJson1MatterInstanceWorkflowExecutionRefList(input.workflowExecutionRefs, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PermissionTeamToClientFacingFilesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/permissionTeamToClientFacingFiles";
    let body;
    body = JSON.stringify({
        ...(input.accessibleBy != null && { "accessibleBy": serializeAws_restJson1IdentityRef(input.accessibleBy, context) }),
        ...(input.accessibleByList != null && { "accessibleByList": serializeAws_restJson1IdentityRefList(input.accessibleByList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PublishMatterDraftContentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/publishDraftContent";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PublishMatterOwnerReassignedDomainEventCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/publishMatterOwnerReassignedDomainEvent";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.oldOwner != null && { "oldOwner": serializeAws_restJson1IdentityRef(input.oldOwner, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PutMatterDraftContentQuestionLegalNoteCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/putDraftContentQuestionLegalNote";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.contentSandboxFileKey != null && { "contentSandboxFileKey": input.contentSandboxFileKey }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1ReassignMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement/reassign";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.newOCFirmId != null && { "newOCFirmId": input.newOCFirmId }),
        ...(input.newOCId != null && { "newOCId": serializeAws_restJson1OCUserOrGroupId(input.newOCId, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1ReassignMatterOwnerCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/reassignOwner";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RemoveMatterDraftContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/removeDraftContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RemoveMatterDraftContentQuestionAssignmentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/removeDraftContentQuestionAssignment";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1ReorderMatterDraftContentQuestionsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/reorderMatterDraftContentQuestions";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKeys != null && { "questionKeys": serializeAws_restJson1StringList(input.questionKeys, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1ReviewMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement/review";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RevokePermissionForHighlyConfidentialMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/revokePermissionForHighlyConfidentialMatter";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.revokeList != null && { "revokeList": serializeAws_restJson1IdentityRefList(input.revokeList, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RevokePermissionFromClientFacingFilesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/revokePermissionFromClientFacingFiles";
    let body;
    body = JSON.stringify({
        ...(input.accessibleByList != null && { "accessibleByList": serializeAws_restJson1IdentityRefList(input.accessibleByList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RevokePermissionFromMatterQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/revokePermissionFromMatterQuestion";
    let body;
    body = JSON.stringify({
        ...(input.accessibleByList != null && { "accessibleByList": serializeAws_restJson1IdentityRefList(input.accessibleByList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1RunMatterInstanceWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/run";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.workflowExecutionRef != null && { "workflowExecutionRef": serializeAws_restJson1MatterInstanceWorkflowExecutionRef(input.workflowExecutionRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterChatLastReadMessageCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat/searchLastReadMessages";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.nestedQueryList != null && { "nestedQueryList": serializeAws_restJson1NestedQueryList(input.nestedQueryList, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterChatMessageCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat/search";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.nestedQueryList != null && { "nestedQueryList": serializeAws_restJson1NestedQueryList(input.nestedQueryList, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.sortDescending != null && { "sortDescending": input.sortDescending }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterDraftContentHistoryCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/searchDraftContentHistory";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterInstanceWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterInstanceWorkflowExecutionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow-execution/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterNewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/searchNew";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.includeSoftDeleted != null && { "includeSoftDeleted": input.includeSoftDeleted }),
        ...(input.nestedQueryList != null && { "nestedQueryList": serializeAws_restJson1NestedQueryList(input.nestedQueryList, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterPublishedContentHistoryCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/searchPublishedContentHistory";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SendMatterChatMessageCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.deleted != null && { "deleted": input.deleted }),
        ...(input.editMessageVersion != null && { "editMessageVersion": input.editMessageVersion }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.messageBody != null && { "messageBody": input.messageBody }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SetMatterHighlyConfidentialCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/setHighlyConfidential";
    let body;
    body = JSON.stringify({
        ...(input.accessibleByList != null && { "accessibleByList": serializeAws_restJson1IdentityRefList(input.accessibleByList, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SmartSearchMatterCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/smartSearch";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1MatterSmartSearchFilter(input.filter, context) }),
        ...(input.includeSoftDeleted != null && { "includeSoftDeleted": input.includeSoftDeleted }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1StartMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocId != null && { "ocId": serializeAws_restJson1OCUserOrGroupId(input.ocId, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SubmitMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement/submit";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnIndexMatterForSearchNewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/unindexNew";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnIndexMatterForSmartSearchCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/UnIndexForSmartSearch";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnsetMatterHighlyConfidentialCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/unsetHighlyConfidential";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterBackgroundCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/updateMatterBackground";
    let body;
    body = JSON.stringify({
        ...(input.backgroundSandboxFileKey != null && { "backgroundSandboxFileKey": input.backgroundSandboxFileKey }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterChatLastReadMessageVersionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/chat/updateLastReadMessageVersion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.lastDismissedMessageVersion != null && { "lastDismissedMessageVersion": input.lastDismissedMessageVersion }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.messageVersion != null && { "messageVersion": input.messageVersion }),
        ...(input.notificationActive != null && { "notificationActive": input.notificationActive }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterDraftContentClientFacingFolderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/updateClientFacingFolder";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.fileKeys != null && { "fileKeys": serializeAws_restJson1StringList(input.fileKeys, context) }),
        ...(input.folderName != null && { "folderName": input.folderName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterDraftContentLegalOnlyFolderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/updateLegalOnlyFolder";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.fileKeys != null && { "fileKeys": serializeAws_restJson1StringList(input.fileKeys, context) }),
        ...(input.folderName != null && { "folderName": input.folderName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.key != null && { "key": input.key }),
        ...(input.matterId != null && { "matterId": input.matterId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterDraftContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/updateDraftContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.answerSandboxFileKey != null && { "answerSandboxFileKey": input.answerSandboxFileKey }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.titleSandboxFileKey != null && { "titleSandboxFileKey": input.titleSandboxFileKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterDraftContentQuestionLabelsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/updateDraftContentQuestionLabels";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.questionLabelMap != null && { "questionLabelMap": serializeAws_restJson1QuestionLabelMap(input.questionLabelMap, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterDraftDetailCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/updateMatterDraftDetail";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.locations != null && { "locations": serializeAws_restJson1MatterLocationList(input.locations, context) }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.owner != null && { "owner": serializeAws_restJson1IdentityRef(input.owner, context) }),
        ...(input.refreshDate != null && { "refreshDate": Math.round(input.refreshDate.getTime() / 1000) }),
        ...(input.removeCustomDateFields != null && { "removeCustomDateFields": serializeAws_restJson1StringList(input.removeCustomDateFields, context) }),
        ...(input.topics != null && { "topics": serializeAws_restJson1MatterTopicList(input.topics, context) }),
        ...(input.updateCustomDateFields != null && { "updateCustomDateFields": serializeAws_restJson1MatterCustomDateFieldList(input.updateCustomDateFields, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterInstanceWorkflowCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/instance-workflow";
    let body;
    body = JSON.stringify({
        ...(input.actor != null && { "actor": serializeAws_restJson1EntityRepositoryWorkflowActor(input.actor, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.disabled != null && { "disabled": input.disabled }),
        ...(input.evaluator != null && { "evaluator": serializeAws_restJson1EntityRepositoryWorkflowEvaluator(input.evaluator, context) }),
        ...(input.executionHistoryDuration != null && { "executionHistoryDuration": serializeAws_restJson1Duration(input.executionHistoryDuration, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.newMajorVersion != null && { "newMajorVersion": input.newMajorVersion }),
        ...(input.removeEvaluator != null && { "removeEvaluator": input.removeEvaluator }),
        ...(input.triggerType != null && { "triggerType": input.triggerType }),
        ...(input.variables != null && { "variables": serializeAws_restJson1EntityRepositoryWorkflowVariableList(input.variables, context) }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1MatterInstanceWorkflowRef(input.workflowRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UploadMatterDraftContentClientFacingFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/uploadClientFacingFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.fileName != null && { "fileName": input.fileName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.sandboxFileKey != null && { "sandboxFileKey": input.sandboxFileKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UploadMatterDraftContentLegalOnlyFileCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/uploadLegalOnlyFile";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.fileName != null && { "fileName": input.fileName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.sandboxFileKey != null && { "sandboxFileKey": input.sandboxFileKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1WorkMatterOCEngagementCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matter/ocEngagement/work";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AddMatterTemplateMatterContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/addMatterContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.questionAnswerSandboxFileKey != null && { "questionAnswerSandboxFileKey": input.questionAnswerSandboxFileKey }),
        ...(input.questionTitleSandboxFileKey != null && { "questionTitleSandboxFileKey": input.questionTitleSandboxFileKey }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BulkGetMatterTemplateMatterContentQuestionsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/bulkGetMatterContentQuestions";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.questionKeys != null && { "questionKeys": serializeAws_restJson1StringList(input.questionKeys, context) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterBackgroundSandboxFileKey != null && { "matterBackgroundSandboxFileKey": input.matterBackgroundSandboxFileKey }),
        ...(input.matterLocations != null && { "matterLocations": serializeAws_restJson1MatterLocationList(input.matterLocations, context) }),
        ...(input.matterName != null && { "matterName": input.matterName }),
        ...(input.matterOwner != null && { "matterOwner": serializeAws_restJson1IdentityRef(input.matterOwner, context) }),
        ...(input.matterQuestionListRef != null && { "matterQuestionListRef": serializeAws_restJson1EntityVersionRef(input.matterQuestionListRef, context) }),
        ...(input.matterTopics != null && { "matterTopics": serializeAws_restJson1MatterTopicList(input.matterTopics, context) }),
        ...(input.name != null && { "name": input.name }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/search";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.includeSoftDeleted != null && { "includeSoftDeleted": input.includeSoftDeleted }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnindexMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/unindex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterTemplateCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/update";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.newDescription != null && { "newDescription": input.newDescription }),
        ...(input.newMatterBackgroundSandboxFileKey != null && { "newMatterBackgroundSandboxFileKey": input.newMatterBackgroundSandboxFileKey }),
        ...(input.newMatterLocations != null && { "newMatterLocations": serializeAws_restJson1MatterLocationList(input.newMatterLocations, context) }),
        ...(input.newMatterName != null && { "newMatterName": input.newMatterName }),
        ...(input.newMatterOwner != null && { "newMatterOwner": serializeAws_restJson1IdentityRef(input.newMatterOwner, context) }),
        ...(input.newMatterQuestionListRef != null && { "newMatterQuestionListRef": serializeAws_restJson1EntityVersionRef(input.newMatterQuestionListRef, context) }),
        ...(input.newMatterTopics != null && { "newMatterTopics": serializeAws_restJson1MatterTopicList(input.newMatterTopics, context) }),
        ...(input.newName != null && { "newName": input.newName }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
        ...(input.resetDescription != null && { "resetDescription": input.resetDescription }),
        ...(input.resetMatterBackgroundSandboxFileKey != null && { "resetMatterBackgroundSandboxFileKey": input.resetMatterBackgroundSandboxFileKey }),
        ...(input.resetMatterLocations != null && { "resetMatterLocations": input.resetMatterLocations }),
        ...(input.resetMatterName != null && { "resetMatterName": input.resetMatterName }),
        ...(input.resetMatterQuestionListRef != null && { "resetMatterQuestionListRef": input.resetMatterQuestionListRef }),
        ...(input.resetMatterTopics != null && { "resetMatterTopics": input.resetMatterTopics }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateMatterTemplateMatterContentQuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/matterTemplate/updateMatterContentQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.questionAnswerSandboxFileKey != null && { "questionAnswerSandboxFileKey": input.questionAnswerSandboxFileKey }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.questionTitleSandboxFileKey != null && { "questionTitleSandboxFileKey": input.questionTitleSandboxFileKey }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterTemplateRef(input.ref, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.firmIdInOCCentral != null && { "firmIdInOCCentral": input.firmIdInOCCentral }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.realm != null && { "realm": input.realm }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateOCFirmGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/group";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.memberRefs != null && { "memberRefs": serializeAws_restJson1FlatEntityExtraRefList(input.memberRefs, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ocFirmRef != null && { "ocFirmRef": serializeAws_restJson1FlatEntityRef(input.ocFirmRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.email != null && { "email": input.email }),
        ...(input.firstName != null && { "firstName": input.firstName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.lastName != null && { "lastName": input.lastName }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocIdInOCCentral != null && { "ocIdInOCCentral": input.ocIdInOCCentral }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetAllOCUserGroupMembershipCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user/getAllGroupMembership";
    let body;
    body = JSON.stringify({
        ...(input.email != null && { "email": input.email }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetOCFirmGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/group/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.ocFirmGroupRef != null && { "ocFirmGroupRef": serializeAws_restJson1FlatEntityExtraRef(input.ocFirmGroupRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocUserId != null && { "ocUserId": input.ocUserId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocUserId != null && { "ocUserId": input.ocUserId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchOCFirmGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/group/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.ocFirmRef != null && { "ocFirmRef": serializeAws_restJson1FlatEntityRef(input.ocFirmRef, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SoftDeleteOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/softDelete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SoftDeleteOCFirmGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/group/softDelete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.ocFirmGroupRef != null && { "ocFirmGroupRef": serializeAws_restJson1FlatEntityExtraRef(input.ocFirmGroupRef, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SoftDeleteOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user/softDelete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocUserId != null && { "ocUserId": input.ocUserId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnIndexOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/unIndex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnIndexOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user/unIndex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocUserId != null && { "ocUserId": input.ocUserId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateOCFirmCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateOCFirmGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/group/update";
    let body;
    body = JSON.stringify({
        ...(input.addMemberRefs != null && { "addMemberRefs": serializeAws_restJson1FlatEntityExtraRefList(input.addMemberRefs, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.newDesc != null && { "newDesc": input.newDesc }),
        ...(input.newName != null && { "newName": input.newName }),
        ...(input.ocFirmGroupRef != null && { "ocFirmGroupRef": serializeAws_restJson1FlatEntityExtraRef(input.ocFirmGroupRef, context) }),
        ...(input.removeMemberRefs != null && { "removeMemberRefs": serializeAws_restJson1FlatEntityExtraRefList(input.removeMemberRefs, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateOCUserCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/ocFirm/user";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.email != null && { "email": input.email }),
        ...(input.firstName != null && { "firstName": input.firstName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.lastName != null && { "lastName": input.lastName }),
        ...(input.ocFirmId != null && { "ocFirmId": input.ocFirmId }),
        ...(input.ocIdInOCCentral != null && { "ocIdInOCCentral": input.ocIdInOCCentral }),
        ...(input.ocUserId != null && { "ocUserId": input.ocUserId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AddQuestionToQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/add-question";
    let body;
    body = JSON.stringify({
        ...(input.answerSandboxFileKey != null && { "answerSandboxFileKey": input.answerSandboxFileKey }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
        ...(input.titleSandboxFileKey != null && { "titleSandboxFileKey": input.titleSandboxFileKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteQuestionsFromQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/delete-questions";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionKeys != null && { "questionKeys": serializeAws_restJson1StringList(input.questionKeys, context) }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetQuestionList2QuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/getQuestion";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateQuestionList2Command = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ocFirmAccessList != null && { "ocFirmAccessList": serializeAws_restJson1StringList(input.ocFirmAccessList, context) }),
        ...(input.questionLabelMap != null && { "questionLabelMap": serializeAws_restJson1QuestionLabelMap(input.questionLabelMap, context) }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
        ...(input.restrictedToOC != null && { "restrictedToOC": input.restrictedToOC }),
        ...(input.sortedQuestionKeys != null && { "sortedQuestionKeys": serializeAws_restJson1StringList(input.sortedQuestionKeys, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateQuestionList2QuestionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/question-list/updateQuestion";
    let body;
    body = JSON.stringify({
        ...(input.answerSandboxFileKey != null && { "answerSandboxFileKey": input.answerSandboxFileKey }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.questionListId != null && { "questionListId": input.questionListId }),
        ...(input.titleSandboxFileKey != null && { "titleSandboxFileKey": input.titleSandboxFileKey }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AnswerRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/answer";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.questionnaireResponses != null && { "questionnaireResponses": serializeAws_restJson1QuestionnaireResponses(input.questionnaireResponses, context) }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1ApproveRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/approve";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AttachFileRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask/attachFile";
    let body;
    body = JSON.stringify({
        ...(input.attachmentType != null && { "attachmentType": input.attachmentType }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.fileName != null && { "fileName": input.fileName }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.sandboxFileKey != null && { "sandboxFileKey": input.sandboxFileKey }),
        ...(input.taskId != null && { "taskId": input.taskId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1BatchGetRapiniQuestionDownloadUrlsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniQuestionTree/batchGetRapiniQuestionDownloadUrls";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionNodeIds != null && { "questionNodeIds": serializeAws_restJson1StringList(input.questionNodeIds, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CommentRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask/comment";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.comment != null && { "comment": input.comment }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.taskId != null && { "taskId": input.taskId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem";
    let body;
    body = JSON.stringify({
        ...(input.additionalContributors != null && { "additionalContributors": serializeAws_restJson1ItemContributorList(input.additionalContributors, context) }),
        ...(input.awsPrivacyLawyer != null && { "awsPrivacyLawyer": serializeAws_restJson1IdentityRef(input.awsPrivacyLawyer, context) }),
        ...(input.businessLineLawyer != null && { "businessLineLawyer": serializeAws_restJson1IdentityRef(input.businessLineLawyer, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.documentationLink != null && { "documentationLink": input.documentationLink }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.productId != null && { "productId": input.productId }),
        ...(input.productManager != null && { "productManager": serializeAws_restJson1IdentityRef(input.productManager, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview";
    let body;
    body = JSON.stringify({
        ...(input.awsPrivacyLawyer != null && { "awsPrivacyLawyer": serializeAws_restJson1IdentityRef(input.awsPrivacyLawyer, context) }),
        ...(input.businessLineLawyer != null && { "businessLineLawyer": serializeAws_restJson1IdentityRef(input.businessLineLawyer, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.productManager != null && { "productManager": serializeAws_restJson1IdentityRef(input.productManager, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask";
    let body;
    body = JSON.stringify({
        ...(input.assignedBy != null && { "assignedBy": serializeAws_restJson1IdentityRef(input.assignedBy, context) }),
        ...(input.assignedTo != null && { "assignedTo": serializeAws_restJson1IdentityRef(input.assignedTo, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.confirmedRequired != null && { "confirmedRequired": input.confirmedRequired }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.optional != null && { "optional": input.optional }),
        ...(input.questionNodeId != null && { "questionNodeId": input.questionNodeId }),
        ...(input.requiresConfirmation != null && { "requiresConfirmation": input.requiresConfirmation }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
        ...(input.taskAction != null && { "taskAction": input.taskAction }),
        ...(input.taskNote != null && { "taskNote": input.taskNote }),
        ...(input.taskRecipientType != null && { "taskRecipientType": input.taskRecipientType }),
        ...(input.type != null && { "type": input.type }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateRapiniQuestionTreeCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniQuestionTree";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.questionNodeSandboxUrlsList != null && { "questionNodeSandboxUrlsList": serializeAws_restJson1RapiniQuestionNodeIdSandboxUrlList(input.questionNodeSandboxUrlsList, context) }),
        ...(input.rootNodeIds != null && { "rootNodeIds": serializeAws_restJson1TypicalIdList(input.rootNodeIds, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateTasksRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/createTasks";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DeleteRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/delete";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1DownloadRapiniAttachmentCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/downloadFile";
    let body;
    body = JSON.stringify({
        ...(input.attachmentVersionRef != null && { "attachmentVersionRef": serializeAws_restJson1EntityExtraVersionRef(input.attachmentVersionRef, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1EditRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/edit";
    let body;
    body = JSON.stringify({
        ...(input.additionalContributors != null && { "additionalContributors": serializeAws_restJson1ItemContributorList(input.additionalContributors, context) }),
        ...(input.awsPrivacyLawyer != null && { "awsPrivacyLawyer": serializeAws_restJson1IdentityRef(input.awsPrivacyLawyer, context) }),
        ...(input.businessLineLawyer != null && { "businessLineLawyer": serializeAws_restJson1IdentityRef(input.businessLineLawyer, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.documentationLink != null && { "documentationLink": input.documentationLink }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.productManager != null && { "productManager": serializeAws_restJson1IdentityRef(input.productManager, context) }),
        ...(input.reviewAwsPrivacyLawyer != null && { "reviewAwsPrivacyLawyer": serializeAws_restJson1IdentityRef(input.reviewAwsPrivacyLawyer, context) }),
        ...(input.reviewBusinessLineLawyer != null && { "reviewBusinessLineLawyer": serializeAws_restJson1IdentityRef(input.reviewBusinessLineLawyer, context) }),
        ...(input.reviewProductManager != null && { "reviewProductManager": serializeAws_restJson1IdentityRef(input.reviewProductManager, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.taskId != null && { "taskId": input.taskId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetRapiniQuestionTreeCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniQuestionTree/get";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.taskId != null && { "taskId": input.taskId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1PublishRapiniEventCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/publishEvent";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.eventData != null && { "eventData": serializeAws_restJson1RapiniEventData(input.eventData, context) }),
        ...(input.eventTimestamp != null && { "eventTimestamp": Math.round(input.eventTimestamp.getTime() / 1000) }),
        ...(input.eventType != null && { "eventType": input.eventType }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SubmitRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview/submit";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UnindexRapiniItemCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItem/unindex";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateRapiniItemReviewCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReview";
    let body;
    body = JSON.stringify({
        ...(input.attachmentDPIARef != null && { "attachmentDPIARef": serializeAws_restJson1RapiniAttachment(input.attachmentDPIARef, context) }),
        ...(input.attachmentROPARef != null && { "attachmentROPARef": serializeAws_restJson1RapiniAttachment(input.attachmentROPARef, context) }),
        ...(input.awsPrivacyLawyer != null && { "awsPrivacyLawyer": serializeAws_restJson1IdentityRef(input.awsPrivacyLawyer, context) }),
        ...(input.businessLineLawyer != null && { "businessLineLawyer": serializeAws_restJson1IdentityRef(input.businessLineLawyer, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.dpiaDocumentRequired != null && { "dpiaDocumentRequired": input.dpiaDocumentRequired }),
        ...(input.dsarsRequired != null && { "dsarsRequired": input.dsarsRequired }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.processCustomerContent != null && { "processCustomerContent": input.processCustomerContent }),
        ...(input.processPrivacyData != null && { "processPrivacyData": input.processPrivacyData }),
        ...(input.productManager != null && { "productManager": serializeAws_restJson1IdentityRef(input.productManager, context) }),
        ...(input.reviewId != null && { "reviewId": input.reviewId }),
        ...(input.ropaDocumentRequired != null && { "ropaDocumentRequired": input.ropaDocumentRequired }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateRapiniItemReviewTaskCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/rapiniItemReviewTask/update";
    let body;
    body = JSON.stringify({
        ...(input.assignedTo != null && { "assignedTo": serializeAws_restJson1IdentityRef(input.assignedTo, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.confirmedRequired != null && { "confirmedRequired": input.confirmedRequired }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.itemId != null && { "itemId": input.itemId }),
        ...(input.optional != null && { "optional": input.optional }),
        ...(input.status != null && { "status": input.status }),
        ...(input.taskAction != null && { "taskAction": input.taskAction }),
        ...(input.taskId != null && { "taskId": input.taskId }),
        ...(input.taskNote != null && { "taskNote": input.taskNote }),
        ...(input.textResponse != null && { "textResponse": input.textResponse }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1AddSubTopicCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/topic/add-subtopic";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1CreateTopicCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/topic";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.description != null && { "description": input.description }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.subtopics != null && { "subtopics": serializeAws_restJson1SubtopicList(input.subtopics, context) }),
        ...(input.topicId != null && { "topicId": input.topicId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1GetTopicCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/topic/load";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1IndexTopicCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/topic/index";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1SearchTopicCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/topic/search";
    let body;
    body = JSON.stringify({
        ...(input.aggregation != null && { "aggregation": serializeAws_restJson1TermsAggregation(input.aggregation, context) }),
        ...(input.filter != null && { "filter": serializeAws_restJson1Query(input.filter, context) }),
        ...(input.pagination != null && { "pagination": serializeAws_restJson1Pagination(input.pagination, context) }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
        ...(input.sort != null && { "sort": serializeAws_restJson1Sort(input.sort, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1UpdateTopicCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/topic";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.description != null && { "description": input.description }),
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.name != null && { "name": input.name }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.subtopics != null && { "subtopics": serializeAws_restJson1SubtopicList(input.subtopics, context) }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const serializeAws_restJson1TrackUserActivityCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        'content-type': 'application/json',
    };
    let resolvedPath = `${basePath?.endsWith('/') ? basePath.slice(0, -1) : (basePath || '')}` + "/v1/track_user_activity";
    let body;
    body = JSON.stringify({
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.module != null && { "module": input.module }),
        ...(input.type != null && { "type": input.type }),
        ...(input.url != null && { "url": input.url }),
    });
    return new __HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
export const deserializeAws_restJson1ActAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ActAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.actorOutput != null) {
        contents.actorOutput = deserializeAws_restJson1Document(data.actorOutput, context);
    }
    if (data.atTimestamp != null) {
        contents.atTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.atTimestamp)));
    }
    return contents;
};
const deserializeAws_restJson1ActAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BatchDeleteAdvancedListItemAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BatchDeleteAdvancedListItemAttachmentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1BatchDeleteAdvancedListItemAttachmentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BatchUploadAdvancedListItemAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BatchUploadAdvancedListItemAttachmentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1BatchUploadAdvancedListItemAttachmentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BuildAdvancedListWorkflowContextCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BuildAdvancedListWorkflowContextCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data._do_not_delete10 != null) {
        contents._do_not_delete10 = __expectString(data._do_not_delete10);
    }
    if (data._do_not_delete11 != null) {
        contents._do_not_delete11 = __expectString(data._do_not_delete11);
    }
    if (data._do_not_delete12 != null) {
        contents._do_not_delete12 = __expectString(data._do_not_delete12);
    }
    if (data._do_not_delete13 != null) {
        contents._do_not_delete13 = __expectString(data._do_not_delete13);
    }
    if (data._do_not_delete14 != null) {
        contents._do_not_delete14 = __expectString(data._do_not_delete14);
    }
    if (data._do_not_delete15 != null) {
        contents._do_not_delete15 = __expectString(data._do_not_delete15);
    }
    if (data._do_not_delete16 != null) {
        contents._do_not_delete16 = deserializeAws_restJson1BasicEntityWorkflowActorOutput_EMAIL(data._do_not_delete16, context);
    }
    if (data._do_not_delete17 != null) {
        contents._do_not_delete17 = __expectString(data._do_not_delete17);
    }
    if (data._do_not_delete18 != null) {
        contents._do_not_delete18 = __expectString(data._do_not_delete18);
    }
    if (data._do_not_delete19 != null) {
        contents._do_not_delete19 = __expectString(data._do_not_delete19);
    }
    if (data._do_not_delete7 != null) {
        contents._do_not_delete7 = __expectString(data._do_not_delete7);
    }
    if (data._do_not_delete8 != null) {
        contents._do_not_delete8 = __expectString(data._do_not_delete8);
    }
    if (data._do_not_delete9 != null) {
        contents._do_not_delete9 = __expectString(data._do_not_delete9);
    }
    if (data.atTimestamp != null) {
        contents.atTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.atTimestamp)));
    }
    if (data.workflowContext != null) {
        contents.workflowContext = deserializeAws_restJson1AdvancedListWorkflowContext(data.workflowContext, context);
    }
    return contents;
};
const deserializeAws_restJson1BuildAdvancedListWorkflowContextCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateAdvancedListCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateAdvancedListCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateAdvancedListCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateAdvancedListItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateAdvancedListItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateAdvancedListItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateAdvancedListViewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateAdvancedListViewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListView(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateAdvancedListViewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityWorkflow(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateAdvancedListWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateAdvancedListWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityWorkflowExecution(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateAdvancedListWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateAdvancedListWorkflowExecutionByItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateAdvancedListWorkflowExecutionByItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1CreateAdvancedListWorkflowExecutionByItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteAdvancedListCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteAdvancedListCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteAdvancedListCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteAdvancedListItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteAdvancedListItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteAdvancedListItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteAdvancedListViewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteAdvancedListViewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteAdvancedListViewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DownloadAdvancedListItemAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DownloadAdvancedListItemAttachmentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1DownloadAdvancedListItemAttachmentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1EvaluateAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1EvaluateAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.atTimestamp != null) {
        contents.atTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.atTimestamp)));
    }
    if (data.result != null) {
        contents.result = __expectBoolean(data.result);
    }
    return contents;
};
const deserializeAws_restJson1EvaluateAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexAdvancedListItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexAdvancedListItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexAdvancedListItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexAdvancedListViewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexAdvancedListViewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexAdvancedListViewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadAdvancedListCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadAdvancedListCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadAdvancedListCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadAdvancedListItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadAdvancedListItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadAdvancedListItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadAdvancedListViewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadAdvancedListViewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListView(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadAdvancedListViewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityWorkflowList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadAdvancedListWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadAdvancedListWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityWorkflowExecutionList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadAdvancedListWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PublishAdvancedListEventCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PublishAdvancedListEventCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1PublishAdvancedListEventCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RunAdvancedListWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RunAdvancedListWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityWorkflowExecution(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1RunAdvancedListWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchAdvancedListItemsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchAdvancedListItemsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1AdvancedListSearchItems(data.items, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchAdvancedListItemsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchAdvancedListViewsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchAdvancedListViewsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1AdvancedListViews(data.items, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchAdvancedListViewsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1EntityWorkflowSearchItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchAdvancedListWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchAdvancedListWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1EntityWorkflowExecutionSearchItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchAdvancedListWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnindexAdvancedListItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnindexAdvancedListItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnindexAdvancedListItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnindexAdvancedListViewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnindexAdvancedListViewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnindexAdvancedListViewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateAdvancedListCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateAdvancedListCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateAdvancedListCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateAdvancedListItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateAdvancedListItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateAdvancedListItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateAdvancedListViewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateAdvancedListViewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1AdvancedListView(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateAdvancedListViewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateAdvancedListWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateAdvancedListWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityWorkflow(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateAdvancedListWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateEntityRelationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateEntityRelationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.data != null) {
        contents.data = deserializeAws_restJson1EntityRelationInfo(data.data, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateEntityRelationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteEntityRelationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteEntityRelationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteEntityRelationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetEntityRelationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetEntityRelationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.data != null) {
        contents.data = deserializeAws_restJson1EntityRelationInfo(data.data, context);
    }
    return contents;
};
const deserializeAws_restJson1GetEntityRelationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexEntityRelationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexEntityRelationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexEntityRelationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchEntityRelationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchEntityRelationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.documents != null) {
        contents.documents = deserializeAws_restJson1EntityRelationInfoList(data.documents, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchEntityRelationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateInstanceCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateInstanceCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityRepositoryInfo(data.body, context);
    }
    if (data.detail != null) {
        contents.detail = deserializeAws_restJson1InstancePayload(data.detail, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateInstanceCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateInstanceAllowedTeamCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateInstanceAllowedTeamCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceAllowedTeamInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateInstanceAllowedTeamCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateInstanceAuthzCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateInstanceAuthzCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceAuthzInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateInstanceAuthzCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateInstanceRoleCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateInstanceRoleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceRoleInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateInstanceRoleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteInstanceAllowedTeamCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteInstanceAllowedTeamCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteInstanceAllowedTeamCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteInstanceAuthzCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteInstanceAuthzCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceAuthzInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1DeleteInstanceAuthzCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteInstanceRoleCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteInstanceRoleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceRoleInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1DeleteInstanceRoleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "BatchOperationInstanceResourceException":
        case "com.amazon.altar.sds.instance#BatchOperationInstanceResourceException":
            throw await deserializeAws_restJson1BatchOperationInstanceResourceExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteUserItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteUserItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1UserItemInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1DeleteUserItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GenInstanceSandboxFileGetUrlCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GenInstanceSandboxFileGetUrlCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.fileKey != null) {
        contents.fileKey = __expectString(data.fileKey);
    }
    if (data.url != null) {
        contents.url = __expectString(data.url);
    }
    return contents;
};
const deserializeAws_restJson1GenInstanceSandboxFileGetUrlCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GenInstanceSandboxFilePutUrlCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GenInstanceSandboxFilePutUrlCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.fileKey != null) {
        contents.fileKey = __expectString(data.fileKey);
    }
    if (data.url != null) {
        contents.url = __expectString(data.url);
    }
    return contents;
};
const deserializeAws_restJson1GenInstanceSandboxFilePutUrlCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetInstanceCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetInstanceCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityRepositoryInfo(data.body, context);
    }
    if (data.detail != null) {
        contents.detail = deserializeAws_restJson1InstancePayload(data.detail, context);
    }
    return contents;
};
const deserializeAws_restJson1GetInstanceCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetInstanceAllowedTeamCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetInstanceAllowedTeamCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceAllowedTeamInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetInstanceAllowedTeamCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetInstanceAuthzCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetInstanceAuthzCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceAuthzInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetInstanceAuthzCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetInstanceRoleCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetInstanceRoleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceRoleInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetInstanceRoleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetUserAllowedTeamsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetUserAllowedTeamsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.allowedTeams != null) {
        contents.allowedTeams = deserializeAws_restJson1InstanceAllowedTeamInfoList(data.allowedTeams, context);
    }
    return contents;
};
const deserializeAws_restJson1GetUserAllowedTeamsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetUserItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetUserItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1UserItemInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetUserItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetUserRolesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetUserRolesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.roles != null) {
        contents.roles = deserializeAws_restJson1InstanceRoleInfoList(data.roles, context);
    }
    return contents;
};
const deserializeAws_restJson1GetUserRolesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexUserItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexUserItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexUserItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IsAuthorizedCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IsAuthorizedCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.result != null) {
        contents.result = __expectBoolean(data.result);
    }
    return contents;
};
const deserializeAws_restJson1IsAuthorizedCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PutUserItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutUserItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1UserItemInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1PutUserItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchInstanceCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchInstanceCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1EntityRepositoryInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchInstanceCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchInstanceAllowedTeamCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchInstanceAllowedTeamCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1InstanceAllowedTeamInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchInstanceAllowedTeamCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchInstanceAuthzCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchInstanceAuthzCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1InstanceAuthzInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchInstanceAuthzCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchInstanceRoleCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchInstanceRoleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1InstanceRoleInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchInstanceRoleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchUserItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchUserItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1UserItemInfoList(data.items, context);
    }
    return contents;
};
const deserializeAws_restJson1SearchUserItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SmartSearchResultFeedbackCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SmartSearchResultFeedbackCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1SmartSearchResultFeedbackCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnindexUserItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnindexUserItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnindexUserItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateInstanceCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateInstanceCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1EntityRepositoryInfo(data.body, context);
    }
    if (data.detail != null) {
        contents.detail = deserializeAws_restJson1InstancePayload(data.detail, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateInstanceCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateInstanceAllowedTeamCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateInstanceAllowedTeamCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceAllowedTeamInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateInstanceAllowedTeamCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateInstanceRoleCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateInstanceRoleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1InstanceRoleInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateInstanceRoleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateLabelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateLabelCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1LabelInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateLabelCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetLabelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetLabelCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1LabelInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetLabelCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexLabelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexLabelCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexLabelCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchLabelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchLabelCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1LabelInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchLabelCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateLabelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateLabelCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1LabelInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateLabelCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateLocationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateLocationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.location != null) {
        contents.location = deserializeAws_restJson1LocationData(data.location, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateLocationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetLocationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetLocationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1LocationData(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetLocationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexLocationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexLocationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexLocationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchLocationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchLocationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1LocationList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchLocationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateLocationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateLocationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.updated != null) {
        contents.updated = deserializeAws_restJson1LocationData(data.updated, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateLocationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1ActMatterInstanceWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ActMatterInstanceWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.actorOutput != null) {
        contents.actorOutput = deserializeAws_restJson1Document(data.actorOutput, context);
    }
    if (data.atTimestamp != null) {
        contents.atTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.atTimestamp)));
    }
    return contents;
};
const deserializeAws_restJson1ActMatterInstanceWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AddMatterDraftContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AddMatterDraftContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterQuestion(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1AddMatterDraftContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AddMatterQuestionsFromQuestionListCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AddMatterQuestionsFromQuestionListCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterQuestions(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1AddMatterQuestionsFromQuestionListCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AssignMatterDraftContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AssignMatterDraftContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.content != null) {
        contents.content = deserializeAws_restJson1Matter(data.content, context);
    }
    return contents;
};
const deserializeAws_restJson1AssignMatterDraftContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BatchUpdatePermissionForMatterQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BatchUpdatePermissionForMatterQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.content != null) {
        contents.content = deserializeAws_restJson1Matter(data.content, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    if (data.questionAccessMap != null) {
        contents.questionAccessMap = deserializeAws_restJson1QuestionAccessMap(data.questionAccessMap, context);
    }
    return contents;
};
const deserializeAws_restJson1BatchUpdatePermissionForMatterQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BuildMatterInstanceWorkflowContextCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BuildMatterInstanceWorkflowContextCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data._do_not_delete10 != null) {
        contents._do_not_delete10 = __expectString(data._do_not_delete10);
    }
    if (data._do_not_delete11 != null) {
        contents._do_not_delete11 = __expectString(data._do_not_delete11);
    }
    if (data._do_not_delete12 != null) {
        contents._do_not_delete12 = __expectString(data._do_not_delete12);
    }
    if (data._do_not_delete13 != null) {
        contents._do_not_delete13 = __expectString(data._do_not_delete13);
    }
    if (data._do_not_delete14 != null) {
        contents._do_not_delete14 = __expectString(data._do_not_delete14);
    }
    if (data._do_not_delete15 != null) {
        contents._do_not_delete15 = __expectString(data._do_not_delete15);
    }
    if (data._do_not_delete16 != null) {
        contents._do_not_delete16 = deserializeAws_restJson1BasicEntityRepositoryWorkflowActorOutput_EMAIL(data._do_not_delete16, context);
    }
    if (data._do_not_delete17 != null) {
        contents._do_not_delete17 = __expectString(data._do_not_delete17);
    }
    if (data._do_not_delete18 != null) {
        contents._do_not_delete18 = __expectString(data._do_not_delete18);
    }
    if (data._do_not_delete7 != null) {
        contents._do_not_delete7 = __expectString(data._do_not_delete7);
    }
    if (data._do_not_delete8 != null) {
        contents._do_not_delete8 = __expectString(data._do_not_delete8);
    }
    if (data._do_not_delete9 != null) {
        contents._do_not_delete9 = __expectString(data._do_not_delete9);
    }
    if (data.atTimestamp != null) {
        contents.atTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.atTimestamp)));
    }
    if (data.workflowContext != null) {
        contents.workflowContext = deserializeAws_restJson1MatterInstanceWorkflowContext(data.workflowContext, context);
    }
    return contents;
};
const deserializeAws_restJson1BuildMatterInstanceWorkflowContextCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BulkGetMatterDraftContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BulkGetMatterDraftContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.questionDownloadUrls != null) {
        contents.questionDownloadUrls = deserializeAws_restJson1QuestionDownloadUrls(data.questionDownloadUrls, context);
    }
    return contents;
};
const deserializeAws_restJson1BulkGetMatterDraftContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BulkGetMatterPublishedContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BulkGetMatterPublishedContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.questionDownloadUrls != null) {
        contents.questionDownloadUrls = deserializeAws_restJson1QuestionDownloadUrls(data.questionDownloadUrls, context);
    }
    return contents;
};
const deserializeAws_restJson1BulkGetMatterPublishedContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CloseMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CloseMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CloseMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matter != null) {
        contents.matter = deserializeAws_restJson1Matter(data.matter, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterDraftContentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterDraftContentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1Matter(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterDraftContentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterDraftContentClientFacingFolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterDraftContentClientFacingFolderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterFolder != null) {
        contents.matterFolder = deserializeAws_restJson1MatterFolder(data.matterFolder, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterDraftContentClientFacingFolderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterDraftContentLegalOnlyFolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterDraftContentLegalOnlyFolderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterFolder != null) {
        contents.matterFolder = deserializeAws_restJson1MatterFolder(data.matterFolder, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterDraftContentLegalOnlyFolderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterInstanceWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterInstanceWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflow(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterInstanceWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterInstanceWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterInstanceWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflowExecution(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterInstanceWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterInstanceWorkflowExecutionForMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterInstanceWorkflowExecutionForMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflowExecutionList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterInstanceWorkflowExecutionForMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterOwnerInactiveWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterOwnerInactiveWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflow(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterOwnerInactiveWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterRefreshWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterRefreshWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflow(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterRefreshWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateTemplateFromMatterQuestionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateTemplateFromMatterQuestionsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.questionListId != null) {
        contents.questionListId = __expectString(data.questionListId);
    }
    if (data.questionListName != null) {
        contents.questionListName = __expectString(data.questionListName);
    }
    return contents;
};
const deserializeAws_restJson1CreateTemplateFromMatterQuestionsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.by != null) {
        contents.by = deserializeAws_restJson1IdentityRef(data.by, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1DeleteMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteMatterDraftContentClientFacingFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteMatterDraftContentClientFacingFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterFile != null) {
        contents.matterFile = deserializeAws_restJson1MatterFile(data.matterFile, context);
    }
    return contents;
};
const deserializeAws_restJson1DeleteMatterDraftContentClientFacingFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteMatterDraftContentClientFacingFolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteMatterDraftContentClientFacingFolderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteMatterDraftContentClientFacingFolderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteMatterDraftContentLegalOnlyFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteMatterDraftContentLegalOnlyFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterFile != null) {
        contents.matterFile = deserializeAws_restJson1MatterFile(data.matterFile, context);
    }
    return contents;
};
const deserializeAws_restJson1DeleteMatterDraftContentLegalOnlyFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteMatterDraftContentLegalOnlyFolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteMatterDraftContentLegalOnlyFolderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteMatterDraftContentLegalOnlyFolderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DownloadMatterDraftContentClientFacingFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DownloadMatterDraftContentClientFacingFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1DownloadMatterDraftContentClientFacingFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DownloadMatterDraftContentLegalOnlyFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DownloadMatterDraftContentLegalOnlyFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1DownloadMatterDraftContentLegalOnlyFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DownloadMatterPublishedClientFacingFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DownloadMatterPublishedClientFacingFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1DownloadMatterPublishedClientFacingFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DownloadMatterPublishedLegalOnlyFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DownloadMatterPublishedLegalOnlyFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1DownloadMatterPublishedLegalOnlyFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1EvaluateMatterInstanceWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1EvaluateMatterInstanceWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.atTimestamp != null) {
        contents.atTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.atTimestamp)));
    }
    if (data.result != null) {
        contents.result = __expectBoolean(data.result);
    }
    return contents;
};
const deserializeAws_restJson1EvaluateMatterInstanceWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matter != null) {
        contents.matter = deserializeAws_restJson1Matter(data.matter, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterChatLastReadMessageVersionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterChatLastReadMessageVersionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterChatLastReadMessageItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterChatLastReadMessageVersionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterDraftContentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterDraftContentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterContent != null) {
        contents.matterContent = deserializeAws_restJson1MatterDraftContent(data.matterContent, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterDraftContentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterDraftContentClientFacingFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterDraftContentClientFacingFilesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterDraftContentFileInfoList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterDraftContentClientFacingFilesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterDraftContentLegalOnlyFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterDraftContentLegalOnlyFilesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterDraftContentFileInfoList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterDraftContentLegalOnlyFilesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterDraftContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterDraftContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.answerDownloadUrl != null) {
        contents.answerDownloadUrl = __expectString(data.answerDownloadUrl);
    }
    if (data.titleDownloadUrl != null) {
        contents.titleDownloadUrl = __expectString(data.titleDownloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterDraftContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterDraftContentQuestionLegalNoteCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterDraftContentQuestionLegalNoteCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    if (data.lastUpdatedBy != null) {
        contents.lastUpdatedBy = deserializeAws_restJson1IdentityRef(data.lastUpdatedBy, context);
    }
    if (data.lastUpdatedTimestamp != null) {
        contents.lastUpdatedTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastUpdatedTimestamp)));
    }
    return contents;
};
const deserializeAws_restJson1GetMatterDraftContentQuestionLegalNoteCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedClientFacingFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedClientFacingFilesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterDraftContentFileInfoList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedClientFacingFilesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedContentHistoryByVersionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedContentHistoryByVersionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matter != null) {
        contents.matter = deserializeAws_restJson1Matter(data.matter, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedContentHistoryByVersionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.answerDownloadUrl != null) {
        contents.answerDownloadUrl = __expectString(data.answerDownloadUrl);
    }
    if (data.titleDownloadUrl != null) {
        contents.titleDownloadUrl = __expectString(data.titleDownloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedContentQuestionByVersionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedContentQuestionByVersionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.answerDownloadUrl != null) {
        contents.answerDownloadUrl = __expectString(data.answerDownloadUrl);
    }
    if (data.titleDownloadUrl != null) {
        contents.titleDownloadUrl = __expectString(data.titleDownloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedContentQuestionByVersionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    if (data.lastUpdatedBy != null) {
        contents.lastUpdatedBy = deserializeAws_restJson1IdentityRef(data.lastUpdatedBy, context);
    }
    if (data.lastUpdatedTimestamp != null) {
        contents.lastUpdatedTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastUpdatedTimestamp)));
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteByVersionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteByVersionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    if (data.lastUpdatedBy != null) {
        contents.lastUpdatedBy = deserializeAws_restJson1IdentityRef(data.lastUpdatedBy, context);
    }
    if (data.lastUpdatedTimestamp != null) {
        contents.lastUpdatedTimestamp = __expectNonNull(__parseEpochTimestamp(__expectNumber(data.lastUpdatedTimestamp)));
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedContentQuestionLegalNoteByVersionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterPublishedLegalOnlyFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterPublishedLegalOnlyFilesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterDraftContentFileInfoList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterPublishedLegalOnlyFilesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetPublishedMatterContentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetPublishedMatterContentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.content != null) {
        contents.content = deserializeAws_restJson1MatterPublishedContent(data.content, context);
    }
    return contents;
};
const deserializeAws_restJson1GetPublishedMatterContentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GrantPermissionForHighlyConfidentialMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GrantPermissionForHighlyConfidentialMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.highlyConfidentialAccessList != null) {
        contents.highlyConfidentialAccessList = deserializeAws_restJson1AccessRecordList(data.highlyConfidentialAccessList, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1GrantPermissionForHighlyConfidentialMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GrantPermissionToTeamForMatterQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GrantPermissionToTeamForMatterQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.content != null) {
        contents.content = deserializeAws_restJson1Matter(data.content, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    if (data.questionAccessMap != null) {
        contents.questionAccessMap = deserializeAws_restJson1QuestionAccessMap(data.questionAccessMap, context);
    }
    return contents;
};
const deserializeAws_restJson1GrantPermissionToTeamForMatterQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterChatLastReadMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterChatLastReadMessageCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterChatLastReadMessageCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterChatMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterChatMessageCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterChatMessageCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterDraftContentHistoryCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterDraftContentHistoryCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterDraftContentHistoryCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterForSearchNewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterForSearchNewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterForSearchNewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterForSmartSearchCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterForSmartSearchCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterForSmartSearchCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterPublishedContentHistoryCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterPublishedContentHistoryCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterPublishedContentHistoryCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadMatterInstanceWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadMatterInstanceWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflowList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadMatterInstanceWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1LoadMatterInstanceWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1LoadMatterInstanceWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflowExecutionList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1LoadMatterInstanceWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PermissionTeamToClientFacingFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PermissionTeamToClientFacingFilesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.clientFileAccessList != null) {
        contents.clientFileAccessList = deserializeAws_restJson1AccessRecordList(data.clientFileAccessList, context);
    }
    if (data.content != null) {
        contents.content = deserializeAws_restJson1Matter(data.content, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1PermissionTeamToClientFacingFilesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PublishMatterDraftContentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PublishMatterDraftContentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matter != null) {
        contents.matter = deserializeAws_restJson1Matter(data.matter, context);
    }
    return contents;
};
const deserializeAws_restJson1PublishMatterDraftContentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PublishMatterOwnerReassignedDomainEventCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PublishMatterOwnerReassignedDomainEventCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.eventReceipt != null) {
        contents.eventReceipt = __expectString(data.eventReceipt);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1PublishMatterOwnerReassignedDomainEventCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PutMatterDraftContentQuestionLegalNoteCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutMatterDraftContentQuestionLegalNoteCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionLegalNote(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1PutMatterDraftContentQuestionLegalNoteCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1ReassignMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ReassignMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1ReassignMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1ReassignMatterOwnerCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ReassignMatterOwnerCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    if (data.newOwner != null) {
        contents.newOwner = deserializeAws_restJson1IdentityRef(data.newOwner, context);
    }
    return contents;
};
const deserializeAws_restJson1ReassignMatterOwnerCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RemoveMatterDraftContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RemoveMatterDraftContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterQuestion(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1RemoveMatterDraftContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RemoveMatterDraftContentQuestionAssignmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RemoveMatterDraftContentQuestionAssignmentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    if (data.questionAssignments != null) {
        contents.questionAssignments = deserializeAws_restJson1QuestionAssignmentList(data.questionAssignments, context);
    }
    return contents;
};
const deserializeAws_restJson1RemoveMatterDraftContentQuestionAssignmentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1ReorderMatterDraftContentQuestionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ReorderMatterDraftContentQuestionsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1StringList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1ReorderMatterDraftContentQuestionsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1ReviewMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ReviewMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1ReviewMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RevokePermissionForHighlyConfidentialMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RevokePermissionForHighlyConfidentialMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.highlyConfidentialAccessList != null) {
        contents.highlyConfidentialAccessList = deserializeAws_restJson1AccessRecordList(data.highlyConfidentialAccessList, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1RevokePermissionForHighlyConfidentialMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RevokePermissionFromClientFacingFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RevokePermissionFromClientFacingFilesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.clientFileAccessList != null) {
        contents.clientFileAccessList = deserializeAws_restJson1AccessRecordList(data.clientFileAccessList, context);
    }
    if (data.content != null) {
        contents.content = deserializeAws_restJson1Matter(data.content, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1RevokePermissionFromClientFacingFilesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RevokePermissionFromMatterQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RevokePermissionFromMatterQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.content != null) {
        contents.content = deserializeAws_restJson1Matter(data.content, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    if (data.questionAccessMap != null) {
        contents.questionAccessMap = deserializeAws_restJson1QuestionAccessMap(data.questionAccessMap, context);
    }
    return contents;
};
const deserializeAws_restJson1RevokePermissionFromMatterQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1RunMatterInstanceWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RunMatterInstanceWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflowExecution(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1RunMatterInstanceWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterChatLastReadMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterChatLastReadMessageCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterChatLastReadMessageItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterChatLastReadMessageCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterChatMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterChatMessageCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterChatMessageSearchItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterChatMessageCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterDraftContentHistoryCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterDraftContentHistoryCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterDraftContentHistoryList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterDraftContentHistoryCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterInstanceWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterInstanceWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterInstanceWorkflowList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterInstanceWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterInstanceWorkflowExecutionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterInstanceWorkflowExecutionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterInstanceWorkflowExecutionList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterInstanceWorkflowExecutionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterNewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterNewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterSearchItemNewList(data.items, context);
    }
    if (data.nestedQueryList != null) {
        contents.nestedQueryList = deserializeAws_restJson1NestedQueryList(data.nestedQueryList, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterNewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterPublishedContentHistoryCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterPublishedContentHistoryCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterPublishedContentHistoryList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterPublishedContentHistoryCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SendMatterChatMessageCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SendMatterChatMessageCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterChatMessage(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1SendMatterChatMessageCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SetMatterHighlyConfidentialCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SetMatterHighlyConfidentialCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.highlyConfidential != null) {
        contents.highlyConfidential = __expectBoolean(data.highlyConfidential);
    }
    if (data.highlyConfidentialAccessList != null) {
        contents.highlyConfidentialAccessList = deserializeAws_restJson1AccessRecordList(data.highlyConfidentialAccessList, context);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1SetMatterHighlyConfidentialCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SmartSearchMatterCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SmartSearchMatterCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterSmartSearchResultItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.queryId != null) {
        contents.queryId = __expectString(data.queryId);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SmartSearchMatterCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1StartMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1StartMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1StartMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SubmitMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SubmitMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1SubmitMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnIndexMatterForSearchNewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnIndexMatterForSearchNewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnIndexMatterForSearchNewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnIndexMatterForSmartSearchCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnIndexMatterForSmartSearchCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnIndexMatterForSmartSearchCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnsetMatterHighlyConfidentialCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnsetMatterHighlyConfidentialCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.highlyConfidential != null) {
        contents.highlyConfidential = __expectBoolean(data.highlyConfidential);
    }
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    return contents;
};
const deserializeAws_restJson1UnsetMatterHighlyConfidentialCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterBackgroundCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterBackgroundCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.backgroundDownloadUrl != null) {
        contents.backgroundDownloadUrl = __expectString(data.backgroundDownloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterBackgroundCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterChatLastReadMessageVersionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterChatLastReadMessageVersionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterChatLastReadMessageItem(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterChatLastReadMessageVersionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterDraftContentClientFacingFolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterDraftContentClientFacingFolderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterFolder != null) {
        contents.matterFolder = deserializeAws_restJson1MatterFolder(data.matterFolder, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterDraftContentClientFacingFolderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterDraftContentLegalOnlyFolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterDraftContentLegalOnlyFolderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterFolder != null) {
        contents.matterFolder = deserializeAws_restJson1MatterFolder(data.matterFolder, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterDraftContentLegalOnlyFolderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterDraftContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterDraftContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterQuestion(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterDraftContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterDraftContentQuestionLabelsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterDraftContentQuestionLabelsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.instanceId != null) {
        contents.instanceId = __expectString(data.instanceId);
    }
    if (data.matterId != null) {
        contents.matterId = __expectString(data.matterId);
    }
    if (data.questionLabelMap != null) {
        contents.questionLabelMap = deserializeAws_restJson1QuestionLabelMap(data.questionLabelMap, context);
    }
    if (data.questions != null) {
        contents.questions = deserializeAws_restJson1MatterQuestions(data.questions, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterDraftContentQuestionLabelsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterDraftDetailCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterDraftDetailCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matter != null) {
        contents.matter = deserializeAws_restJson1Matter(data.matter, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterDraftDetailCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterInstanceWorkflowCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterInstanceWorkflowCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterInstanceWorkflow(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterInstanceWorkflowCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UploadMatterDraftContentClientFacingFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UploadMatterDraftContentClientFacingFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterDraftContentFileInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UploadMatterDraftContentClientFacingFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UploadMatterDraftContentLegalOnlyFileCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UploadMatterDraftContentLegalOnlyFileCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterDraftContentFileInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UploadMatterDraftContentLegalOnlyFileCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1WorkMatterOCEngagementCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1WorkMatterOCEngagementCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1MatterOCEngagement(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1WorkMatterOCEngagementCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AddMatterTemplateMatterContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AddMatterTemplateMatterContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterContentQuestion != null) {
        contents.matterContentQuestion = deserializeAws_restJson1MatterQuestion(data.matterContentQuestion, context);
    }
    return contents;
};
const deserializeAws_restJson1AddMatterTemplateMatterContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BulkGetMatterTemplateMatterContentQuestionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BulkGetMatterTemplateMatterContentQuestionsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.questionDownloadUrls != null) {
        contents.questionDownloadUrls = deserializeAws_restJson1QuestionDownloadUrls(data.questionDownloadUrls, context);
    }
    return contents;
};
const deserializeAws_restJson1BulkGetMatterTemplateMatterContentQuestionsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterTemplate != null) {
        contents.matterTemplate = deserializeAws_restJson1MatterTemplate(data.matterTemplate, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterTemplate != null) {
        contents.matterTemplate = deserializeAws_restJson1MatterTemplate(data.matterTemplate, context);
    }
    return contents;
};
const deserializeAws_restJson1GetMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.items != null) {
        contents.items = deserializeAws_restJson1MatterTemplateSearchItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnindexMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnindexMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnindexMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterTemplateCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterTemplateCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterTemplate != null) {
        contents.matterTemplate = deserializeAws_restJson1MatterTemplate(data.matterTemplate, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterTemplateCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateMatterTemplateMatterContentQuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateMatterTemplateMatterContentQuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.matterContentQuestion != null) {
        contents.matterContentQuestion = deserializeAws_restJson1MatterQuestion(data.matterContentQuestion, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateMatterTemplateMatterContentQuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCFirmInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateOCFirmGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateOCFirmGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCFirmGroupEntityExtra(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateOCFirmGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCUserInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetAllOCUserGroupMembershipCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetAllOCUserGroupMembershipCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.ocFirmGroups != null) {
        contents.ocFirmGroups = deserializeAws_restJson1OCFirmGroupEntityExtraList(data.ocFirmGroups, context);
    }
    return contents;
};
const deserializeAws_restJson1GetAllOCUserGroupMembershipCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCFirmInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetOCFirmGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetOCFirmGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCFirmGroupEntityExtra(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetOCFirmGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCUserInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1OCFirmInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchOCFirmGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchOCFirmGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1OCFirmGroupDocumentList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchOCFirmGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1OCUserInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SoftDeleteOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SoftDeleteOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1SoftDeleteOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SoftDeleteOCFirmGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SoftDeleteOCFirmGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1SoftDeleteOCFirmGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SoftDeleteOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SoftDeleteOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1SoftDeleteOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnIndexOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnIndexOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnIndexOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnIndexOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnIndexOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnIndexOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateOCFirmCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateOCFirmCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCFirmInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateOCFirmCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateOCFirmGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateOCFirmGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCFirmGroupEntityExtra(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateOCFirmGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateOCUserCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateOCUserCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1OCUserInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateOCUserCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AddQuestionToQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AddQuestionToQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionList2Question(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1AddQuestionToQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionList2(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteQuestionsFromQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteQuestionsFromQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionList2(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1DeleteQuestionsFromQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionList2(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetQuestionList2QuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetQuestionList2QuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.answerDownloadUrl != null) {
        contents.answerDownloadUrl = __expectString(data.answerDownloadUrl);
    }
    if (data.labels != null) {
        contents.labels = deserializeAws_restJson1QuestionLabelList(data.labels, context);
    }
    if (data.questionKey != null) {
        contents.questionKey = __expectString(data.questionKey);
    }
    if (data.titleDownloadUrl != null) {
        contents.titleDownloadUrl = __expectString(data.titleDownloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1GetQuestionList2QuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1QuestionList2SearchItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateQuestionList2Command = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateQuestionList2CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionList2(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateQuestionList2CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateQuestionList2QuestionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateQuestionList2QuestionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1QuestionList2Question(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateQuestionList2QuestionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AnswerRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AnswerRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1AnswerRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1ApproveRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ApproveRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1ApproveRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AttachFileRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AttachFileRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewTaskInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1AttachFileRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1BatchGetRapiniQuestionDownloadUrlsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BatchGetRapiniQuestionDownloadUrlsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniQuestionDownloadResultList(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1BatchGetRapiniQuestionDownloadUrlsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CommentRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CommentRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewTaskInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CommentRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewTaskInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateRapiniQuestionTreeCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateRapiniQuestionTreeCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniQuestionTreeInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateRapiniQuestionTreeCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateTasksRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateTasksRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1CreateTasksRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DeleteRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1DeleteRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1DownloadRapiniAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DownloadRapiniAttachmentCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.downloadUrl != null) {
        contents.downloadUrl = __expectString(data.downloadUrl);
    }
    return contents;
};
const deserializeAws_restJson1DownloadRapiniAttachmentCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1EditRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1EditRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1EditRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewTaskInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetRapiniQuestionTreeCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetRapiniQuestionTreeCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniQuestionTreeInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetRapiniQuestionTreeCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1PublishRapiniEventCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PublishRapiniEventCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1PublishRapiniEventCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1RapiniSearchItemList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1RapiniItemReviewSearchDocumentList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1RapiniItemReviewTaskSearchDocumentList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SubmitRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SubmitRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1SubmitRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UnindexRapiniItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UnindexRapiniItemCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1UnindexRapiniItemCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateRapiniItemReviewCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateRapiniItemReviewCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateRapiniItemReviewCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateRapiniItemReviewTaskCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateRapiniItemReviewTaskCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1RapiniItemReviewTaskInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateRapiniItemReviewTaskCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1AddSubTopicCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AddSubTopicCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.subTopic != null) {
        contents.subTopic = deserializeAws_restJson1Subtopic(data.subTopic, context);
    }
    return contents;
};
const deserializeAws_restJson1AddSubTopicCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1CreateTopicCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateTopicCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1TopicInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1CreateTopicCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1GetTopicCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetTopicCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1TopicInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1GetTopicCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1IndexTopicCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1IndexTopicCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
const deserializeAws_restJson1IndexTopicCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1SearchTopicCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchTopicCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.aggregation != null) {
        contents.aggregation = deserializeAws_restJson1TermsAggregation(data.aggregation, context);
    }
    if (data.buckets != null) {
        contents.buckets = deserializeAws_restJson1StringList(data.buckets, context);
    }
    if (data.filter != null) {
        contents.filter = deserializeAws_restJson1Query(data.filter, context);
    }
    if (data.items != null) {
        contents.items = deserializeAws_restJson1TopicInfoList(data.items, context);
    }
    if (data.pagination != null) {
        contents.pagination = deserializeAws_restJson1Pagination(data.pagination, context);
    }
    if (data.query != null) {
        contents.query = deserializeAws_restJson1Query(data.query, context);
    }
    if (data.sort != null) {
        contents.sort = deserializeAws_restJson1Sort(data.sort, context);
    }
    if (data.total != null) {
        contents.total = __expectInt32(data.total);
    }
    return contents;
};
const deserializeAws_restJson1SearchTopicCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1UpdateTopicCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateTopicCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1TopicInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1UpdateTopicCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
export const deserializeAws_restJson1TrackUserActivityCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1TrackUserActivityCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    if (data.body != null) {
        contents.body = deserializeAws_restJson1UserActivityInfo(data.body, context);
    }
    return contents;
};
const deserializeAws_restJson1TrackUserActivityCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazon.altar.sds#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazon.altar.sds#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "DependencyException":
        case "com.amazon.altar.sds#DependencyException":
            throw await deserializeAws_restJson1DependencyExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazon.altar.sds#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "InternalServerException":
        case "com.amazon.altar.sds#InternalServerException":
            throw await deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazon.altar.sds#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "UnauthorizedException":
        case "com.amazon.altar.sds#UnauthorizedException":
            throw await deserializeAws_restJson1UnauthorizedExceptionResponse(parsedOutput, context);
        case "ValidationException":
        case "com.amazon.altar.sds#ValidationException":
            throw await deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: __BaseException,
                errorCode
            });
    }
};
const map = __map;
const deserializeAws_restJson1BadRequestExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new BadRequestException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1ConflictExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new ConflictException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1DependencyExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new DependencyException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1ForbiddenExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new ForbiddenException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1InternalServerExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new InternalServerException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1NotFoundExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new NotFoundException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1UnauthorizedExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    const exception = new UnauthorizedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1ValidationExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.fieldList != null) {
        contents.fieldList = deserializeAws_restJson1ValidationExceptionFieldList(data.fieldList, context);
    }
    if (data.message != null) {
        contents.message = __expectString(data.message);
    }
    if (data.reason != null) {
        contents.reason = __expectString(data.reason);
    }
    const exception = new ValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeAws_restJson1BatchOperationInstanceResourceExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.failed != null) {
        contents.failed = deserializeAws_restJson1BatchOperationInstanceResourceList(data.failed, context);
    }
    if (data.succeeded != null) {
        contents.succeeded = deserializeAws_restJson1BatchOperationInstanceResourceList(data.succeeded, context);
    }
    const exception = new BatchOperationInstanceResourceException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const serializeAws_restJson1Any = (input, context) => {
    return input;
};
const serializeAws_restJson1Duration = (input, context) => {
    return {
        ...(input.length != null && { "length": input.length }),
        ...(input.unit != null && { "unit": input.unit }),
    };
};
const serializeAws_restJson1NestedQuery = (input, context) => {
    return {
        ...(input.path != null && { "path": input.path }),
        ...(input.query != null && { "query": serializeAws_restJson1Query(input.query, context) }),
    };
};
const serializeAws_restJson1NestedQueryList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1NestedQuery(entry, context);
    });
};
const serializeAws_restJson1Pagination = (input, context) => {
    return {
        ...(input.pageIndex != null && { "pageIndex": input.pageIndex }),
        ...(input.pageSize != null && { "pageSize": input.pageSize }),
    };
};
const serializeAws_restJson1PropertyToken = (input, context) => {
    return {
        ...(input.isCaseInsensitive != null && { "isCaseInsensitive": input.isCaseInsensitive }),
        ...(input.isKeywordText != null && { "isKeywordText": input.isKeywordText }),
        ...(input.name != null && { "name": input.name }),
        ...(input.nestPath != null && { "nestPath": input.nestPath }),
        ...(input.operator != null && { "operator": input.operator }),
        ...(input.value != null && { "value": serializeAws_restJson1Any(input.value, context) }),
    };
};
const serializeAws_restJson1PropertyTokenList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1PropertyToken(entry, context);
    });
};
const serializeAws_restJson1Query = (input, context) => {
    return {
        ...(input.operation != null && { "operation": input.operation }),
        ...(input.propertyTokens != null && { "propertyTokens": serializeAws_restJson1PropertyTokenList(input.propertyTokens, context) }),
    };
};
const serializeAws_restJson1Sort = (input, context) => {
    return {
        ...(input.descending != null && { "descending": input.descending }),
        ...(input.isKeywordText != null && { "isKeywordText": input.isKeywordText }),
        ...(input.nestFilter != null && { "nestFilter": serializeAws_restJson1PropertyToken(input.nestFilter, context) }),
        ...(input.nestPath != null && { "nestPath": input.nestPath }),
        ...(input.propertyName != null && { "propertyName": input.propertyName }),
    };
};
const serializeAws_restJson1SortList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1Sort(entry, context);
    });
};
const serializeAws_restJson1StringList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return entry;
    });
};
const serializeAws_restJson1Tags = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
};
const serializeAws_restJson1TermsAggregation = (input, context) => {
    return {
        ...(input.isKeywordText != null && { "isKeywordText": input.isKeywordText }),
        ...(input.name != null && { "name": input.name }),
        ...(input.propertyName != null && { "propertyName": input.propertyName }),
        ...(input.size != null && { "size": input.size }),
    };
};
const serializeAws_restJson1TypicalIdList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return entry;
    });
};
const serializeAws_restJson1AddFieldDefinitionInput = (input, context) => {
    return {
        ...(input.allowFreeTextOption != null && { "allowFreeTextOption": input.allowFreeTextOption }),
        ...(input.choiceOptions != null && { "choiceOptions": serializeAws_restJson1ChoiceOptionsList(input.choiceOptions, context) }),
        ...(input.dataType != null && { "dataType": input.dataType }),
        ...(input.defaultChoiceKeys != null && { "defaultChoiceKeys": serializeAws_restJson1StringList(input.defaultChoiceKeys, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.description != null && { "description": input.description }),
        ...(input.displayName != null && { "displayName": input.displayName }),
        ...(input.fieldKey != null && { "fieldKey": input.fieldKey }),
        ...(input.required != null && { "required": input.required }),
        ...(input.sequenceStartValue != null && { "sequenceStartValue": input.sequenceStartValue }),
    };
};
const serializeAws_restJson1AddFieldDefinitionsList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1AddFieldDefinitionInput(entry, context);
    });
};
const serializeAws_restJson1AdvancedListContext = (input, context) => {
    return {
        ...(input.description != null && { "description": input.description }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ref != null && { "ref": serializeAws_restJson1EntityVersionRef(input.ref, context) }),
    };
};
const serializeAws_restJson1AdvancedListEventData = (input, context) => {
    return AdvancedListEventData.visit(input, {
        itemWorkflowExecuted: value => ({ "itemWorkflowExecuted": serializeAws_restJson1AdvancedListEventData_ITEM_WORKFLOW_EXECUTED(value, context) }),
        _: (name, value) => ({ name: value })
    });
};
const serializeAws_restJson1AdvancedListEventData_ITEM_WORKFLOW_EXECUTED = (input, context) => {
    return {
        ...(input.itemWorkflowExecutionRef != null && { "itemWorkflowExecutionRef": serializeAws_restJson1EntityExtraVersionRef(input.itemWorkflowExecutionRef, context) }),
    };
};
const serializeAws_restJson1AdvancedListItemContext = (input, context) => {
    return {
        ...(input.ref != null && { "ref": serializeAws_restJson1EntityExtraVersionRef(input.ref, context) }),
        ...(input.valuesMap != null && { "valuesMap": serializeAws_restJson1AdvancedListItemValuesMap(input.valuesMap, context) }),
    };
};
const serializeAws_restJson1AdvancedListItemField = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.type != null && { "type": input.type }),
        ...(input.value != null && { "value": serializeAws_restJson1Document(input.value, context) }),
    };
};
const serializeAws_restJson1AdvancedListItemValues = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1AdvancedListItemField(entry, context);
    });
};
const serializeAws_restJson1AdvancedListItemValuesMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = serializeAws_restJson1AdvancedListItemField(value, context);
        return acc;
    }, {});
};
const serializeAws_restJson1AdvancedListWorkflowContext = (input, context) => {
    return {
        ...(input.currentTimestamp != null && { "currentTimestamp": Math.round(input.currentTimestamp.getTime() / 1000) }),
        ...(input.item != null && { "item": serializeAws_restJson1AdvancedListItemContext(input.item, context) }),
        ...(input.lastWorkflowExecution != null && { "lastWorkflowExecution": serializeAws_restJson1AdvancedListWorkflowExecution(input.lastWorkflowExecution, context) }),
        ...(input.list != null && { "list": serializeAws_restJson1AdvancedListContext(input.list, context) }),
        ...(input.oldItem != null && { "oldItem": serializeAws_restJson1AdvancedListItemContext(input.oldItem, context) }),
        ...(input.workflow != null && { "workflow": serializeAws_restJson1EntityWorkflow(input.workflow, context) }),
        ...(input.workflowExecution != null && { "workflowExecution": serializeAws_restJson1AdvancedListWorkflowExecution(input.workflowExecution, context) }),
    };
};
const serializeAws_restJson1AdvancedListWorkflowContextConfig = (input, context) => {
    return {
        ...(input.itemRef != null && { "itemRef": serializeAws_restJson1EntityExtraVersionRef(input.itemRef, context) }),
        ...(input.oldVersion != null && { "oldVersion": input.oldVersion }),
    };
};
const serializeAws_restJson1AdvancedListWorkflowExecution = (input, context) => {
    return {
        ...(input.actionTimestamp != null && { "actionTimestamp": Math.round(input.actionTimestamp.getTime() / 1000) }),
        ...(input.contextCreationTimestamp != null && { "contextCreationTimestamp": Math.round(input.contextCreationTimestamp.getTime() / 1000) }),
        ...(input.evaluationTimestamp != null && { "evaluationTimestamp": Math.round(input.evaluationTimestamp.getTime() / 1000) }),
        ...(input.nowTimestamp != null && { "nowTimestamp": Math.round(input.nowTimestamp.getTime() / 1000) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1EntityExtraVersionRef(input.ref, context) }),
        ...(input.runSeq != null && { "runSeq": input.runSeq }),
        ...(input.startTimestamp != null && { "startTimestamp": Math.round(input.startTimestamp.getTime() / 1000) }),
        ...(input.workflowContextConfig != null && { "workflowContextConfig": serializeAws_restJson1AdvancedListWorkflowContextConfig(input.workflowContextConfig, context) }),
        ...(input.workflowMajorVersion != null && { "workflowMajorVersion": input.workflowMajorVersion }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1EntityExtraVersionRef(input.workflowRef, context) }),
    };
};
const serializeAws_restJson1ChoiceOption = (input, context) => {
    return {
        ...(input.displayValue != null && { "displayValue": input.displayValue }),
        ...(input.key != null && { "key": input.key }),
    };
};
const serializeAws_restJson1ChoiceOptionsList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1ChoiceOption(entry, context);
    });
};
const serializeAws_restJson1EditorList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1IdentityRef(entry, context);
    });
};
const serializeAws_restJson1EntityExtraRef = (input, context) => {
    return {
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1EntityRef(input.entityRef, context) }),
        ...(input.extraId != null && { "extraId": input.extraId }),
        ...(input.extraTypeId != null && { "extraTypeId": input.extraTypeId }),
    };
};
const serializeAws_restJson1EntityExtraVersionRef = (input, context) => {
    return {
        ...(input.entityExtraRef != null && { "entityExtraRef": serializeAws_restJson1EntityExtraRef(input.entityExtraRef, context) }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1EntityExtraVersionRefList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1EntityExtraVersionRef(entry, context);
    });
};
const serializeAws_restJson1EntityRef = (input, context) => {
    return {
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.entityTypeRef != null && { "entityTypeRef": serializeAws_restJson1EntityTypeRef(input.entityTypeRef, context) }),
        ...(input.repositoryRef != null && { "repositoryRef": serializeAws_restJson1EntityRepositoryRef(input.repositoryRef, context) }),
    };
};
const serializeAws_restJson1EntityRefList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1EntityRef(entry, context);
    });
};
const serializeAws_restJson1EntityVersionRef = (input, context) => {
    return {
        ...(input._do_not_delete != null && { "_do_not_delete": input._do_not_delete }),
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1EntityRef(input.entityRef, context) }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1EntityWorkflow = (input, context) => {
    return {
        ...(input._do_not_delete != null && { "_do_not_delete": input._do_not_delete }),
        ...(input.actor != null && { "actor": serializeAws_restJson1EntityWorkflowActor(input.actor, context) }),
        ...(input.contextType != null && { "contextType": input.contextType }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.disabled != null && { "disabled": input.disabled }),
        ...(input.evaluator != null && { "evaluator": serializeAws_restJson1EntityWorkflowEvaluator(input.evaluator, context) }),
        ...(input.executionHistoryDuration != null && { "executionHistoryDuration": serializeAws_restJson1Duration(input.executionHistoryDuration, context) }),
        ...(input.majorVersion != null && { "majorVersion": input.majorVersion }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ref != null && { "ref": serializeAws_restJson1EntityExtraVersionRef(input.ref, context) }),
        ...(input.variables != null && { "variables": serializeAws_restJson1VariableList(input.variables, context) }),
    };
};
const serializeAws_restJson1EntityWorkflowActor = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.type != null && { "type": input.type }),
        ...(input.variables != null && { "variables": serializeAws_restJson1VariableList(input.variables, context) }),
    };
};
const serializeAws_restJson1EntityWorkflowEvaluator = (input, context) => {
    return EntityWorkflowEvaluator.visit(input, {
        basic: value => ({ "basic": serializeAws_restJson1EntityWorkflowEvaluator_Basic(value, context) }),
        composite: value => ({ "composite": serializeAws_restJson1EntityWorkflowEvaluator_Composite(value, context) }),
        _: (name, value) => ({ name: value })
    });
};
const serializeAws_restJson1EntityWorkflowEvaluator_Basic = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.type != null && { "type": input.type }),
        ...(input.variables != null && { "variables": serializeAws_restJson1VariableList(input.variables, context) }),
    };
};
const serializeAws_restJson1EntityWorkflowEvaluator_Composite = (input, context) => {
    return {
        ...(input.evaluators != null && { "evaluators": serializeAws_restJson1EntityWorkflowEvaluatorList(input.evaluators, context) }),
        ...(input.join != null && { "join": input.join }),
    };
};
const serializeAws_restJson1EntityWorkflowEvaluatorList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1EntityWorkflowEvaluator(entry, context);
    });
};
const serializeAws_restJson1FlatEntityExtraRef = (input, context) => {
    return {
        ...(input.entityRef != null && { "entityRef": serializeAws_restJson1FlatEntityRef(input.entityRef, context) }),
        ...(input.extraId != null && { "extraId": input.extraId }),
        ...(input.extraTypeId != null && { "extraTypeId": input.extraTypeId }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1FlatEntityExtraRefList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1FlatEntityExtraRef(entry, context);
    });
};
const serializeAws_restJson1FlatEntityRef = (input, context) => {
    return {
        ...(input.entityId != null && { "entityId": input.entityId }),
        ...(input.entityTypeId != null && { "entityTypeId": input.entityTypeId }),
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1Variable = (input, context) => {
    return {
        ...(input.isDynamic != null && { "isDynamic": input.isDynamic }),
        ...(input.name != null && { "name": input.name }),
        ...(input.tags != null && { "tags": serializeAws_restJson1Tags(input.tags, context) }),
        ...(input.value != null && { "value": input.value }),
    };
};
const serializeAws_restJson1VariableList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1Variable(entry, context);
    });
};
const serializeAws_restJson1EntityRepositoryEvaluator_Basic = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.type != null && { "type": input.type }),
        ...(input.variables != null && { "variables": serializeAws_restJson1EntityRepositoryWorkflowVariableList(input.variables, context) }),
    };
};
const serializeAws_restJson1EntityRepositoryEvaluator_Composite = (input, context) => {
    return {
        ...(input.evaluators != null && { "evaluators": serializeAws_restJson1EntityRepositoryWorkflowEvaluatorList(input.evaluators, context) }),
        ...(input.join != null && { "join": input.join }),
    };
};
const serializeAws_restJson1EntityRepositoryRef = (input, context) => {
    return {
        ...(input.repositoryId != null && { "repositoryId": input.repositoryId }),
    };
};
const serializeAws_restJson1EntityRepositoryRolePermission = (input, context) => {
    return {
        ...(input.entityTypeId != null && { "entityTypeId": input.entityTypeId }),
        ...(input.permissionName != null && { "permissionName": input.permissionName }),
    };
};
const serializeAws_restJson1EntityRepositoryRolePermissions = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1EntityRepositoryRolePermission(entry, context);
    });
};
const serializeAws_restJson1EntityRepositoryWorkflowActor = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.type != null && { "type": input.type }),
        ...(input.variables != null && { "variables": serializeAws_restJson1EntityRepositoryWorkflowVariableList(input.variables, context) }),
    };
};
const serializeAws_restJson1EntityRepositoryWorkflowEvaluator = (input, context) => {
    return EntityRepositoryWorkflowEvaluator.visit(input, {
        basic: value => ({ "basic": serializeAws_restJson1EntityRepositoryEvaluator_Basic(value, context) }),
        composite: value => ({ "composite": serializeAws_restJson1EntityRepositoryEvaluator_Composite(value, context) }),
        _: (name, value) => ({ name: value })
    });
};
const serializeAws_restJson1EntityRepositoryWorkflowEvaluatorList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1EntityRepositoryWorkflowEvaluator(entry, context);
    });
};
const serializeAws_restJson1EntityRepositoryWorkflowVariable = (input, context) => {
    return {
        ...(input.isDynamic != null && { "isDynamic": input.isDynamic }),
        ...(input.name != null && { "name": input.name }),
        ...(input.tags != null && { "tags": serializeAws_restJson1Tags(input.tags, context) }),
        ...(input.value != null && { "value": input.value }),
    };
};
const serializeAws_restJson1EntityRepositoryWorkflowVariableList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1EntityRepositoryWorkflowVariable(entry, context);
    });
};
const serializeAws_restJson1EntityTypeRef = (input, context) => {
    return {
        ...(input.entityTypeId != null && { "entityTypeId": input.entityTypeId }),
    };
};
const serializeAws_restJson1IdentityRef = (input, context) => {
    return {
        ...(input.id != null && { "id": input.id }),
        ...(input.realm != null && { "realm": input.realm }),
        ...(input.type != null && { "type": input.type }),
    };
};
const serializeAws_restJson1IdentityRefList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1IdentityRef(entry, context);
    });
};
const serializeAws_restJson1InstanceRoleRef = (input, context) => {
    return {
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.roleId != null && { "roleId": input.roleId }),
    };
};
const serializeAws_restJson1MatterCustomField = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.name != null && { "name": input.name }),
        ...(input.required != null && { "required": input.required }),
        ...(input.sequenceNumber != null && { "sequenceNumber": input.sequenceNumber }),
        ...(input.type != null && { "type": input.type }),
    };
};
const serializeAws_restJson1MatterCustomFieldList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1MatterCustomField(entry, context);
    });
};
const serializeAws_restJson1ModuleConfiguration = (input, context) => {
    return {
        ...(input.__do_not_delete != null && { "__do_not_delete": serializeAws_restJson1Source2ModuleConfiguration(input.__do_not_delete, context) }),
        ...(input.configuration != null && { "configuration": serializeAws_restJson1Document(input.configuration, context) }),
        ...(input.moduleName != null && { "moduleName": input.moduleName }),
    };
};
const serializeAws_restJson1ModuleConfigurationList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1ModuleConfiguration(entry, context);
    });
};
const serializeAws_restJson1ModuleList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return entry;
    });
};
const serializeAws_restJson1SmartSearchResultRelevanceItem = (input, context) => {
    return {
        ...(input.relevance != null && { "relevance": input.relevance }),
        ...(input.resultId != null && { "resultId": input.resultId }),
    };
};
const serializeAws_restJson1SmartSearchResultRelevanceItems = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1SmartSearchResultRelevanceItem(entry, context);
    });
};
const serializeAws_restJson1Source2ModuleConfiguration = (input, context) => {
    return {
        ...(input.enableLabels != null && { "enableLabels": input.enableLabels }),
        ...(input.enableMatterCustomFields != null && { "enableMatterCustomFields": input.enableMatterCustomFields }),
        ...(input.hideDeprecatedTopics != null && { "hideDeprecatedTopics": input.hideDeprecatedTopics }),
        ...(input.matterCustomFields != null && { "matterCustomFields": serializeAws_restJson1MatterCustomFieldList(input.matterCustomFields, context) }),
        ...(input.matterOwnerInactiveWorkflowRef != null && { "matterOwnerInactiveWorkflowRef": serializeAws_restJson1MatterInstanceWorkflowRef(input.matterOwnerInactiveWorkflowRef, context) }),
        ...(input.matterRefreshWorkflowRef != null && { "matterRefreshWorkflowRef": serializeAws_restJson1MatterInstanceWorkflowRef(input.matterRefreshWorkflowRef, context) }),
    };
};
const serializeAws_restJson1CountryData2 = (input, context) => {
    return {
        ...(input.subLocations != null && { "subLocations": serializeAws_restJson1SubLocationList(input.subLocations, context) }),
    };
};
const serializeAws_restJson1SubLocation = (input, context) => {
    return {
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.key != null && { "key": input.key }),
        ...(input.name != null && { "name": input.name }),
    };
};
const serializeAws_restJson1SubLocationList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1SubLocation(entry, context);
    });
};
const serializeAws_restJson1UnionData2 = (input, context) => {
    return {
        ...(input.countries != null && { "countries": serializeAws_restJson1EntityRefList(input.countries, context) }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
    };
};
const serializeAws_restJson1BatchUpdatePermissionForMatterQuestionRequestItem = (input, context) => {
    return {
        ...(input.grantList != null && { "grantList": serializeAws_restJson1IdentityRefList(input.grantList, context) }),
        ...(input.questionKey != null && { "questionKey": input.questionKey }),
        ...(input.revokeList != null && { "revokeList": serializeAws_restJson1IdentityRefList(input.revokeList, context) }),
    };
};
const serializeAws_restJson1BatchUpdatePermissionForMatterQuestionRequestItemList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1BatchUpdatePermissionForMatterQuestionRequestItem(entry, context);
    });
};
const serializeAws_restJson1CompactMatter = (input, context) => {
    return {
        ...(input.__do_not_delete != null && { "__do_not_delete": input.__do_not_delete }),
        ...(input.draftContent != null && { "draftContent": serializeAws_restJson1CompactMatterDraftContent(input.draftContent, context) }),
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.owner != null && { "owner": serializeAws_restJson1IdentityRef(input.owner, context) }),
        ...(input.publishedContent != null && { "publishedContent": serializeAws_restJson1CompactMatterPublishedContent(input.publishedContent, context) }),
        ...(input.status != null && { "status": input.status }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1CompactMatterContentBody = (input, context) => {
    return {
        ...(input.customDateFieldList != null && { "customDateFieldList": serializeAws_restJson1MatterCustomDateFieldList(input.customDateFieldList, context) }),
        ...(input.name != null && { "name": input.name }),
        ...(input.refreshDate != null && { "refreshDate": Math.round(input.refreshDate.getTime() / 1000) }),
    };
};
const serializeAws_restJson1CompactMatterContext = (input, context) => {
    return {
        ...(input.compactMatter != null && { "compactMatter": serializeAws_restJson1CompactMatter(input.compactMatter, context) }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
    };
};
const serializeAws_restJson1CompactMatterDraftContent = (input, context) => {
    return {
        ...(input.body != null && { "body": serializeAws_restJson1CompactMatterContentBody(input.body, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.creationDate != null && { "creationDate": Math.round(input.creationDate.getTime() / 1000) }),
        ...(input.majorVersion != null && { "majorVersion": input.majorVersion }),
        ...(input.minorVersion != null && { "minorVersion": input.minorVersion }),
        ...(input.modifyType != null && { "modifyType": input.modifyType }),
    };
};
const serializeAws_restJson1CompactMatterPublishedContent = (input, context) => {
    return {
        ...(input.body != null && { "body": serializeAws_restJson1CompactMatterContentBody(input.body, context) }),
        ...(input.by != null && { "by": serializeAws_restJson1IdentityRef(input.by, context) }),
        ...(input.creationDate != null && { "creationDate": Math.round(input.creationDate.getTime() / 1000) }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1MatterCustomDateField = (input, context) => {
    return {
        ...(input.key != null && { "key": input.key }),
        ...(input.sequenceNumber != null && { "sequenceNumber": input.sequenceNumber }),
        ...(input.value != null && { "value": Math.round(input.value.getTime() / 1000) }),
    };
};
const serializeAws_restJson1MatterCustomDateFieldList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1MatterCustomDateField(entry, context);
    });
};
const serializeAws_restJson1MatterDraftContentHistory = (input, context) => {
    return {
        ...(input.majorVersion != null && { "majorVersion": input.majorVersion }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1EntityVersionRef(input.matterRef, context) }),
        ...(input.minorVersion != null && { "minorVersion": input.minorVersion }),
        ...(input.modifiedBy != null && { "modifiedBy": serializeAws_restJson1IdentityRef(input.modifiedBy, context) }),
        ...(input.modifiedDate != null && { "modifiedDate": Math.round(input.modifiedDate.getTime() / 1000) }),
        ...(input.modifyType != null && { "modifyType": input.modifyType }),
    };
};
const serializeAws_restJson1MatterInstanceWorkflow = (input, context) => {
    return {
        ...(input.actor != null && { "actor": serializeAws_restJson1EntityRepositoryWorkflowActor(input.actor, context) }),
        ...(input.desc != null && { "desc": input.desc }),
        ...(input.disabled != null && { "disabled": input.disabled }),
        ...(input.evaluator != null && { "evaluator": serializeAws_restJson1EntityRepositoryWorkflowEvaluator(input.evaluator, context) }),
        ...(input.executionHistoryDuration != null && { "executionHistoryDuration": serializeAws_restJson1Duration(input.executionHistoryDuration, context) }),
        ...(input.majorVersion != null && { "majorVersion": input.majorVersion }),
        ...(input.name != null && { "name": input.name }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterInstanceWorkflowRef(input.ref, context) }),
        ...(input.triggeredBy != null && { "triggeredBy": input.triggeredBy }),
        ...(input.variables != null && { "variables": serializeAws_restJson1EntityRepositoryWorkflowVariableList(input.variables, context) }),
    };
};
const serializeAws_restJson1MatterInstanceWorkflowContext = (input, context) => {
    return {
        ...(input.currentTimestamp != null && { "currentTimestamp": Math.round(input.currentTimestamp.getTime() / 1000) }),
        ...(input.lastWorkflowExecution != null && { "lastWorkflowExecution": serializeAws_restJson1MatterInstanceWorkflowExecution(input.lastWorkflowExecution, context) }),
        ...(input.matter != null && { "matter": serializeAws_restJson1CompactMatterContext(input.matter, context) }),
        ...(input.oldMatter != null && { "oldMatter": serializeAws_restJson1CompactMatterContext(input.oldMatter, context) }),
        ...(input.workflow != null && { "workflow": serializeAws_restJson1MatterInstanceWorkflow(input.workflow, context) }),
        ...(input.workflowExecution != null && { "workflowExecution": serializeAws_restJson1MatterInstanceWorkflowExecution(input.workflowExecution, context) }),
    };
};
const serializeAws_restJson1MatterInstanceWorkflowExecution = (input, context) => {
    return {
        ...(input.__do_not_delete != null && { "__do_not_delete": input.__do_not_delete }),
        ...(input.__do_not_delete2 != null && { "__do_not_delete2": input.__do_not_delete2 }),
        ...(input.__do_not_delete3 != null && { "__do_not_delete3": serializeAws_restJson1MatterWorkflowActorOutput_REFRESH_EVENT(input.__do_not_delete3, context) }),
        ...(input.__do_not_delete4 != null && { "__do_not_delete4": input.__do_not_delete4 }),
        ...(input.__do_not_delete5 != null && { "__do_not_delete5": serializeAws_restJson1MatterWorkflowActorOutput_MATTER_OWNER_INACTIVE_EVENT(input.__do_not_delete5, context) }),
        ...(input.actionTimestamp != null && { "actionTimestamp": Math.round(input.actionTimestamp.getTime() / 1000) }),
        ...(input.contextCreationTimestamp != null && { "contextCreationTimestamp": Math.round(input.contextCreationTimestamp.getTime() / 1000) }),
        ...(input.evaluationTimestamp != null && { "evaluationTimestamp": Math.round(input.evaluationTimestamp.getTime() / 1000) }),
        ...(input.evaluatorOutput != null && { "evaluatorOutput": input.evaluatorOutput }),
        ...(input.executionCreationContext != null && { "executionCreationContext": serializeAws_restJson1MatterWorkflowExecutionCreationContext(input.executionCreationContext, context) }),
        ...(input.nowTimestamp != null && { "nowTimestamp": Math.round(input.nowTimestamp.getTime() / 1000) }),
        ...(input.ref != null && { "ref": serializeAws_restJson1MatterInstanceWorkflowExecutionRef(input.ref, context) }),
        ...(input.runSequenceNumber != null && { "runSequenceNumber": input.runSequenceNumber }),
        ...(input.startTimestamp != null && { "startTimestamp": Math.round(input.startTimestamp.getTime() / 1000) }),
        ...(input.status != null && { "status": input.status }),
        ...(input.workflowMajorVersion != null && { "workflowMajorVersion": input.workflowMajorVersion }),
        ...(input.workflowRef != null && { "workflowRef": serializeAws_restJson1MatterInstanceWorkflowRef(input.workflowRef, context) }),
    };
};
const serializeAws_restJson1MatterInstanceWorkflowExecutionRef = (input, context) => {
    return {
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.version != null && { "version": input.version }),
        ...(input.workflowExecutionId != null && { "workflowExecutionId": input.workflowExecutionId }),
    };
};
const serializeAws_restJson1MatterInstanceWorkflowExecutionRefList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1MatterInstanceWorkflowExecutionRef(entry, context);
    });
};
const serializeAws_restJson1MatterInstanceWorkflowRef = (input, context) => {
    return {
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.version != null && { "version": input.version }),
        ...(input.workflowId != null && { "workflowId": input.workflowId }),
    };
};
const serializeAws_restJson1MatterInstanceWorkflowRefList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1MatterInstanceWorkflowRef(entry, context);
    });
};
const serializeAws_restJson1MatterLocation = (input, context) => {
    return {
        ...(input.type != null && { "type": input.type }),
        ...(input.value != null && { "value": serializeAws_restJson1MatterLocationValue(input.value, context) }),
    };
};
const serializeAws_restJson1MatterLocationList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1MatterLocation(entry, context);
    });
};
const serializeAws_restJson1MatterLocationValue = (input, context) => {
    return {
        ...(input.locationRef != null && { "locationRef": serializeAws_restJson1EntityRef(input.locationRef, context) }),
        ...(input.subCountryKey != null && { "subCountryKey": input.subCountryKey }),
    };
};
const serializeAws_restJson1MatterPublishedContentHistory = (input, context) => {
    return {
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1EntityVersionRef(input.matterRef, context) }),
        ...(input.publishDate != null && { "publishDate": Math.round(input.publishDate.getTime() / 1000) }),
        ...(input.publishedBy != null && { "publishedBy": serializeAws_restJson1IdentityRef(input.publishedBy, context) }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1MatterRef = (input, context) => {
    return {
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.matterId != null && { "matterId": input.matterId }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1MatterSmartSearchFilter = (input, context) => {
    return {
        ...(input.customDateFieldsGreaterThan != null && { "customDateFieldsGreaterThan": serializeAws_restJson1MatterCustomDateFieldList(input.customDateFieldsGreaterThan, context) }),
        ...(input.customDateFieldsLessThan != null && { "customDateFieldsLessThan": serializeAws_restJson1MatterCustomDateFieldList(input.customDateFieldsLessThan, context) }),
        ...(input.highlyConfidential != null && { "highlyConfidential": input.highlyConfidential }),
        ...(input.legalOnly != null && { "legalOnly": input.legalOnly }),
        ...(input.locations != null && { "locations": serializeAws_restJson1MatterLocationList(input.locations, context) }),
        ...(input.owner != null && { "owner": serializeAws_restJson1IdentityRef(input.owner, context) }),
        ...(input.publishDateGreaterThan != null && { "publishDateGreaterThan": Math.round(input.publishDateGreaterThan.getTime() / 1000) }),
        ...(input.publishDateLessThan != null && { "publishDateLessThan": Math.round(input.publishDateLessThan.getTime() / 1000) }),
        ...(input.published != null && { "published": input.published }),
        ...(input.publishedBy != null && { "publishedBy": serializeAws_restJson1IdentityRef(input.publishedBy, context) }),
        ...(input.queryText != null && { "queryText": input.queryText }),
        ...(input.questionLabels != null && { "questionLabels": serializeAws_restJson1QuestionLabelList(input.questionLabels, context) }),
        ...(input.refreshDateGreaterThan != null && { "refreshDateGreaterThan": Math.round(input.refreshDateGreaterThan.getTime() / 1000) }),
        ...(input.refreshDateLessThan != null && { "refreshDateLessThan": Math.round(input.refreshDateLessThan.getTime() / 1000) }),
        ...(input.topics != null && { "topics": serializeAws_restJson1MatterTopicList(input.topics, context) }),
    };
};
const serializeAws_restJson1MatterTopic = (input, context) => {
    return {
        ...(input.subTopicKey != null && { "subTopicKey": input.subTopicKey }),
        ...(input.topicRef != null && { "topicRef": serializeAws_restJson1EntityRef(input.topicRef, context) }),
    };
};
const serializeAws_restJson1MatterTopicList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1MatterTopic(entry, context);
    });
};
const serializeAws_restJson1MatterWorkflowActorOutput_MATTER_OWNER_INACTIVE_EVENT = (input, context) => {
    return {
        ...(input.matterName != null && { "matterName": input.matterName }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.owner != null && { "owner": serializeAws_restJson1IdentityRef(input.owner, context) }),
    };
};
const serializeAws_restJson1MatterWorkflowActorOutput_REFRESH_EVENT = (input, context) => {
    return {
        ...(input.matterName != null && { "matterName": input.matterName }),
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.owner != null && { "owner": serializeAws_restJson1IdentityRef(input.owner, context) }),
        ...(input.refreshDate != null && { "refreshDate": Math.round(input.refreshDate.getTime() / 1000) }),
    };
};
const serializeAws_restJson1MatterWorkflowExecutionCreationContext = (input, context) => {
    return {
        ...(input.matterRef != null && { "matterRef": serializeAws_restJson1MatterRef(input.matterRef, context) }),
        ...(input.oldVersion != null && { "oldVersion": input.oldVersion }),
    };
};
const serializeAws_restJson1OCUserOrGroupId = (input, context) => {
    return OCUserOrGroupId.visit(input, {
        groupId: value => ({ "groupId": value }),
        userId: value => ({ "userId": value }),
        _: (name, value) => ({ name: value })
    });
};
const serializeAws_restJson1MatterTemplateRef = (input, context) => {
    return {
        ...(input.id != null && { "id": input.id }),
        ...(input.instanceId != null && { "instanceId": input.instanceId }),
        ...(input.version != null && { "version": input.version }),
    };
};
const serializeAws_restJson1QuestionLabel = (input, context) => {
    return {
        ...(input.labelRef != null && { "labelRef": serializeAws_restJson1EntityRef(input.labelRef, context) }),
    };
};
const serializeAws_restJson1QuestionLabelList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1QuestionLabel(entry, context);
    });
};
const serializeAws_restJson1QuestionLabelMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = serializeAws_restJson1QuestionLabelList(value, context);
        return acc;
    }, {});
};
const serializeAws_restJson1ItemContributor = (input, context) => {
    return {
        ...(input.role != null && { "role": input.role }),
        ...(input.user != null && { "user": serializeAws_restJson1IdentityRef(input.user, context) }),
    };
};
const serializeAws_restJson1ItemContributorList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1ItemContributor(entry, context);
    });
};
const serializeAws_restJson1QuestionnaireResponses = (input, context) => {
    return {
        ...(input.questionnaireId != null && { "questionnaireId": input.questionnaireId }),
        ...(input.questionnaireVersion != null && { "questionnaireVersion": input.questionnaireVersion }),
        ...(input.responseList != null && { "responseList": serializeAws_restJson1QuestionResponseList(input.responseList, context) }),
    };
};
const serializeAws_restJson1QuestionResponse = (input, context) => {
    return {
        ...(input.nodeKey != null && { "nodeKey": input.nodeKey }),
        ...(input.response != null && { "response": input.response }),
    };
};
const serializeAws_restJson1QuestionResponseList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1QuestionResponse(entry, context);
    });
};
const serializeAws_restJson1RapiniAttachment = (input, context) => {
    return {
        ...(input.attachmentRef != null && { "attachmentRef": serializeAws_restJson1EntityExtraVersionRef(input.attachmentRef, context) }),
        ...(input.attachmentType != null && { "attachmentType": input.attachmentType }),
        ...(input.fileName != null && { "fileName": input.fileName }),
    };
};
const serializeAws_restJson1RapiniEventData = (input, context) => {
    return {
        ...(input.rapiniItemRef != null && { "rapiniItemRef": serializeAws_restJson1EntityRef(input.rapiniItemRef, context) }),
        ...(input.rapiniItemReviewRef != null && { "rapiniItemReviewRef": serializeAws_restJson1EntityExtraVersionRef(input.rapiniItemReviewRef, context) }),
        ...(input.rapiniItemReviewTaskRef != null && { "rapiniItemReviewTaskRef": serializeAws_restJson1EntityExtraVersionRef(input.rapiniItemReviewTaskRef, context) }),
    };
};
const serializeAws_restJson1RapiniQuestionNodeIdSandboxUrl = (input, context) => {
    return {
        ...(input.questionNodeId != null && { "questionNodeId": input.questionNodeId }),
        ...(input.sandboxUrl != null && { "sandboxUrl": input.sandboxUrl }),
    };
};
const serializeAws_restJson1RapiniQuestionNodeIdSandboxUrlList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1RapiniQuestionNodeIdSandboxUrl(entry, context);
    });
};
const serializeAws_restJson1SandboxFileKeyFileName = (input, context) => {
    return {
        ...(input.fileKey != null && { "fileKey": input.fileKey }),
        ...(input.fileName != null && { "fileName": input.fileName }),
    };
};
const serializeAws_restJson1SandboxFileKeyFileNameList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1SandboxFileKeyFileName(entry, context);
    });
};
const serializeAws_restJson1Subtopic = (input, context) => {
    return {
        ...(input.deleted != null && { "deleted": input.deleted }),
        ...(input.deprecated != null && { "deprecated": input.deprecated }),
        ...(input.description != null && { "description": input.description }),
        ...(input.key != null && { "key": input.key }),
        ...(input.name != null && { "name": input.name }),
    };
};
const serializeAws_restJson1SubtopicList = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return serializeAws_restJson1Subtopic(entry, context);
    });
};
const serializeAws_restJson1Document = (input, context) => {
    return input;
};
const deserializeAws_restJson1Any = (output, context) => {
    return output;
};
const deserializeAws_restJson1CreationInfo = (output, context) => {
    return {
        createdBy: (output.createdBy != null) ? deserializeAws_restJson1IdentityRef(output.createdBy, context) : undefined,
        creationTimestamp: (output.creationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationTimestamp))) : undefined,
    };
};
const deserializeAws_restJson1DeletionInfo = (output, context) => {
    return {
        deletedBy: (output.deletedBy != null) ? deserializeAws_restJson1IdentityRef(output.deletedBy, context) : undefined,
        deletionTimestamp: (output.deletionTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.deletionTimestamp))) : undefined,
    };
};
const deserializeAws_restJson1Duration = (output, context) => {
    return {
        length: __expectInt32(output.length),
        unit: __expectString(output.unit),
    };
};
const deserializeAws_restJson1NestedQuery = (output, context) => {
    return {
        path: __expectString(output.path),
        query: (output.query != null) ? deserializeAws_restJson1Query(output.query, context) : undefined,
    };
};
const deserializeAws_restJson1NestedQueryList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1NestedQuery(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1Pagination = (output, context) => {
    return {
        pageIndex: __expectInt32(output.pageIndex),
        pageSize: __expectInt32(output.pageSize),
    };
};
const deserializeAws_restJson1PropertyToken = (output, context) => {
    return {
        isCaseInsensitive: __expectBoolean(output.isCaseInsensitive),
        isKeywordText: __expectBoolean(output.isKeywordText),
        name: __expectString(output.name),
        nestPath: __expectString(output.nestPath),
        operator: __expectString(output.operator),
        value: (output.value != null) ? deserializeAws_restJson1Any(output.value, context) : undefined,
    };
};
const deserializeAws_restJson1PropertyTokenList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PropertyToken(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1Query = (output, context) => {
    return {
        operation: __expectString(output.operation),
        propertyTokens: (output.propertyTokens != null) ? deserializeAws_restJson1PropertyTokenList(output.propertyTokens, context) : undefined,
    };
};
const deserializeAws_restJson1Sort = (output, context) => {
    return {
        descending: __expectBoolean(output.descending),
        isKeywordText: __expectBoolean(output.isKeywordText),
        nestFilter: (output.nestFilter != null) ? deserializeAws_restJson1PropertyToken(output.nestFilter, context) : undefined,
        nestPath: __expectString(output.nestPath),
        propertyName: __expectString(output.propertyName),
    };
};
const deserializeAws_restJson1SortList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Sort(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1StringList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
const deserializeAws_restJson1Tags = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = __expectString(value);
        return acc;
    }, {});
};
const deserializeAws_restJson1TermsAggregation = (output, context) => {
    return {
        isKeywordText: __expectBoolean(output.isKeywordText),
        name: __expectString(output.name),
        propertyName: __expectString(output.propertyName),
        size: __expectInt32(output.size),
    };
};
const deserializeAws_restJson1TypicalIdList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
const deserializeAws_restJson1ValidationExceptionField = (output, context) => {
    return {
        message: __expectString(output.message),
        name: __expectString(output.name),
    };
};
const deserializeAws_restJson1ValidationExceptionFieldList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ValidationExceptionField(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1VersionInfo = (output, context) => {
    return {
        lastModifiedBy: (output.lastModifiedBy != null) ? deserializeAws_restJson1IdentityRef(output.lastModifiedBy, context) : undefined,
        lastModifiedTimestamp: (output.lastModifiedTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedTimestamp))) : undefined,
        versionComment: __expectString(output.versionComment),
    };
};
const deserializeAws_restJson1AdvancedList = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        _do_not_delete2: __expectString(output._do_not_delete2),
        defaultSort: (output.defaultSort != null) ? deserializeAws_restJson1Sort(output.defaultSort, context) : undefined,
        description: __expectString(output.description),
        editorFieldKey: __expectString(output.editorFieldKey),
        editors: (output.editors != null) ? deserializeAws_restJson1EditorList(output.editors, context) : undefined,
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        fieldDefinitions: (output.fieldDefinitions != null) ? deserializeAws_restJson1FieldDefintionList(output.fieldDefinitions, context) : undefined,
        name: __expectString(output.name),
        viewerFieldKey: __expectString(output.viewerFieldKey),
    };
};
const deserializeAws_restJson1AdvancedListContext = (output, context) => {
    return {
        description: __expectString(output.description),
        name: __expectString(output.name),
        ref: (output.ref != null) ? deserializeAws_restJson1EntityVersionRef(output.ref, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListEvent = (output, context) => {
    return {
        advancedListRef: (output.advancedListRef != null) ? deserializeAws_restJson1EntityRef(output.advancedListRef, context) : undefined,
        eventData: (output.eventData != null) ? deserializeAws_restJson1AdvancedListEventData(__expectUnion(output.eventData), context) : undefined,
        eventTimestamp: (output.eventTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.eventTimestamp))) : undefined,
        eventType: __expectString(output.eventType),
    };
};
const deserializeAws_restJson1AdvancedListEventData = (output, context) => {
    if (output.itemWorkflowExecuted != null) {
        return {
            itemWorkflowExecuted: deserializeAws_restJson1AdvancedListEventData_ITEM_WORKFLOW_EXECUTED(output.itemWorkflowExecuted, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const deserializeAws_restJson1AdvancedListEventData_ITEM_WORKFLOW_EXECUTED = (output, context) => {
    return {
        itemWorkflowExecutionRef: (output.itemWorkflowExecutionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.itemWorkflowExecutionRef, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListItem = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        _do_not_delete2: (output._do_not_delete2 != null) ? deserializeAws_restJson1ItemChoiceOption(output._do_not_delete2, context) : undefined,
        _do_not_delete3: (output._do_not_delete3 != null) ? deserializeAws_restJson1ItemHyperlink(output._do_not_delete3, context) : undefined,
        _do_not_delete4: (output._do_not_delete4 != null) ? deserializeAws_restJson1AdvancedListEvent(output._do_not_delete4, context) : undefined,
        _do_not_delete5: __expectString(output._do_not_delete5),
        attachments: (output.attachments != null) ? deserializeAws_restJson1AdvancedListItemAttachmentList(output.attachments, context) : undefined,
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        values: (output.values != null) ? deserializeAws_restJson1AdvancedListItemValues(output.values, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListItemAttachment = (output, context) => {
    return {
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        fileName: __expectString(output.fileName),
        key: __expectString(output.key),
    };
};
const deserializeAws_restJson1AdvancedListItemAttachmentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AdvancedListItemAttachment(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1AdvancedListItemContext = (output, context) => {
    return {
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        valuesMap: (output.valuesMap != null) ? deserializeAws_restJson1AdvancedListItemValuesMap(output.valuesMap, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListItemField = (output, context) => {
    return {
        key: __expectString(output.key),
        type: __expectString(output.type),
        value: (output.value != null) ? deserializeAws_restJson1Document(output.value, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListItemValues = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AdvancedListItemField(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1AdvancedListItemValuesMap = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = deserializeAws_restJson1AdvancedListItemField(value, context);
        return acc;
    }, {});
};
const deserializeAws_restJson1AdvancedListSearchItem = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        _do_not_delete_search_property: __expectString(output._do_not_delete_search_property),
        attachments: (output.attachments != null) ? deserializeAws_restJson1AdvancedListItemAttachmentList(output.attachments, context) : undefined,
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        values: (output.values != null) ? deserializeAws_restJson1AdvancedListItemValues(output.values, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListSearchItems = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AdvancedListSearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1AdvancedListView = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        deprecated: __expectBoolean(output.deprecated),
        description: __expectString(output.description),
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        fieldKeys: (output.fieldKeys != null) ? deserializeAws_restJson1StringList(output.fieldKeys, context) : undefined,
        filter: (output.filter != null) ? deserializeAws_restJson1Query(output.filter, context) : undefined,
        name: __expectString(output.name),
        sort: (output.sort != null) ? deserializeAws_restJson1SortList(output.sort, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListViews = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AdvancedListView(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1AdvancedListWorkflowContext = (output, context) => {
    return {
        currentTimestamp: (output.currentTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.currentTimestamp))) : undefined,
        item: (output.item != null) ? deserializeAws_restJson1AdvancedListItemContext(output.item, context) : undefined,
        lastWorkflowExecution: (output.lastWorkflowExecution != null) ? deserializeAws_restJson1AdvancedListWorkflowExecution(output.lastWorkflowExecution, context) : undefined,
        list: (output.list != null) ? deserializeAws_restJson1AdvancedListContext(output.list, context) : undefined,
        oldItem: (output.oldItem != null) ? deserializeAws_restJson1AdvancedListItemContext(output.oldItem, context) : undefined,
        workflow: (output.workflow != null) ? deserializeAws_restJson1EntityWorkflow(output.workflow, context) : undefined,
        workflowExecution: (output.workflowExecution != null) ? deserializeAws_restJson1AdvancedListWorkflowExecution(output.workflowExecution, context) : undefined,
    };
};
const deserializeAws_restJson1AdvancedListWorkflowContextConfig = (output, context) => {
    return {
        itemRef: (output.itemRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.itemRef, context) : undefined,
        oldVersion: __expectString(output.oldVersion),
    };
};
const deserializeAws_restJson1AdvancedListWorkflowExecution = (output, context) => {
    return {
        actionTimestamp: (output.actionTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.actionTimestamp))) : undefined,
        contextCreationTimestamp: (output.contextCreationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.contextCreationTimestamp))) : undefined,
        evaluationTimestamp: (output.evaluationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.evaluationTimestamp))) : undefined,
        nowTimestamp: (output.nowTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.nowTimestamp))) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        runSeq: __expectInt32(output.runSeq),
        startTimestamp: (output.startTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTimestamp))) : undefined,
        workflowContextConfig: (output.workflowContextConfig != null) ? deserializeAws_restJson1AdvancedListWorkflowContextConfig(output.workflowContextConfig, context) : undefined,
        workflowMajorVersion: __expectInt32(output.workflowMajorVersion),
        workflowRef: (output.workflowRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.workflowRef, context) : undefined,
    };
};
const deserializeAws_restJson1ChoiceOption = (output, context) => {
    return {
        displayValue: __expectString(output.displayValue),
        key: __expectString(output.key),
    };
};
const deserializeAws_restJson1ChoiceOptionsList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ChoiceOption(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EditorList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1IdentityRef(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1FieldDefinition = (output, context) => {
    return {
        allowFreeTextOption: __expectBoolean(output.allowFreeTextOption),
        choiceOptions: (output.choiceOptions != null) ? deserializeAws_restJson1ChoiceOptionsList(output.choiceOptions, context) : undefined,
        dataType: __expectString(output.dataType),
        defaultChoiceKeys: (output.defaultChoiceKeys != null) ? deserializeAws_restJson1StringList(output.defaultChoiceKeys, context) : undefined,
        deprecated: __expectBoolean(output.deprecated),
        description: __expectString(output.description),
        displayName: __expectString(output.displayName),
        fieldKey: __expectString(output.fieldKey),
        required: __expectBoolean(output.required),
        sequenceStartValue: __expectLong(output.sequenceStartValue),
    };
};
const deserializeAws_restJson1FieldDefintionList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1FieldDefinition(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1ItemChoiceOption = (output, context) => {
    return {
        displayValue: __expectString(output.displayValue),
        key: __expectString(output.key),
    };
};
const deserializeAws_restJson1ItemHyperlink = (output, context) => {
    return {
        href: __expectString(output.href),
        title: __expectString(output.title),
    };
};
const deserializeAws_restJson1DocumentRef = (output, context) => {
    return {
        documentId: __expectString(output.documentId),
        indexRef: (output.indexRef != null) ? deserializeAws_restJson1IndexRef(output.indexRef, context) : undefined,
    };
};
const deserializeAws_restJson1IndexRef = (output, context) => {
    return {
        indexId: __expectString(output.indexId),
    };
};
const deserializeAws_restJson1BasicEntityWorkflowActorOutput_EMAIL = (output, context) => {
    return {
        body: __expectString(output.body),
        ccList: (output.ccList != null) ? deserializeAws_restJson1StringList(output.ccList, context) : undefined,
        subject: __expectString(output.subject),
        toList: (output.toList != null) ? deserializeAws_restJson1StringList(output.toList, context) : undefined,
    };
};
const deserializeAws_restJson1EntityAttachmentInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        desc: __expectString(output.desc),
        entityExtraInfo: (output.entityExtraInfo != null) ? deserializeAws_restJson1EntityExtraInfo(output.entityExtraInfo, context) : undefined,
        entityExtraRef: (output.entityExtraRef != null) ? deserializeAws_restJson1EntityExtraRef(output.entityExtraRef, context) : undefined,
        name: __expectString(output.name),
        s3Bucket: __expectString(output.s3Bucket),
        s3ObjectKey: __expectString(output.s3ObjectKey),
        s3ObjectVersion: __expectString(output.s3ObjectVersion),
        sizeInByte: __expectInt32(output.sizeInByte),
        type: __expectString(output.type),
    };
};
const deserializeAws_restJson1EntityExtraInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        payload: (output.payload != null) ? deserializeAws_restJson1Document(output.payload, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        versionInfo: (output.versionInfo != null) ? deserializeAws_restJson1VersionInfo(output.versionInfo, context) : undefined,
    };
};
const deserializeAws_restJson1EntityExtraRef = (output, context) => {
    return {
        entityRef: (output.entityRef != null) ? deserializeAws_restJson1EntityRef(output.entityRef, context) : undefined,
        extraId: __expectString(output.extraId),
        extraTypeId: __expectString(output.extraTypeId),
    };
};
const deserializeAws_restJson1EntityExtraVersionRef = (output, context) => {
    return {
        entityExtraRef: (output.entityExtraRef != null) ? deserializeAws_restJson1EntityExtraRef(output.entityExtraRef, context) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1EntityInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        deprecated: __expectBoolean(output.deprecated),
        ownerRef: (output.ownerRef != null) ? deserializeAws_restJson1IdentityRef(output.ownerRef, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1EntityVersionRef(output.ref, context) : undefined,
        versionInfo: (output.versionInfo != null) ? deserializeAws_restJson1VersionInfo(output.versionInfo, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRef = (output, context) => {
    return {
        entityId: __expectString(output.entityId),
        entityTypeRef: (output.entityTypeRef != null) ? deserializeAws_restJson1EntityTypeRef(output.entityTypeRef, context) : undefined,
        repositoryRef: (output.repositoryRef != null) ? deserializeAws_restJson1EntityRepositoryRef(output.repositoryRef, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRefList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityRef(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityVersionRef = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        entityRef: (output.entityRef != null) ? deserializeAws_restJson1EntityRef(output.entityRef, context) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1EntityWorkflow = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        actor: (output.actor != null) ? deserializeAws_restJson1EntityWorkflowActor(output.actor, context) : undefined,
        contextType: __expectString(output.contextType),
        desc: __expectString(output.desc),
        disabled: __expectBoolean(output.disabled),
        evaluator: (output.evaluator != null) ? deserializeAws_restJson1EntityWorkflowEvaluator(__expectUnion(output.evaluator), context) : undefined,
        executionHistoryDuration: (output.executionHistoryDuration != null) ? deserializeAws_restJson1Duration(output.executionHistoryDuration, context) : undefined,
        majorVersion: __expectInt32(output.majorVersion),
        name: __expectString(output.name),
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        variables: (output.variables != null) ? deserializeAws_restJson1VariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1EntityWorkflowActor = (output, context) => {
    return {
        key: __expectString(output.key),
        type: __expectString(output.type),
        variables: (output.variables != null) ? deserializeAws_restJson1VariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1EntityWorkflowEvaluator = (output, context) => {
    if (output.basic != null) {
        return {
            basic: deserializeAws_restJson1EntityWorkflowEvaluator_Basic(output.basic, context)
        };
    }
    if (output.composite != null) {
        return {
            composite: deserializeAws_restJson1EntityWorkflowEvaluator_Composite(output.composite, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const deserializeAws_restJson1EntityWorkflowEvaluator_Basic = (output, context) => {
    return {
        key: __expectString(output.key),
        type: __expectString(output.type),
        variables: (output.variables != null) ? deserializeAws_restJson1VariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1EntityWorkflowEvaluator_Composite = (output, context) => {
    return {
        evaluators: (output.evaluators != null) ? deserializeAws_restJson1EntityWorkflowEvaluatorList(output.evaluators, context) : undefined,
        join: __expectString(output.join),
    };
};
const deserializeAws_restJson1EntityWorkflowEvaluatorList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityWorkflowEvaluator(__expectUnion(entry), context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityWorkflowExecution = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        actionTimestamp: (output.actionTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.actionTimestamp))) : undefined,
        actorError: (output.actorError != null) ? deserializeAws_restJson1Document(output.actorError, context) : undefined,
        actorOutput: (output.actorOutput != null) ? deserializeAws_restJson1Document(output.actorOutput, context) : undefined,
        actorType: __expectString(output.actorType),
        contextCreationTimestamp: (output.contextCreationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.contextCreationTimestamp))) : undefined,
        contextCreatorError: (output.contextCreatorError != null) ? deserializeAws_restJson1Document(output.contextCreatorError, context) : undefined,
        contextCreatorOutput: (output.contextCreatorOutput != null) ? deserializeAws_restJson1Document(output.contextCreatorOutput, context) : undefined,
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        evaluationTimestamp: (output.evaluationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.evaluationTimestamp))) : undefined,
        evaluatorError: (output.evaluatorError != null) ? deserializeAws_restJson1Document(output.evaluatorError, context) : undefined,
        evaluatorOutput: __expectBoolean(output.evaluatorOutput),
        nowTimestamp: (output.nowTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.nowTimestamp))) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        runSeq: __expectInt32(output.runSeq),
        startTimestamp: (output.startTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTimestamp))) : undefined,
        status: __expectString(output.status),
        workflowContextConfig: (output.workflowContextConfig != null) ? deserializeAws_restJson1Document(output.workflowContextConfig, context) : undefined,
        workflowContextType: __expectString(output.workflowContextType),
        workflowMajorVersion: __expectInt32(output.workflowMajorVersion),
        workflowRef: (output.workflowRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.workflowRef, context) : undefined,
    };
};
const deserializeAws_restJson1EntityWorkflowExecutionList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityWorkflowExecution(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityWorkflowExecutionSearchItem = (output, context) => {
    return {
        actionTimestamp: (output.actionTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.actionTimestamp))) : undefined,
        actorType: __expectString(output.actorType),
        contextCreationTimestamp: (output.contextCreationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.contextCreationTimestamp))) : undefined,
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        evaluationTimestamp: (output.evaluationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.evaluationTimestamp))) : undefined,
        nowTimestamp: (output.nowTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.nowTimestamp))) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        runSeq: __expectInt32(output.runSeq),
        startTimestamp: (output.startTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTimestamp))) : undefined,
        status: __expectString(output.status),
        workflowContextConfig: (output.workflowContextConfig != null) ? deserializeAws_restJson1Document(output.workflowContextConfig, context) : undefined,
        workflowContextType: __expectString(output.workflowContextType),
        workflowMajorVersion: __expectInt32(output.workflowMajorVersion),
        workflowRef: (output.workflowRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.workflowRef, context) : undefined,
    };
};
const deserializeAws_restJson1EntityWorkflowExecutionSearchItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityWorkflowExecutionSearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityWorkflowList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityWorkflow(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityWorkflowSearchItem = (output, context) => {
    return {
        actor: (output.actor != null) ? deserializeAws_restJson1EntityWorkflowActor(output.actor, context) : undefined,
        contextType: __expectString(output.contextType),
        desc: __expectString(output.desc),
        disabled: __expectBoolean(output.disabled),
        executionHistoryDuration: (output.executionHistoryDuration != null) ? deserializeAws_restJson1Duration(output.executionHistoryDuration, context) : undefined,
        majorVersion: __expectInt32(output.majorVersion),
        name: __expectString(output.name),
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        variables: (output.variables != null) ? deserializeAws_restJson1VariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1EntityWorkflowSearchItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityWorkflowSearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1FlatEntityExtraInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1FlatEntityExtraRef(output.ref, context) : undefined,
        versionInfo: (output.versionInfo != null) ? deserializeAws_restJson1VersionInfo(output.versionInfo, context) : undefined,
    };
};
const deserializeAws_restJson1FlatEntityExtraRef = (output, context) => {
    return {
        entityRef: (output.entityRef != null) ? deserializeAws_restJson1FlatEntityRef(output.entityRef, context) : undefined,
        extraId: __expectString(output.extraId),
        extraTypeId: __expectString(output.extraTypeId),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1FlatEntityExtraRefList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1FlatEntityExtraRef(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1FlatEntityRef = (output, context) => {
    return {
        entityId: __expectString(output.entityId),
        entityTypeId: __expectString(output.entityTypeId),
        repositoryId: __expectString(output.repositoryId),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1Variable = (output, context) => {
    return {
        isDynamic: __expectBoolean(output.isDynamic),
        name: __expectString(output.name),
        tags: (output.tags != null) ? deserializeAws_restJson1Tags(output.tags, context) : undefined,
        value: __expectString(output.value),
    };
};
const deserializeAws_restJson1VariableList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Variable(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityRelationInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        _do_not_delete2: __expectString(output._do_not_delete2),
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        entityRef: (output.entityRef != null) ? deserializeAws_restJson1EntityRef(output.entityRef, context) : undefined,
        relatedEntityRef: (output.relatedEntityRef != null) ? deserializeAws_restJson1EntityRef(output.relatedEntityRef, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRelationInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityRelationInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1BasicEntityRepositoryWorkflowActorOutput_EMAIL = (output, context) => {
    return {
        body: __expectString(output.body),
        ccList: (output.ccList != null) ? deserializeAws_restJson1StringList(output.ccList, context) : undefined,
        subject: __expectString(output.subject),
        toList: (output.toList != null) ? deserializeAws_restJson1StringList(output.toList, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRepositoryEvaluator_Basic = (output, context) => {
    return {
        key: __expectString(output.key),
        type: __expectString(output.type),
        variables: (output.variables != null) ? deserializeAws_restJson1EntityRepositoryWorkflowVariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRepositoryEvaluator_Composite = (output, context) => {
    return {
        evaluators: (output.evaluators != null) ? deserializeAws_restJson1EntityRepositoryWorkflowEvaluatorList(output.evaluators, context) : undefined,
        join: __expectString(output.join),
    };
};
const deserializeAws_restJson1EntityRepositoryInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        desc: __expectString(output.desc),
        name: __expectString(output.name),
        ownerRef: (output.ownerRef != null) ? deserializeAws_restJson1IdentityRef(output.ownerRef, context) : undefined,
        payload: (output.payload != null) ? deserializeAws_restJson1Document(output.payload, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1EntityRepositoryVersionRef(output.ref, context) : undefined,
        versionInfo: (output.versionInfo != null) ? deserializeAws_restJson1VersionInfo(output.versionInfo, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRepositoryInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityRepositoryInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityRepositoryRef = (output, context) => {
    return {
        repositoryId: __expectString(output.repositoryId),
    };
};
const deserializeAws_restJson1EntityRepositoryRolePermission = (output, context) => {
    return {
        entityTypeId: __expectString(output.entityTypeId),
        permissionName: __expectString(output.permissionName),
    };
};
const deserializeAws_restJson1EntityRepositoryRolePermissions = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityRepositoryRolePermission(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityRepositoryVersionRef = (output, context) => {
    return {
        entityRepositoryRef: (output.entityRepositoryRef != null) ? deserializeAws_restJson1EntityRepositoryRef(output.entityRepositoryRef, context) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1EntityRepositoryWorkflowActor = (output, context) => {
    return {
        key: __expectString(output.key),
        type: __expectString(output.type),
        variables: (output.variables != null) ? deserializeAws_restJson1EntityRepositoryWorkflowVariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1EntityRepositoryWorkflowEvaluator = (output, context) => {
    if (output.basic != null) {
        return {
            basic: deserializeAws_restJson1EntityRepositoryEvaluator_Basic(output.basic, context)
        };
    }
    if (output.composite != null) {
        return {
            composite: deserializeAws_restJson1EntityRepositoryEvaluator_Composite(output.composite, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const deserializeAws_restJson1EntityRepositoryWorkflowEvaluatorList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityRepositoryWorkflowEvaluator(__expectUnion(entry), context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityRepositoryWorkflowVariable = (output, context) => {
    return {
        isDynamic: __expectBoolean(output.isDynamic),
        name: __expectString(output.name),
        tags: (output.tags != null) ? deserializeAws_restJson1Tags(output.tags, context) : undefined,
        value: __expectString(output.value),
    };
};
const deserializeAws_restJson1EntityRepositoryWorkflowVariableList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1EntityRepositoryWorkflowVariable(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1EntityTypeRef = (output, context) => {
    return {
        entityTypeId: __expectString(output.entityTypeId),
    };
};
const deserializeAws_restJson1IdentityRef = (output, context) => {
    return {
        id: __expectString(output.id),
        realm: __expectString(output.realm),
        type: __expectString(output.type),
    };
};
const deserializeAws_restJson1IdentityRefList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1IdentityRef(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1BatchOperationInstanceResourceList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchOpreationInstanceResource(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1BatchOpreationInstanceResource = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        resourceId: __expectString(output.resourceId),
    };
};
const deserializeAws_restJson1InstanceAllowedTeamInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        desc: __expectString(output.desc),
        entityRef: (output.entityRef != null) ? deserializeAws_restJson1EntityRef(output.entityRef, context) : undefined,
        identityRef: (output.identityRef != null) ? deserializeAws_restJson1IdentityRef(output.identityRef, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1InstanceAllowedTeamRef(output.ref, context) : undefined,
        roleRef: (output.roleRef != null) ? deserializeAws_restJson1InstanceRoleRef(output.roleRef, context) : undefined,
    };
};
const deserializeAws_restJson1InstanceAllowedTeamInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1InstanceAllowedTeamInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1InstanceAllowedTeamRef = (output, context) => {
    return {
        allowedTeamId: __expectString(output.allowedTeamId),
        instanceId: __expectString(output.instanceId),
    };
};
const deserializeAws_restJson1InstanceAuthzInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        desc: __expectString(output.desc),
        entityRef: (output.entityRef != null) ? deserializeAws_restJson1EntityRef(output.entityRef, context) : undefined,
        identityRef: (output.identityRef != null) ? deserializeAws_restJson1IdentityRef(output.identityRef, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1InstanceAuthzRef(output.ref, context) : undefined,
        resourceIdentifier: __expectString(output.resourceIdentifier),
        roleRef: (output.roleRef != null) ? deserializeAws_restJson1InstanceRoleRef(output.roleRef, context) : undefined,
    };
};
const deserializeAws_restJson1InstanceAuthzInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1InstanceAuthzInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1InstanceAuthzRef = (output, context) => {
    return {
        authzId: __expectString(output.authzId),
        instanceId: __expectString(output.instanceId),
    };
};
const deserializeAws_restJson1InstancePayload = (output, context) => {
    return {
        guidianceLink: __expectString(output.guidianceLink),
        moduleConfigurations: (output.moduleConfigurations != null) ? deserializeAws_restJson1ModuleConfigurationList(output.moduleConfigurations, context) : undefined,
        modules: (output.modules != null) ? deserializeAws_restJson1ModuleList(output.modules, context) : undefined,
    };
};
const deserializeAws_restJson1InstanceRoleInfo = (output, context) => {
    return {
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        desc: __expectString(output.desc),
        name: __expectString(output.name),
        permissions: (output.permissions != null) ? deserializeAws_restJson1EntityRepositoryRolePermissions(output.permissions, context) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1InstanceRoleRef(output.ref, context) : undefined,
        versionInfo: (output.versionInfo != null) ? deserializeAws_restJson1VersionInfo(output.versionInfo, context) : undefined,
    };
};
const deserializeAws_restJson1InstanceRoleInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1InstanceRoleInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1InstanceRoleRef = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        roleId: __expectString(output.roleId),
    };
};
const deserializeAws_restJson1MatterCustomField = (output, context) => {
    return {
        key: __expectString(output.key),
        name: __expectString(output.name),
        required: __expectBoolean(output.required),
        sequenceNumber: __expectInt32(output.sequenceNumber),
        type: __expectString(output.type),
    };
};
const deserializeAws_restJson1MatterCustomFieldList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterCustomField(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1ModuleConfiguration = (output, context) => {
    return {
        __do_not_delete: (output.__do_not_delete != null) ? deserializeAws_restJson1Source2ModuleConfiguration(output.__do_not_delete, context) : undefined,
        configuration: (output.configuration != null) ? deserializeAws_restJson1Document(output.configuration, context) : undefined,
        moduleName: __expectString(output.moduleName),
    };
};
const deserializeAws_restJson1ModuleConfigurationList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ModuleConfiguration(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1ModuleList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return __expectString(entry);
    });
    return retVal;
};
const deserializeAws_restJson1Source2ModuleConfiguration = (output, context) => {
    return {
        enableLabels: __expectBoolean(output.enableLabels),
        enableMatterCustomFields: __expectBoolean(output.enableMatterCustomFields),
        hideDeprecatedTopics: __expectBoolean(output.hideDeprecatedTopics),
        matterCustomFields: (output.matterCustomFields != null) ? deserializeAws_restJson1MatterCustomFieldList(output.matterCustomFields, context) : undefined,
        matterOwnerInactiveWorkflowRef: (output.matterOwnerInactiveWorkflowRef != null) ? deserializeAws_restJson1MatterInstanceWorkflowRef(output.matterOwnerInactiveWorkflowRef, context) : undefined,
        matterRefreshWorkflowRef: (output.matterRefreshWorkflowRef != null) ? deserializeAws_restJson1MatterInstanceWorkflowRef(output.matterRefreshWorkflowRef, context) : undefined,
    };
};
const deserializeAws_restJson1UserItemInfo = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        instanceId: __expectString(output.instanceId),
        itemId: __expectString(output.itemId),
        itemName: __expectString(output.itemName),
        itemType: __expectString(output.itemType),
        itemValue: __expectString(output.itemValue),
        ownerUserId: __expectString(output.ownerUserId),
    };
};
const deserializeAws_restJson1UserItemInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1UserItemInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1LabelInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        description: __expectString(output.description),
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        name: __expectString(output.name),
    };
};
const deserializeAws_restJson1LabelInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1LabelInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1CountryData2 = (output, context) => {
    return {
        subLocations: (output.subLocations != null) ? deserializeAws_restJson1SubLocationList(output.subLocations, context) : undefined,
    };
};
const deserializeAws_restJson1LocationData = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        countryData: (output.countryData != null) ? deserializeAws_restJson1CountryData2(output.countryData, context) : undefined,
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        locationType: __expectString(output.locationType),
        name: __expectString(output.name),
        unionData: (output.unionData != null) ? deserializeAws_restJson1UnionData2(output.unionData, context) : undefined,
    };
};
const deserializeAws_restJson1LocationList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1LocationData(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1SubLocation = (output, context) => {
    return {
        deprecated: __expectBoolean(output.deprecated),
        key: __expectString(output.key),
        name: __expectString(output.name),
    };
};
const deserializeAws_restJson1SubLocationList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SubLocation(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1UnionData2 = (output, context) => {
    return {
        countries: (output.countries != null) ? deserializeAws_restJson1EntityRefList(output.countries, context) : undefined,
        deprecated: __expectBoolean(output.deprecated),
    };
};
const deserializeAws_restJson1AccessRecord = (output, context) => {
    return {
        identityRef: (output.identityRef != null) ? deserializeAws_restJson1IdentityRef(output.identityRef, context) : undefined,
        instanceAllowedTeamRef: (output.instanceAllowedTeamRef != null) ? deserializeAws_restJson1InstanceAllowedTeamRef(output.instanceAllowedTeamRef, context) : undefined,
    };
};
const deserializeAws_restJson1AccessRecordList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1AccessRecord(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1CompactMatter = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        draftContent: (output.draftContent != null) ? deserializeAws_restJson1CompactMatterDraftContent(output.draftContent, context) : undefined,
        id: __expectString(output.id),
        instanceId: __expectString(output.instanceId),
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
        publishedContent: (output.publishedContent != null) ? deserializeAws_restJson1CompactMatterPublishedContent(output.publishedContent, context) : undefined,
        status: __expectString(output.status),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1CompactMatterContentBody = (output, context) => {
    return {
        customDateFieldList: (output.customDateFieldList != null) ? deserializeAws_restJson1MatterCustomDateFieldList(output.customDateFieldList, context) : undefined,
        name: __expectString(output.name),
        refreshDate: (output.refreshDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.refreshDate))) : undefined,
    };
};
const deserializeAws_restJson1CompactMatterContext = (output, context) => {
    return {
        compactMatter: (output.compactMatter != null) ? deserializeAws_restJson1CompactMatter(output.compactMatter, context) : undefined,
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
    };
};
const deserializeAws_restJson1CompactMatterDraftContent = (output, context) => {
    return {
        body: (output.body != null) ? deserializeAws_restJson1CompactMatterContentBody(output.body, context) : undefined,
        by: (output.by != null) ? deserializeAws_restJson1IdentityRef(output.by, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        majorVersion: __expectString(output.majorVersion),
        minorVersion: __expectString(output.minorVersion),
        modifyType: __expectString(output.modifyType),
    };
};
const deserializeAws_restJson1CompactMatterPublishedContent = (output, context) => {
    return {
        body: (output.body != null) ? deserializeAws_restJson1CompactMatterContentBody(output.body, context) : undefined,
        by: (output.by != null) ? deserializeAws_restJson1IdentityRef(output.by, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1Matter = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        __do_not_delete2: __expectString(output.__do_not_delete2),
        __do_not_delete3: (output.__do_not_delete3 != null) ? deserializeAws_restJson1MatterDomainEvent(output.__do_not_delete3, context) : undefined,
        draftContent: (output.draftContent != null) ? deserializeAws_restJson1MatterDraftContent(output.draftContent, context) : undefined,
        id: __expectString(output.id),
        instanceId: __expectString(output.instanceId),
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
        publishedContent: (output.publishedContent != null) ? deserializeAws_restJson1MatterPublishedContent(output.publishedContent, context) : undefined,
        status: __expectString(output.status),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1MatterChatLastReadMessageItem = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        instanceId: __expectString(output.instanceId),
        lastDismissedMessageVersion: __expectInt32(output.lastDismissedMessageVersion),
        matterId: __expectString(output.matterId),
        messageVersion: __expectInt32(output.messageVersion),
        notificationActive: __expectBoolean(output.notificationActive),
        notificationActiveDate: (output.notificationActiveDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.notificationActiveDate))) : undefined,
        questionKey: __expectString(output.questionKey),
        user: (output.user != null) ? deserializeAws_restJson1IdentityRef(output.user, context) : undefined,
    };
};
const deserializeAws_restJson1MatterChatLastReadMessageItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterChatLastReadMessageItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterChatMessage = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        deleted: __expectBoolean(output.deleted),
        editVersion: __expectString(output.editVersion),
        engagementRef: (output.engagementRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.engagementRef, context) : undefined,
        instanceId: __expectString(output.instanceId),
        matterId: __expectString(output.matterId),
        messageBody: __expectString(output.messageBody),
        messageVersion: __expectInt32(output.messageVersion),
        ocFirmId: __expectString(output.ocFirmId),
        questionKey: __expectString(output.questionKey),
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        sendDate: (output.sendDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.sendDate))) : undefined,
        sender: (output.sender != null) ? deserializeAws_restJson1IdentityRef(output.sender, context) : undefined,
    };
};
const deserializeAws_restJson1MatterChatMessageSearchItem = (output, context) => {
    return {
        deleted: __expectBoolean(output.deleted),
        editVersion: __expectString(output.editVersion),
        engagementRef: (output.engagementRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.engagementRef, context) : undefined,
        instanceId: __expectString(output.instanceId),
        matterId: __expectString(output.matterId),
        messageBody: __expectString(output.messageBody),
        messageVersion: __expectInt32(output.messageVersion),
        ocFirmId: __expectString(output.ocFirmId),
        questionKey: __expectString(output.questionKey),
        ref: (output.ref != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ref, context) : undefined,
        sendDate: (output.sendDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.sendDate))) : undefined,
        sender: (output.sender != null) ? deserializeAws_restJson1IdentityRef(output.sender, context) : undefined,
    };
};
const deserializeAws_restJson1MatterChatMessageSearchItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterChatMessageSearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterContentBody = (output, context) => {
    return {
        backgroundAccessList: (output.backgroundAccessList != null) ? deserializeAws_restJson1AccessRecordList(output.backgroundAccessList, context) : undefined,
        backgroundDownloadUrl: __expectString(output.backgroundDownloadUrl),
        clientFacingFiles: (output.clientFacingFiles != null) ? deserializeAws_restJson1MatterFiles(output.clientFacingFiles, context) : undefined,
        clientFacingFolders: (output.clientFacingFolders != null) ? deserializeAws_restJson1MatterFolders(output.clientFacingFolders, context) : undefined,
        clientFileAccessList: (output.clientFileAccessList != null) ? deserializeAws_restJson1AccessRecordList(output.clientFileAccessList, context) : undefined,
        customDateFieldList: (output.customDateFieldList != null) ? deserializeAws_restJson1MatterCustomDateFieldList(output.customDateFieldList, context) : undefined,
        highlyConfidential: __expectBoolean(output.highlyConfidential),
        highlyConfidentialAccessList: (output.highlyConfidentialAccessList != null) ? deserializeAws_restJson1AccessRecordList(output.highlyConfidentialAccessList, context) : undefined,
        legalOnlyFiles: (output.legalOnlyFiles != null) ? deserializeAws_restJson1MatterFiles(output.legalOnlyFiles, context) : undefined,
        legalOnlyFolders: (output.legalOnlyFolders != null) ? deserializeAws_restJson1MatterFolders(output.legalOnlyFolders, context) : undefined,
        locations: (output.locations != null) ? deserializeAws_restJson1MatterLocationList(output.locations, context) : undefined,
        name: __expectString(output.name),
        questionAccessMap: (output.questionAccessMap != null) ? deserializeAws_restJson1QuestionAccessMap(output.questionAccessMap, context) : undefined,
        questionAssignments: (output.questionAssignments != null) ? deserializeAws_restJson1QuestionAssignmentList(output.questionAssignments, context) : undefined,
        questionLabelMap: (output.questionLabelMap != null) ? deserializeAws_restJson1QuestionLabelMap(output.questionLabelMap, context) : undefined,
        questionLegalNotes: (output.questionLegalNotes != null) ? deserializeAws_restJson1QuestionLegalNoteList(output.questionLegalNotes, context) : undefined,
        questions: (output.questions != null) ? deserializeAws_restJson1MatterQuestions(output.questions, context) : undefined,
        refreshDate: (output.refreshDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.refreshDate))) : undefined,
        topics: (output.topics != null) ? deserializeAws_restJson1MatterTopicList(output.topics, context) : undefined,
    };
};
const deserializeAws_restJson1MatterCustomDateField = (output, context) => {
    return {
        key: __expectString(output.key),
        sequenceNumber: __expectInt32(output.sequenceNumber),
        value: (output.value != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.value))) : undefined,
    };
};
const deserializeAws_restJson1MatterCustomDateFieldList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterCustomDateField(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterDomainEvent = (output, context) => {
    return {
        eventData: (output.eventData != null) ? deserializeAws_restJson1MatterDomainEventData(__expectUnion(output.eventData), context) : undefined,
        eventType: __expectString(output.eventType),
        matterName: __expectString(output.matterName),
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1EntityVersionRef(output.matterRef, context) : undefined,
    };
};
const deserializeAws_restJson1MatterDomainEventData = (output, context) => {
    if (output.ocEngagementClosed != null) {
        return {
            ocEngagementClosed: deserializeAws_restJson1MatterOCEngagmentClosedEventData(output.ocEngagementClosed, context)
        };
    }
    if (output.ocEngagementReassigned != null) {
        return {
            ocEngagementReassigned: deserializeAws_restJson1MatterOCEngagementReassignedEventData(output.ocEngagementReassigned, context)
        };
    }
    if (output.ocEngagementStarted != null) {
        return {
            ocEngagementStarted: deserializeAws_restJson1MatterOCEngagmentStartedEventData(output.ocEngagementStarted, context)
        };
    }
    if (output.ocEngagementSubmitted != null) {
        return {
            ocEngagementSubmitted: deserializeAws_restJson1MatterOCEngagementSubmittedEventData(output.ocEngagementSubmitted, context)
        };
    }
    if (output.ownerInactive != null) {
        return {
            ownerInactive: deserializeAws_restJson1MatterOwnerValidationEventData(output.ownerInactive, context)
        };
    }
    if (output.ownerReassigned != null) {
        return {
            ownerReassigned: deserializeAws_restJson1MatterOwnerReassignedEventData(output.ownerReassigned, context)
        };
    }
    if (output.questionAssigned != null) {
        return {
            questionAssigned: deserializeAws_restJson1MatterQuestionAssignedEventData(output.questionAssigned, context)
        };
    }
    if (output.refreshDateReached != null) {
        return {
            refreshDateReached: deserializeAws_restJson1MatterRefreshDateReachedEventData(output.refreshDateReached, context)
        };
    }
    return { $unknown: Object.entries(output)[0] };
};
const deserializeAws_restJson1MatterDraftContent = (output, context) => {
    return {
        body: (output.body != null) ? deserializeAws_restJson1MatterContentBody(output.body, context) : undefined,
        by: (output.by != null) ? deserializeAws_restJson1IdentityRef(output.by, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        majorVersion: __expectString(output.majorVersion),
        minorVersion: __expectString(output.minorVersion),
        modifyType: __expectString(output.modifyType),
    };
};
const deserializeAws_restJson1MatterDraftContentFileInfo = (output, context) => {
    return {
        entityAttachmentInfo: (output.entityAttachmentInfo != null) ? deserializeAws_restJson1EntityAttachmentInfo(output.entityAttachmentInfo, context) : undefined,
        fileType: __expectString(output.fileType),
        instanceId: __expectString(output.instanceId),
        key: __expectString(output.key),
        matterId: __expectString(output.matterId),
    };
};
const deserializeAws_restJson1MatterDraftContentFileInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterDraftContentFileInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterDraftContentHistory = (output, context) => {
    return {
        majorVersion: __expectString(output.majorVersion),
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1EntityVersionRef(output.matterRef, context) : undefined,
        minorVersion: __expectString(output.minorVersion),
        modifiedBy: (output.modifiedBy != null) ? deserializeAws_restJson1IdentityRef(output.modifiedBy, context) : undefined,
        modifiedDate: (output.modifiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.modifiedDate))) : undefined,
        modifyType: __expectString(output.modifyType),
    };
};
const deserializeAws_restJson1MatterDraftContentHistoryList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterDraftContentHistory(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterFile = (output, context) => {
    return {
        entityAttachmentVersionRef: (output.entityAttachmentVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityAttachmentVersionRef, context) : undefined,
        key: __expectString(output.key),
    };
};
const deserializeAws_restJson1MatterFiles = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterFile(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterFolder = (output, context) => {
    return {
        fileKeys: (output.fileKeys != null) ? deserializeAws_restJson1StringList(output.fileKeys, context) : undefined,
        folderName: __expectString(output.folderName),
        key: __expectString(output.key),
    };
};
const deserializeAws_restJson1MatterFolders = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterFolder(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterInstanceWorkflow = (output, context) => {
    return {
        actor: (output.actor != null) ? deserializeAws_restJson1EntityRepositoryWorkflowActor(output.actor, context) : undefined,
        desc: __expectString(output.desc),
        disabled: __expectBoolean(output.disabled),
        evaluator: (output.evaluator != null) ? deserializeAws_restJson1EntityRepositoryWorkflowEvaluator(__expectUnion(output.evaluator), context) : undefined,
        executionHistoryDuration: (output.executionHistoryDuration != null) ? deserializeAws_restJson1Duration(output.executionHistoryDuration, context) : undefined,
        majorVersion: __expectInt32(output.majorVersion),
        name: __expectString(output.name),
        ref: (output.ref != null) ? deserializeAws_restJson1MatterInstanceWorkflowRef(output.ref, context) : undefined,
        triggeredBy: __expectString(output.triggeredBy),
        variables: (output.variables != null) ? deserializeAws_restJson1EntityRepositoryWorkflowVariableList(output.variables, context) : undefined,
    };
};
const deserializeAws_restJson1MatterInstanceWorkflowContext = (output, context) => {
    return {
        currentTimestamp: (output.currentTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.currentTimestamp))) : undefined,
        lastWorkflowExecution: (output.lastWorkflowExecution != null) ? deserializeAws_restJson1MatterInstanceWorkflowExecution(output.lastWorkflowExecution, context) : undefined,
        matter: (output.matter != null) ? deserializeAws_restJson1CompactMatterContext(output.matter, context) : undefined,
        oldMatter: (output.oldMatter != null) ? deserializeAws_restJson1CompactMatterContext(output.oldMatter, context) : undefined,
        workflow: (output.workflow != null) ? deserializeAws_restJson1MatterInstanceWorkflow(output.workflow, context) : undefined,
        workflowExecution: (output.workflowExecution != null) ? deserializeAws_restJson1MatterInstanceWorkflowExecution(output.workflowExecution, context) : undefined,
    };
};
const deserializeAws_restJson1MatterInstanceWorkflowExecution = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        __do_not_delete2: __expectString(output.__do_not_delete2),
        __do_not_delete3: (output.__do_not_delete3 != null) ? deserializeAws_restJson1MatterWorkflowActorOutput_REFRESH_EVENT(output.__do_not_delete3, context) : undefined,
        __do_not_delete4: __expectString(output.__do_not_delete4),
        __do_not_delete5: (output.__do_not_delete5 != null) ? deserializeAws_restJson1MatterWorkflowActorOutput_MATTER_OWNER_INACTIVE_EVENT(output.__do_not_delete5, context) : undefined,
        actionTimestamp: (output.actionTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.actionTimestamp))) : undefined,
        contextCreationTimestamp: (output.contextCreationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.contextCreationTimestamp))) : undefined,
        evaluationTimestamp: (output.evaluationTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.evaluationTimestamp))) : undefined,
        evaluatorOutput: __expectBoolean(output.evaluatorOutput),
        executionCreationContext: (output.executionCreationContext != null) ? deserializeAws_restJson1MatterWorkflowExecutionCreationContext(output.executionCreationContext, context) : undefined,
        nowTimestamp: (output.nowTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.nowTimestamp))) : undefined,
        ref: (output.ref != null) ? deserializeAws_restJson1MatterInstanceWorkflowExecutionRef(output.ref, context) : undefined,
        runSequenceNumber: __expectInt32(output.runSequenceNumber),
        startTimestamp: (output.startTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startTimestamp))) : undefined,
        status: __expectString(output.status),
        workflowMajorVersion: __expectInt32(output.workflowMajorVersion),
        workflowRef: (output.workflowRef != null) ? deserializeAws_restJson1MatterInstanceWorkflowRef(output.workflowRef, context) : undefined,
    };
};
const deserializeAws_restJson1MatterInstanceWorkflowExecutionList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterInstanceWorkflowExecution(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterInstanceWorkflowExecutionRef = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        version: __expectString(output.version),
        workflowExecutionId: __expectString(output.workflowExecutionId),
    };
};
const deserializeAws_restJson1MatterInstanceWorkflowList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterInstanceWorkflow(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterInstanceWorkflowRef = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        version: __expectString(output.version),
        workflowId: __expectString(output.workflowId),
    };
};
const deserializeAws_restJson1MatterLocation = (output, context) => {
    return {
        type: __expectString(output.type),
        value: (output.value != null) ? deserializeAws_restJson1MatterLocationValue(output.value, context) : undefined,
    };
};
const deserializeAws_restJson1MatterLocationList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterLocation(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterLocationValue = (output, context) => {
    return {
        locationRef: (output.locationRef != null) ? deserializeAws_restJson1EntityRef(output.locationRef, context) : undefined,
        subCountryKey: __expectString(output.subCountryKey),
    };
};
const deserializeAws_restJson1MatterOCEngagement = (output, context) => {
    return {
        detail: (output.detail != null) ? deserializeAws_restJson1MatterOCEngagementDetail(output.detail, context) : undefined,
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
        questionKey: __expectString(output.questionKey),
    };
};
const deserializeAws_restJson1MatterOCEngagementDetail = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        engagedBy: (output.engagedBy != null) ? deserializeAws_restJson1IdentityRef(output.engagedBy, context) : undefined,
        lastUpdatedBy: (output.lastUpdatedBy != null) ? deserializeAws_restJson1IdentityRef(output.lastUpdatedBy, context) : undefined,
        lastUpdatedDate: (output.lastUpdatedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedDate))) : undefined,
        ocFirmId: __expectString(output.ocFirmId),
        ocId: (output.ocId != null) ? deserializeAws_restJson1OCUserOrGroupId(__expectUnion(output.ocId), context) : undefined,
        startDate: (output.startDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startDate))) : undefined,
        status: __expectString(output.status),
    };
};
const deserializeAws_restJson1MatterOCEngagementReassignedEventData = (output, context) => {
    return {
        newOCFirmId: __expectString(output.newOCFirmId),
        newOCId: (output.newOCId != null) ? deserializeAws_restJson1OCUserOrGroupId(__expectUnion(output.newOCId), context) : undefined,
        oldOCFirmId: __expectString(output.oldOCFirmId),
        oldOCId: (output.oldOCId != null) ? deserializeAws_restJson1OCUserOrGroupId(__expectUnion(output.oldOCId), context) : undefined,
        questionKey: __expectString(output.questionKey),
        reassignedAt: (output.reassignedAt != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.reassignedAt))) : undefined,
        reassignedBy: (output.reassignedBy != null) ? deserializeAws_restJson1IdentityRef(output.reassignedBy, context) : undefined,
    };
};
const deserializeAws_restJson1MatterOCEngagementSubmittedEventData = (output, context) => {
    return {
        questionKey: __expectString(output.questionKey),
        submittedAt: (output.submittedAt != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.submittedAt))) : undefined,
        submittedBy: (output.submittedBy != null) ? deserializeAws_restJson1IdentityRef(output.submittedBy, context) : undefined,
    };
};
const deserializeAws_restJson1MatterOCEngagmentClosedEventData = (output, context) => {
    return {
        closedAt: (output.closedAt != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.closedAt))) : undefined,
        closedBy: (output.closedBy != null) ? deserializeAws_restJson1IdentityRef(output.closedBy, context) : undefined,
        ocRef: (output.ocRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ocRef, context) : undefined,
        questionKey: __expectString(output.questionKey),
    };
};
const deserializeAws_restJson1MatterOCEngagmentStartedEventData = (output, context) => {
    return {
        ocRef: (output.ocRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.ocRef, context) : undefined,
        questionKey: __expectString(output.questionKey),
        startedAt: (output.startedAt != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.startedAt))) : undefined,
        startedBy: (output.startedBy != null) ? deserializeAws_restJson1IdentityRef(output.startedBy, context) : undefined,
    };
};
const deserializeAws_restJson1MatterOwnerReassignedEventData = (output, context) => {
    return {
        matterName: __expectString(output.matterName),
        newOwner: (output.newOwner != null) ? deserializeAws_restJson1IdentityRef(output.newOwner, context) : undefined,
        previousOwner: (output.previousOwner != null) ? deserializeAws_restJson1IdentityRef(output.previousOwner, context) : undefined,
    };
};
const deserializeAws_restJson1MatterOwnerValidationEventData = (output, context) => {
    return {
        matterName: __expectString(output.matterName),
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
    };
};
const deserializeAws_restJson1MatterPublishedContent = (output, context) => {
    return {
        body: (output.body != null) ? deserializeAws_restJson1MatterContentBody(output.body, context) : undefined,
        by: (output.by != null) ? deserializeAws_restJson1IdentityRef(output.by, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1MatterPublishedContentHistory = (output, context) => {
    return {
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1EntityVersionRef(output.matterRef, context) : undefined,
        publishDate: (output.publishDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.publishDate))) : undefined,
        publishedBy: (output.publishedBy != null) ? deserializeAws_restJson1IdentityRef(output.publishedBy, context) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1MatterPublishedContentHistoryList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterPublishedContentHistory(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterQuestion = (output, context) => {
    return {
        key: __expectString(output.key),
        sourceInfoForQuestionList: (output.sourceInfoForQuestionList != null) ? deserializeAws_restJson1MatterQuestionSourceInfoForQuestionList(output.sourceInfoForQuestionList, context) : undefined,
        sourceType: __expectString(output.sourceType),
    };
};
const deserializeAws_restJson1MatterQuestionAssignedEventData = (output, context) => {
    return {
        assignedBy: (output.assignedBy != null) ? deserializeAws_restJson1IdentityRef(output.assignedBy, context) : undefined,
        assignedDate: (output.assignedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.assignedDate))) : undefined,
        matterName: __expectString(output.matterName),
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
        questionAssignment: (output.questionAssignment != null) ? deserializeAws_restJson1QuestionAssignment(output.questionAssignment, context) : undefined,
    };
};
const deserializeAws_restJson1MatterQuestions = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterQuestion(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterQuestionSourceInfoForQuestionList = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        questionKey: __expectString(output.questionKey),
        questionListId: __expectString(output.questionListId),
        questionListVersion: __expectString(output.questionListVersion),
    };
};
const deserializeAws_restJson1MatterRef = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        matterId: __expectString(output.matterId),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1MatterRefreshDateReachedEventData = (output, context) => {
    return {
        matterName: __expectString(output.matterName),
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
        refreshDate: (output.refreshDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.refreshDate))) : undefined,
    };
};
const deserializeAws_restJson1MatterSearchItemNew = (output, context) => {
    return {
        backgroundAccessList: (output.backgroundAccessList != null) ? deserializeAws_restJson1AccessRecordList(output.backgroundAccessList, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        customDateFieldList: (output.customDateFieldList != null) ? deserializeAws_restJson1MatterCustomDateFieldList(output.customDateFieldList, context) : undefined,
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        deprecated: __expectBoolean(output.deprecated),
        documentId: __expectString(output.documentId),
        highlyConfidential: __expectBoolean(output.highlyConfidential),
        identityRefAllowList: (output.identityRefAllowList != null) ? deserializeAws_restJson1IdentityRefList(output.identityRefAllowList, context) : undefined,
        instanceId: __expectString(output.instanceId),
        lastModfiedDate: (output.lastModfiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModfiedDate))) : undefined,
        locations: (output.locations != null) ? deserializeAws_restJson1MatterLocationList(output.locations, context) : undefined,
        matterId: __expectString(output.matterId),
        matterName: __expectString(output.matterName),
        ocAccessList: (output.ocAccessList != null) ? deserializeAws_restJson1AccessRecordList(output.ocAccessList, context) : undefined,
        ocFirmIds: (output.ocFirmIds != null) ? deserializeAws_restJson1StringList(output.ocFirmIds, context) : undefined,
        ocGroupIds: (output.ocGroupIds != null) ? deserializeAws_restJson1StringList(output.ocGroupIds, context) : undefined,
        ocUserIds: (output.ocUserIds != null) ? deserializeAws_restJson1StringList(output.ocUserIds, context) : undefined,
        ownerRef: (output.ownerRef != null) ? deserializeAws_restJson1IdentityRef(output.ownerRef, context) : undefined,
        pendingActionStatus: __expectString(output.pendingActionStatus),
        publishDate: (output.publishDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.publishDate))) : undefined,
        questionAssignments: (output.questionAssignments != null) ? deserializeAws_restJson1QuestionAssignmentList(output.questionAssignments, context) : undefined,
        questionLabels: (output.questionLabels != null) ? deserializeAws_restJson1QuestionLabelList(output.questionLabels, context) : undefined,
        refreshDate: (output.refreshDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.refreshDate))) : undefined,
        status: __expectString(output.status),
        topics: (output.topics != null) ? deserializeAws_restJson1MatterTopicList(output.topics, context) : undefined,
    };
};
const deserializeAws_restJson1MatterSearchItemNewList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterSearchItemNew(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterSmartSearchAttributes = (output, context) => {
    return {
        customDateFieldList: (output.customDateFieldList != null) ? deserializeAws_restJson1MatterCustomDateFieldList(output.customDateFieldList, context) : undefined,
        fileKey: __expectString(output.fileKey),
        highlyConfidential: __expectBoolean(output.highlyConfidential),
        identityRefAllowList: (output.identityRefAllowList != null) ? deserializeAws_restJson1IdentityRefList(output.identityRefAllowList, context) : undefined,
        instanceId: __expectString(output.instanceId),
        lastModifiedDate: (output.lastModifiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate))) : undefined,
        legalOnly: __expectBoolean(output.legalOnly),
        locations: (output.locations != null) ? deserializeAws_restJson1MatterLocationList(output.locations, context) : undefined,
        matterId: __expectString(output.matterId),
        publishDate: (output.publishDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.publishDate))) : undefined,
        published: __expectBoolean(output.published),
        publishedBy: (output.publishedBy != null) ? deserializeAws_restJson1IdentityRef(output.publishedBy, context) : undefined,
        questionKey: __expectString(output.questionKey),
        questionLabels: (output.questionLabels != null) ? deserializeAws_restJson1QuestionLabelList(output.questionLabels, context) : undefined,
        refreshDate: (output.refreshDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.refreshDate))) : undefined,
        topics: (output.topics != null) ? deserializeAws_restJson1MatterTopicList(output.topics, context) : undefined,
        type: __expectString(output.type),
    };
};
const deserializeAws_restJson1MatterSmartSearchResultItem = (output, context) => {
    return {
        attributes: (output.attributes != null) ? deserializeAws_restJson1MatterSmartSearchAttributes(output.attributes, context) : undefined,
        excerpt: __expectString(output.excerpt),
        id: __expectString(output.id),
        resultId: __expectString(output.resultId),
        title: __expectString(output.title),
        type: __expectString(output.type),
    };
};
const deserializeAws_restJson1MatterSmartSearchResultItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterSmartSearchResultItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterTopic = (output, context) => {
    return {
        subTopicKey: __expectString(output.subTopicKey),
        topicRef: (output.topicRef != null) ? deserializeAws_restJson1EntityRef(output.topicRef, context) : undefined,
    };
};
const deserializeAws_restJson1MatterTopicList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterTopic(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterWorkflowActorOutput_MATTER_OWNER_INACTIVE_EVENT = (output, context) => {
    return {
        matterName: __expectString(output.matterName),
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
    };
};
const deserializeAws_restJson1MatterWorkflowActorOutput_REFRESH_EVENT = (output, context) => {
    return {
        matterName: __expectString(output.matterName),
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
        refreshDate: (output.refreshDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.refreshDate))) : undefined,
    };
};
const deserializeAws_restJson1MatterWorkflowExecutionCreationContext = (output, context) => {
    return {
        matterRef: (output.matterRef != null) ? deserializeAws_restJson1MatterRef(output.matterRef, context) : undefined,
        oldVersion: __expectString(output.oldVersion),
    };
};
const deserializeAws_restJson1OCUserOrGroupId = (output, context) => {
    if (__expectString(output.groupId) !== undefined) {
        return { groupId: __expectString(output.groupId) };
    }
    if (__expectString(output.userId) !== undefined) {
        return { userId: __expectString(output.userId) };
    }
    return { $unknown: Object.entries(output)[0] };
};
const deserializeAws_restJson1QuestionAccessMap = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = deserializeAws_restJson1AccessRecordList(value, context);
        return acc;
    }, {});
};
const deserializeAws_restJson1QuestionAssignment = (output, context) => {
    return {
        assignee: (output.assignee != null) ? deserializeAws_restJson1IdentityRef(output.assignee, context) : undefined,
        questionKey: __expectString(output.questionKey),
    };
};
const deserializeAws_restJson1QuestionAssignmentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionAssignment(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1QuestionDownloadUrl = (output, context) => {
    return {
        answerDownloadUrl: __expectString(output.answerDownloadUrl),
        error: __expectString(output.error),
        questionKey: __expectString(output.questionKey),
        titleDownloadUrl: __expectString(output.titleDownloadUrl),
    };
};
const deserializeAws_restJson1QuestionDownloadUrls = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionDownloadUrl(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1QuestionLegalNote = (output, context) => {
    return {
        lastUpdatedBy: (output.lastUpdatedBy != null) ? deserializeAws_restJson1IdentityRef(output.lastUpdatedBy, context) : undefined,
        lastUpdatedTimestamp: (output.lastUpdatedTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastUpdatedTimestamp))) : undefined,
        questionKey: __expectString(output.questionKey),
    };
};
const deserializeAws_restJson1QuestionLegalNoteList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionLegalNote(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterTemplate = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        description: __expectString(output.description),
        matterContent: (output.matterContent != null) ? deserializeAws_restJson1MatterTemplateMatterContentBody(output.matterContent, context) : undefined,
        name: __expectString(output.name),
        ref: (output.ref != null) ? deserializeAws_restJson1MatterTemplateRef(output.ref, context) : undefined,
    };
};
const deserializeAws_restJson1MatterTemplateMatterContentBody = (output, context) => {
    return {
        backgroundDownloadUrl: __expectString(output.backgroundDownloadUrl),
        locations: (output.locations != null) ? deserializeAws_restJson1MatterLocationList(output.locations, context) : undefined,
        name: __expectString(output.name),
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
        questionListRef: (output.questionListRef != null) ? deserializeAws_restJson1EntityVersionRef(output.questionListRef, context) : undefined,
        questions: (output.questions != null) ? deserializeAws_restJson1MatterQuestions(output.questions, context) : undefined,
        topics: (output.topics != null) ? deserializeAws_restJson1MatterTopicList(output.topics, context) : undefined,
    };
};
const deserializeAws_restJson1MatterTemplateRef = (output, context) => {
    return {
        id: __expectString(output.id),
        instanceId: __expectString(output.instanceId),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1MatterTemplateSearchItem = (output, context) => {
    return {
        createdBy: (output.createdBy != null) ? deserializeAws_restJson1IdentityRef(output.createdBy, context) : undefined,
        createdDate: (output.createdDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.createdDate))) : undefined,
        description: __expectString(output.description),
        id: __expectString(output.id),
        instanceId: __expectString(output.instanceId),
        matterContent: (output.matterContent != null) ? deserializeAws_restJson1MatterTemplateSearchItemMatterContent(output.matterContent, context) : undefined,
        name: __expectString(output.name),
        updatedBy: (output.updatedBy != null) ? deserializeAws_restJson1IdentityRef(output.updatedBy, context) : undefined,
        updatedDate: (output.updatedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.updatedDate))) : undefined,
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1MatterTemplateSearchItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1MatterTemplateSearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1MatterTemplateSearchItemMatterContent = (output, context) => {
    return {
        name: __expectString(output.name),
        owner: (output.owner != null) ? deserializeAws_restJson1IdentityRef(output.owner, context) : undefined,
    };
};
const deserializeAws_restJson1OCFirmGroup = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        desc: __expectString(output.desc),
        memberRefs: (output.memberRefs != null) ? deserializeAws_restJson1FlatEntityExtraRefList(output.memberRefs, context) : undefined,
        name: __expectString(output.name),
    };
};
const deserializeAws_restJson1OCFirmGroupDocument = (output, context) => {
    return {
        data: (output.data != null) ? deserializeAws_restJson1OCFirmGroupEntityExtra(output.data, context) : undefined,
        docRef: (output.docRef != null) ? deserializeAws_restJson1DocumentRef(output.docRef, context) : undefined,
    };
};
const deserializeAws_restJson1OCFirmGroupDocumentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OCFirmGroupDocument(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1OCFirmGroupEntityExtra = (output, context) => {
    return {
        entityExtraInfo: (output.entityExtraInfo != null) ? deserializeAws_restJson1FlatEntityExtraInfo(output.entityExtraInfo, context) : undefined,
        payload: (output.payload != null) ? deserializeAws_restJson1OCFirmGroup(output.payload, context) : undefined,
    };
};
const deserializeAws_restJson1OCFirmGroupEntityExtraList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OCFirmGroupEntityExtra(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1OCFirmInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        firmIdInOCCentral: __expectString(output.firmIdInOCCentral),
        instanceId: __expectString(output.instanceId),
        name: __expectString(output.name),
        ocFirmId: __expectString(output.ocFirmId),
        realm: __expectString(output.realm),
    };
};
const deserializeAws_restJson1OCFirmInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OCFirmInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1OCFirmRef = (output, context) => {
    return {
        firmId: __expectString(output.firmId),
        instanceId: __expectString(output.instanceId),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1OCUserInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        deletionInfo: (output.deletionInfo != null) ? deserializeAws_restJson1DeletionInfo(output.deletionInfo, context) : undefined,
        email: __expectString(output.email),
        entityExtraVersionRef: (output.entityExtraVersionRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.entityExtraVersionRef, context) : undefined,
        firstName: __expectString(output.firstName),
        instanceId: __expectString(output.instanceId),
        lastName: __expectString(output.lastName),
        ocFirmId: __expectString(output.ocFirmId),
        ocIdInOCCentral: __expectString(output.ocIdInOCCentral),
        ocUserId: __expectString(output.ocUserId),
        ref: (output.ref != null) ? deserializeAws_restJson1OCUserRef(output.ref, context) : undefined,
    };
};
const deserializeAws_restJson1OCUserInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OCUserInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1OCUserRef = (output, context) => {
    return {
        firmRef: (output.firmRef != null) ? deserializeAws_restJson1OCFirmRef(output.firmRef, context) : undefined,
        userId: __expectString(output.userId),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1QuestionLabel = (output, context) => {
    return {
        labelRef: (output.labelRef != null) ? deserializeAws_restJson1EntityRef(output.labelRef, context) : undefined,
    };
};
const deserializeAws_restJson1QuestionLabelList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionLabel(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1QuestionLabelMap = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = deserializeAws_restJson1QuestionLabelList(value, context);
        return acc;
    }, {});
};
const deserializeAws_restJson1QuestionList2 = (output, context) => {
    return {
        __do_not_delete: __expectString(output.__do_not_delete),
        deprecated: __expectBoolean(output.deprecated),
        id: __expectString(output.id),
        instanceId: __expectString(output.instanceId),
        name: __expectString(output.name),
        ocFirmAccessList: (output.ocFirmAccessList != null) ? deserializeAws_restJson1StringList(output.ocFirmAccessList, context) : undefined,
        questionLabelMap: (output.questionLabelMap != null) ? deserializeAws_restJson1QuestionLabelMap(output.questionLabelMap, context) : undefined,
        questions: (output.questions != null) ? deserializeAws_restJson1QuestionList2Questions(output.questions, context) : undefined,
        restrictedToOC: __expectBoolean(output.restrictedToOC),
        version: __expectString(output.version),
    };
};
const deserializeAws_restJson1QuestionList2Question = (output, context) => {
    return {
        defaultAnswerDownloadUrl: __expectString(output.defaultAnswerDownloadUrl),
        key: __expectString(output.key),
        titleDownloadUrl: __expectString(output.titleDownloadUrl),
    };
};
const deserializeAws_restJson1QuestionList2Questions = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionList2Question(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1QuestionList2SearchItem = (output, context) => {
    return {
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        deprecated: __expectBoolean(output.deprecated),
        documentId: __expectString(output.documentId),
        instanceId: __expectString(output.instanceId),
        labels: (output.labels != null) ? deserializeAws_restJson1QuestionLabelList(output.labels, context) : undefined,
        lastModfiedDate: (output.lastModfiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModfiedDate))) : undefined,
        name: __expectString(output.name),
        ocFirmAccessList: (output.ocFirmAccessList != null) ? deserializeAws_restJson1StringList(output.ocFirmAccessList, context) : undefined,
        questionListId: __expectString(output.questionListId),
        restrictedToOC: __expectBoolean(output.restrictedToOC),
    };
};
const deserializeAws_restJson1QuestionList2SearchItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionList2SearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1ALMProductContact = (output, context) => {
    return {
        alias: __expectString(output.alias),
        contactType: __expectString(output.contactType),
    };
};
const deserializeAws_restJson1ALMProductContactList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ALMProductContact(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1ItemContributor = (output, context) => {
    return {
        role: __expectString(output.role),
        user: (output.user != null) ? deserializeAws_restJson1IdentityRef(output.user, context) : undefined,
    };
};
const deserializeAws_restJson1ItemContributorList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ItemContributor(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PrivacyData = (output, context) => {
    return {
        attachmentDPIARef: (output.attachmentDPIARef != null) ? deserializeAws_restJson1RapiniAttachment(output.attachmentDPIARef, context) : undefined,
        attachmentROPARef: (output.attachmentROPARef != null) ? deserializeAws_restJson1RapiniAttachment(output.attachmentROPARef, context) : undefined,
        dpiaDocumentRequired: __expectBoolean(output.dpiaDocumentRequired),
        dsarsRequired: __expectBoolean(output.dsarsRequired),
        processCustomerContent: __expectBoolean(output.processCustomerContent),
        processPersonalData: __expectBoolean(output.processPersonalData),
        processPrivacyData: __expectBoolean(output.processPrivacyData),
        ropaDocumentRequired: __expectBoolean(output.ropaDocumentRequired),
    };
};
const deserializeAws_restJson1QuestionnaireResponses = (output, context) => {
    return {
        questionnaireId: __expectString(output.questionnaireId),
        questionnaireVersion: __expectInt32(output.questionnaireVersion),
        responseList: (output.responseList != null) ? deserializeAws_restJson1QuestionResponseList(output.responseList, context) : undefined,
    };
};
const deserializeAws_restJson1QuestionResponse = (output, context) => {
    return {
        nodeKey: __expectString(output.nodeKey),
        response: __expectString(output.response),
    };
};
const deserializeAws_restJson1QuestionResponseList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1QuestionResponse(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1RapiniAnswerOption = (output, context) => {
    return {
        answerContent: __expectString(output.answerContent),
        answerKey: __expectString(output.answerKey),
        followUpQuestionNodeIds: (output.followUpQuestionNodeIds != null) ? deserializeAws_restJson1TypicalIdList(output.followUpQuestionNodeIds, context) : undefined,
    };
};
const deserializeAws_restJson1RapiniAnswerOptionList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RapiniAnswerOption(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1RapiniAttachment = (output, context) => {
    return {
        attachmentRef: (output.attachmentRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.attachmentRef, context) : undefined,
        attachmentType: __expectString(output.attachmentType),
        fileName: __expectString(output.fileName),
    };
};
const deserializeAws_restJson1RapiniEvent = (output, context) => {
    return {
        eventData: (output.eventData != null) ? deserializeAws_restJson1RapiniEventData(output.eventData, context) : undefined,
        eventTimestamp: (output.eventTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.eventTimestamp))) : undefined,
        eventType: __expectString(output.eventType),
    };
};
const deserializeAws_restJson1RapiniEventData = (output, context) => {
    return {
        rapiniItemRef: (output.rapiniItemRef != null) ? deserializeAws_restJson1EntityRef(output.rapiniItemRef, context) : undefined,
        rapiniItemReviewRef: (output.rapiniItemReviewRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.rapiniItemReviewRef, context) : undefined,
        rapiniItemReviewTaskRef: (output.rapiniItemReviewTaskRef != null) ? deserializeAws_restJson1EntityExtraVersionRef(output.rapiniItemReviewTaskRef, context) : undefined,
    };
};
const deserializeAws_restJson1RapiniItemInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        _do_not_delete2: (output._do_not_delete2 != null) ? deserializeAws_restJson1RapiniEvent(output._do_not_delete2, context) : undefined,
        additionalContributors: (output.additionalContributors != null) ? deserializeAws_restJson1ItemContributorList(output.additionalContributors, context) : undefined,
        awsPrivacyLawyer: (output.awsPrivacyLawyer != null) ? deserializeAws_restJson1IdentityRef(output.awsPrivacyLawyer, context) : undefined,
        businessLineLawyer: (output.businessLineLawyer != null) ? deserializeAws_restJson1IdentityRef(output.businessLineLawyer, context) : undefined,
        documentationLink: __expectString(output.documentationLink),
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        productId: __expectString(output.productId),
        productManager: (output.productManager != null) ? deserializeAws_restJson1IdentityRef(output.productManager, context) : undefined,
    };
};
const deserializeAws_restJson1RapiniItemReviewInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        awsPrivacyLawyer: (output.awsPrivacyLawyer != null) ? deserializeAws_restJson1IdentityRef(output.awsPrivacyLawyer, context) : undefined,
        businessLineLawyer: (output.businessLineLawyer != null) ? deserializeAws_restJson1IdentityRef(output.businessLineLawyer, context) : undefined,
        closedTimestamp: (output.closedTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.closedTimestamp))) : undefined,
        entityExtraInfo: (output.entityExtraInfo != null) ? deserializeAws_restJson1EntityExtraInfo(output.entityExtraInfo, context) : undefined,
        openTimestamp: (output.openTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.openTimestamp))) : undefined,
        privacyData: (output.privacyData != null) ? deserializeAws_restJson1PrivacyData(output.privacyData, context) : undefined,
        productManager: (output.productManager != null) ? deserializeAws_restJson1IdentityRef(output.productManager, context) : undefined,
        questionnaireCompleted: __expectBoolean(output.questionnaireCompleted),
        questionnaireResponses: (output.questionnaireResponses != null) ? deserializeAws_restJson1QuestionnaireResponses(output.questionnaireResponses, context) : undefined,
        reviewId: __expectString(output.reviewId),
        status: __expectString(output.status),
    };
};
const deserializeAws_restJson1RapiniItemReviewSearchDocument = (output, context) => {
    return {
        awsPrivacyLawyer: (output.awsPrivacyLawyer != null) ? deserializeAws_restJson1IdentityRef(output.awsPrivacyLawyer, context) : undefined,
        businessLineLawyer: (output.businessLineLawyer != null) ? deserializeAws_restJson1IdentityRef(output.businessLineLawyer, context) : undefined,
        closedTimestamp: (output.closedTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.closedTimestamp))) : undefined,
        createdBy: (output.createdBy != null) ? deserializeAws_restJson1IdentityRef(output.createdBy, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        itemId: __expectString(output.itemId),
        lastModifiedBy: (output.lastModifiedBy != null) ? deserializeAws_restJson1IdentityRef(output.lastModifiedBy, context) : undefined,
        lastModifiedDate: (output.lastModifiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate))) : undefined,
        openTimestamp: (output.openTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.openTimestamp))) : undefined,
        productManager: (output.productManager != null) ? deserializeAws_restJson1IdentityRef(output.productManager, context) : undefined,
        questionnaireCompleted: __expectBoolean(output.questionnaireCompleted),
        reviewId: __expectString(output.reviewId),
        status: __expectString(output.status),
        version: __expectInt32(output.version),
    };
};
const deserializeAws_restJson1RapiniItemReviewSearchDocumentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RapiniItemReviewSearchDocument(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1RapiniItemReviewTaskInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        assignedBy: (output.assignedBy != null) ? deserializeAws_restJson1IdentityRef(output.assignedBy, context) : undefined,
        assignedTo: (output.assignedTo != null) ? deserializeAws_restJson1IdentityRef(output.assignedTo, context) : undefined,
        attachment: (output.attachment != null) ? deserializeAws_restJson1RapiniAttachment(output.attachment, context) : undefined,
        closedTimestamp: (output.closedTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.closedTimestamp))) : undefined,
        comments: (output.comments != null) ? deserializeAws_restJson1TaskCommentList(output.comments, context) : undefined,
        confirmedRequired: __expectBoolean(output.confirmedRequired),
        entityExtraInfo: (output.entityExtraInfo != null) ? deserializeAws_restJson1EntityExtraInfo(output.entityExtraInfo, context) : undefined,
        openTimestamp: (output.openTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.openTimestamp))) : undefined,
        optional: __expectBoolean(output.optional),
        questionNodeId: __expectString(output.questionNodeId),
        requiresConfirmation: __expectBoolean(output.requiresConfirmation),
        reviewId: __expectString(output.reviewId),
        status: __expectString(output.status),
        taskAction: __expectString(output.taskAction),
        taskId: __expectString(output.taskId),
        taskNote: __expectString(output.taskNote),
        taskRecipientType: __expectString(output.taskRecipientType),
        textResponse: __expectString(output.textResponse),
        type: __expectString(output.type),
    };
};
const deserializeAws_restJson1RapiniItemReviewTaskSearchDocument = (output, context) => {
    return {
        assignedBy: (output.assignedBy != null) ? deserializeAws_restJson1IdentityRef(output.assignedBy, context) : undefined,
        assignedTo: (output.assignedTo != null) ? deserializeAws_restJson1IdentityRef(output.assignedTo, context) : undefined,
        attachment: (output.attachment != null) ? deserializeAws_restJson1RapiniAttachment(output.attachment, context) : undefined,
        closedTimestamp: (output.closedTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.closedTimestamp))) : undefined,
        confirmedRequired: __expectBoolean(output.confirmedRequired),
        createdBy: (output.createdBy != null) ? deserializeAws_restJson1IdentityRef(output.createdBy, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        itemId: __expectString(output.itemId),
        lastModifiedBy: (output.lastModifiedBy != null) ? deserializeAws_restJson1IdentityRef(output.lastModifiedBy, context) : undefined,
        lastModifiedDate: (output.lastModifiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate))) : undefined,
        openTimestamp: (output.openTimestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.openTimestamp))) : undefined,
        optional: __expectBoolean(output.optional),
        questionNodeId: __expectString(output.questionNodeId),
        requiresConfirmation: __expectBoolean(output.requiresConfirmation),
        reviewId: __expectString(output.reviewId),
        status: __expectString(output.status),
        taskAction: __expectString(output.taskAction),
        taskId: __expectString(output.taskId),
        taskNote: __expectString(output.taskNote),
        taskRecipientType: __expectString(output.taskRecipientType),
        textResponse: __expectString(output.textResponse),
        type: __expectString(output.type),
        version: __expectInt32(output.version),
    };
};
const deserializeAws_restJson1RapiniItemReviewTaskSearchDocumentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RapiniItemReviewTaskSearchDocument(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1RapiniQuestionDownloadResult = (output, context) => {
    return {
        downloadUrl: __expectString(output.downloadUrl),
        questionNode: (output.questionNode != null) ? deserializeAws_restJson1RapiniQuestionNode(output.questionNode, context) : undefined,
        questionNodeId: __expectString(output.questionNodeId),
    };
};
const deserializeAws_restJson1RapiniQuestionDownloadResultList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RapiniQuestionDownloadResult(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1RapiniQuestionNode = (output, context) => {
    return {
        answerOptions: (output.answerOptions != null) ? deserializeAws_restJson1RapiniAnswerOptionList(output.answerOptions, context) : undefined,
        answerType: __expectString(output.answerType),
        content: __expectString(output.content),
        nodeId: __expectString(output.nodeId),
        payload: (output.payload != null) ? deserializeAws_restJson1RapiniQuestionPayload(output.payload, context) : undefined,
    };
};
const deserializeAws_restJson1RapiniQuestionPayload = (output, context) => {
    return {
        requiresConfirmation: __expectBoolean(output.requiresConfirmation),
        setsProcessCustomerContent: __expectBoolean(output.setsProcessCustomerContent),
        setsProcessPersonalData: __expectBoolean(output.setsProcessPersonalData),
        setsProcessPrivacyData: __expectBoolean(output.setsProcessPrivacyData),
        task: __expectBoolean(output.task),
        taskAction: __expectString(output.taskAction),
        taskNote: __expectString(output.taskNote),
        taskRecipient: __expectString(output.taskRecipient),
    };
};
const deserializeAws_restJson1RapiniQuestionTreeInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        questionNodeIdList: (output.questionNodeIdList != null) ? deserializeAws_restJson1TypicalIdList(output.questionNodeIdList, context) : undefined,
        rootNodeIds: (output.rootNodeIds != null) ? deserializeAws_restJson1TypicalIdList(output.rootNodeIds, context) : undefined,
    };
};
const deserializeAws_restJson1RapiniSearchItem = (output, context) => {
    return {
        additionalContributors: (output.additionalContributors != null) ? deserializeAws_restJson1ItemContributorList(output.additionalContributors, context) : undefined,
        audience: __expectString(output.audience),
        awsCategory: __expectString(output.awsCategory),
        awsPrivacyLawyer: (output.awsPrivacyLawyer != null) ? deserializeAws_restJson1IdentityRef(output.awsPrivacyLawyer, context) : undefined,
        businessLineLawyer: (output.businessLineLawyer != null) ? deserializeAws_restJson1IdentityRef(output.businessLineLawyer, context) : undefined,
        codeName: __expectString(output.codeName),
        confidential: __expectString(output.confidential),
        createdBy: (output.createdBy != null) ? deserializeAws_restJson1IdentityRef(output.createdBy, context) : undefined,
        creationDate: (output.creationDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.creationDate))) : undefined,
        description: __expectString(output.description),
        documentationLink: __expectString(output.documentationLink),
        gm: __expectString(output.gm),
        id: __expectString(output.id),
        lastModifiedBy: (output.lastModifiedBy != null) ? deserializeAws_restJson1IdentityRef(output.lastModifiedBy, context) : undefined,
        lastModifiedDate: (output.lastModifiedDate != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.lastModifiedDate))) : undefined,
        primaryOwner: (output.primaryOwner != null) ? deserializeAws_restJson1ALMProductContact(output.primaryOwner, context) : undefined,
        productId: __expectString(output.productId),
        productManager: (output.productManager != null) ? deserializeAws_restJson1IdentityRef(output.productManager, context) : undefined,
        productName: __expectString(output.productName),
        productType: __expectString(output.productType),
        secondaryOwners: (output.secondaryOwners != null) ? deserializeAws_restJson1ALMProductContactList(output.secondaryOwners, context) : undefined,
        version: __expectInt32(output.version),
        vp: __expectString(output.vp),
    };
};
const deserializeAws_restJson1RapiniSearchItemList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1RapiniSearchItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1TaskComment = (output, context) => {
    return {
        comment: __expectString(output.comment),
        commenter: (output.commenter != null) ? deserializeAws_restJson1IdentityRef(output.commenter, context) : undefined,
        timestamp: (output.timestamp != null) ? __expectNonNull(__parseEpochTimestamp(__expectNumber(output.timestamp))) : undefined,
    };
};
const deserializeAws_restJson1TaskCommentList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1TaskComment(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1Subtopic = (output, context) => {
    return {
        deleted: __expectBoolean(output.deleted),
        deprecated: __expectBoolean(output.deprecated),
        description: __expectString(output.description),
        key: __expectString(output.key),
        name: __expectString(output.name),
    };
};
const deserializeAws_restJson1SubtopicList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Subtopic(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1TopicInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        deprecated: __expectBoolean(output.deprecated),
        description: __expectString(output.description),
        entityInfo: (output.entityInfo != null) ? deserializeAws_restJson1EntityInfo(output.entityInfo, context) : undefined,
        name: __expectString(output.name),
        subtopics: (output.subtopics != null) ? deserializeAws_restJson1SubtopicList(output.subtopics, context) : undefined,
    };
};
const deserializeAws_restJson1TopicInfoList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1TopicInfo(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1UserActivityInfo = (output, context) => {
    return {
        _do_not_delete: __expectString(output._do_not_delete),
        creationInfo: (output.creationInfo != null) ? deserializeAws_restJson1CreationInfo(output.creationInfo, context) : undefined,
        module: __expectString(output.module),
        ref: (output.ref != null) ? deserializeAws_restJson1UserActivityRef(output.ref, context) : undefined,
        type: __expectString(output.type),
        url: __expectString(output.url),
        versionInfo: (output.versionInfo != null) ? deserializeAws_restJson1VersionInfo(output.versionInfo, context) : undefined,
    };
};
const deserializeAws_restJson1UserActivityRef = (output, context) => {
    return {
        instanceId: __expectString(output.instanceId),
        userActivityId: __expectString(output.userActivityId),
    };
};
const deserializeAws_restJson1Document = (output, context) => {
    return output;
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBody = (streamBody = new Uint8Array(), context) => {
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then(body => context.utf8Encoder(body));
const isSerializableHeaderValue = (value) => value !== undefined &&
    value !== null &&
    value !== "" &&
    (!Object.getOwnPropertyNames(value).includes("length") ||
        value.length != 0) &&
    (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const parseBody = (streamBody, context) => collectBodyString(streamBody, context).then(encoded => {
    if (encoded.length) {
        return JSON.parse(encoded);
    }
    return {};
});
const parseErrorBody = async (errorBody, context) => {
    const value = await parseBody(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const loadRestJsonErrorCode = (output, data) => {
    const findKey = (object, key) => Object.keys(object).find((k) => k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue) => {
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") {
            cleanValue = cleanValue.toString();
        }
        if (cleanValue.indexOf(",") >= 0) {
            cleanValue = cleanValue.split(",")[0];
        }
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
};
